export default {
  "brandSeo": {
    "pageTitle": "{title} con Miral AI",
    "toolDescription": "Su Miral AI, {description}",
    "sectionTitle": "{title} con Miral AI",
    "faqTitle": "{title} su Miral AI",
    "toolFreeTrialCta": "Prova gratis questo strumento su Miral AI",
    "toolProcessCta": "{action} gratis",
    "imageFaqs": [
      { "q": "Posso provare gratis la generazione di immagini su Miral?", "a": "Sì. Registrati su Miral AI per ricevere crediti gratuiti e provare la generazione. Ogni risultato usa comunque i crediti richiesti dal modello scelto." },
      { "q": "Perché creare immagini con Miral AI?", "a": "Miral AI riunisce i principali modelli di immagini in un solo luogo per confrontare le funzioni e creare senza cambiare piattaforma." }
    ],
    "toolFaqs": [
      { "q": "Posso provare gratis questo strumento Miral AI?", "a": "Sì. Accedi a Miral AI per iniziare una prova gratuita. L’accesso dipende dai limiti dell’account e non indica un utilizzo gratuito illimitato." },
      { "q": "Perché usare gli strumenti creativi di Miral AI?", "a": "Miral AI combina generazione di immagini e strumenti pratici di editing per creare, elaborare e scaricare risultati in un unico flusso." }
    ]
  },
  "common": {
    "loading": "Caricamento...",
    "error": "Si è verificato un errore",
    "success": "Operazione riuscita",
    "confirm": "OK",
    "prev": "Precedente",
    "next": "Successivo",
    "optional": "Opzionale",
    "remove": "Rimuovi",
    "generate": "Genera",
    "generating": "Generazione...",
    "required": "Obbligatorio",
    "generateFailedContactSupport": "Generazione non riuscita. Riprova o contatta il supporto!",
    "localMediaTransferFailed": "Instabilità di rete: trasferimento o interazione con il servizio interrotti. Generazione sospesa. Riprova a generare o contatta l’assistenza.",
    "errorDetails": "Dettagli dell'errore",
    "tryAgainOrContactSupportTail": " Si prega di riprovare o contattare il supporto!",
    "errorCategoryImageSizeInvalid": "La dimensione dell'immagine non soddisfa i requisiti. Si prega di utilizzare un'immagine valida",
    "errorCategoryOutputEmptyOrSensitive": "L'output è stato bloccato dalle regole di sicurezza o non è stato generato alcun risultato. Si prega di modificare la richiesta/l'immagine di riferimento",
    "errorCategoryUpstreamBusy": "Il servizio è occupato ora (carico upstream saturo)",
    "errorCategoryAiNetworkError": "Connessione di rete anomala. Verifica la rete e riprova",
    "errorCategoryAiTimeout": "La richiesta AI è scaduta. La rete potrebbe essere instabile, riprova tra poco",
    "close": "Close",
    "leaveConfirmTitle": "Friendly Reminder",
    "leaveConfirmMessage": "Your AI work is still being generated. Switching pages will not affect progress. You can check processing or completed works in [My - My Works].\nAre you sure you want to leave?",
    "leaveConfirmConfirm": "Leave Page",
    "leaveConfirmCancel": "Stay Here"
  },
  "api": {
    "errors": {
      "requestFailed": "Richiesta fallita",
      "badRequest": "Richiesta non valida",
      "unauthorized": "Non autorizzato, accedi di nuovo",
      "forbidden": "Vietato",
      "notFound": "Risorsa non trovata",
      "serverError": "Errore interno del server",
      "timeout": "Timeout della richiesta, riprova",
      "networkError": "Errore di rete, controlla la connessione",
      "sessionExpired": "Sessione scaduta, accedi di nuovo",
      "operationFailed": "Operazione fallita!"
    }
  },
  "nav": {
    "home": "Home",
    "models": "Modelli AI",
    "pricing": "Prezzi",
    "faq": "FAQ",
    "login": "Accedi",
    "signup": "Aggiorna",
    "register": "Registrati",
    "email": "Email",
    "logout": "Esci",
    "help": "Aiuto",
    "profile": "Profilo",
    "myWorks": "I miei lavori",
    "username": "Nome utente",
    "password": "Password",
    "confirmPassword": "Conferma password",
    "processing": "Elaborazione...",
    "haveAccount": "Hai già un account?",
    "noAccount": "Non hai un account?",
    "orContinueWith": "Oppure continua con",
    "loginFailed": "Accesso fallito, riprova",
    "registerFailed": "Registrazione fallita, riprova",
    "fillRequired": "Compila tutti i campi obbligatori",
    "passwordMismatch": "Le password non corrispondono",
    "passwordTooShort": "La password deve essere di almeno 6 caratteri",
    "googleNotLoaded": "Servizio di accesso Google non caricato, aggiorna la pagina",
    "googleInitFailed": "Inizializzazione accesso Google fallita",
    "googleUserInfoFailed": "Impossibile ottenere le informazioni utente",
    "googleCancelled": "Accesso Google annullato",
    "codeLoginHint": "Inserisci la tua email, invieremo un codice di verifica",
    "verificationCode": "Codice di verifica",
    "sendCode": "Invia codice",
    "resendCode": "Invia di nuovo",
    "verifyAndLogin": "Verifica e accedi",
    "enterEmail": "Inserisci il tuo indirizzo email",
    "invalidEmail": "Inserisci un indirizzo email valido",
    "sendCodeFailed": "Invio del codice di verifica fallito, riprova",
    "checkSpamFolder": "Non trovi l'email? Controlla la cartella spam/posta indesiderata",
    "enterValidCode": "Inserisci il codice di verifica a 6 cifre",
    "verifyCodeFailed": "Codice di verifica non valido o scaduto",
    "googleLoginFailed": "Accesso Google fallito, riprova",
    "registerHint": "Registrandoti, accetti i nostri",
    "and": "e",
    "freeCreditsLabel": "Crediti gratuiti:",
    "freeCreditsDesc": "Ottieni crediti gratuiti semplicemente accedendo — nessun pagamento richiesto!",
    "sidebar": {
      "navigation": "Navigazione",
      "home": "Home",
      "inspiration": "Ispirazione",
      "allModels": "Tutti i modelli AI",
      "videoAI": "Video AI",
      "videoGenerator": "Generatore video",
      "newModels": "Nuovi modelli",
      "otherModels": "Altri modelli",
      "videoEnhance": "Migliora video",
      "musicAI": "Musica AI",
      "musicGenerator": "Musica AI",
      "imageAI": "Immagine AI",
      "imageGenerator": "Generatore immagini",
      "hotModels": "Modelli popolari",
      "hotTools": "Strumenti popolari",
      "history": "Cronologia",
      "upgrade": "Aggiorna"
    }
  },
  "footer": {
    "brand": "Miral",
    "siteTitle": "Miral - Piattaforma di creazione di immagini, video e musica AI",
    "desc": "Una piattaforma AI completa per la creazione di immagini, video e musica.",
    "fluxModels": "Modelli FLUX",
    "aiImages": "Immagini AI",
    "aiVideos": "Video AI",
    "aiMusic": "Musica AI",
    "product": "Prodotto",
    "videoModels": "Modelli video IA",
    "imageModels": "Modelli immagine IA",
    "musicModels": "Modelli musica IA",
    "apps": "App",
    "company": "Azienda",
    "about": "Chi siamo",
    "contact": "Contattaci",
    "blog": "Blog",
    "tools": "Strumenti",
    "resources": "Risorse",
    "allModels": "Tutti i modelli AI",
    "pricing": "Prezzi",
    "trustSafety": "Fiducia e sicurezza",
    "terms": "Termini di servizio",
    "privacy": "Informativa sulla privacy",
    "faq": "FAQ",
    "musicGenerator": "Generatore di musica AI",
    "copyright": "© 2025 Miral. Tutti i diritti riservati.",
    "langZh": "简体中文",
    "langEn": "English",
    "langIt": "Italiano"
  },
  "about": {
    "tag": "About Miral",
    "title": "About Us",
    "subtitle": "Create images, videos, and music with leading AI models in one place.",
    "paragraphs": [
      "Miral is an AI creation platform for creators, designers, and businesses. Generate images and videos, compose AI music, and use practical tools such as watermark removal and document cleanup.",
      "We continuously integrate leading models and reliable channels so you can go from idea to finished content in the browser.",
      "Learn more about our data practices on Trust & Safety, or contact support when you need help."
    ]
  },
  "contact": {
    "tag": "Support",
    "title": "Contact Us",
    "subtitle": "We will get back to your questions and feedback as soon as we can.",
    "emailLabel": "Support email",
    "hint": "Email us about billing, credits, or generation issues. We usually reply on business days.",
    "cta": "Send Email"
  },
  "models": {
    "image": {
      "nano-banana": {
        "name": "Nano Banana Pro",
        "desc": "Realismo cinematografico con dettagli naturali di pelle, texture e illuminazione"
      },
      "nano-banana-31": {
        "name": "Nano Banana 3.1",
        "desc": "Generazione di immagini multi-risoluzione, modalità v2.5 e v3.1"
      },
      "seedream-4": {
        "name": "Seedream 4",
        "desc": "Stile artistico"
      },
      "seedream-5": {
        "name": "Seedream 5",
        "desc": "Stile artistico"
      },
      "midjourney": {
        "name": "Midjourney",
        "desc": "Stile artistico"
      },
      "gpt-image-1": {
        "name": "GPT-Image-1",
        "desc": "Multiuso"
      },
      "gpt-image-1-5": {
        "name": "GPT-Image-1-5",
        "desc": "Multiuso"
      },
      "flux-pro-1-1-ultra": {
        "name": "Flux Pro 1.1 Ultra",
        "desc": "Testo-immagine di alta qualità"
      },
      "flux-schnell": {
        "name": "Flux Schnell",
        "desc": "Testo-immagine veloce"
      },
      "flux-2": {
        "name": "FLUX.2",
        "desc": "Testo-immagine di nuova generazione"
      },
      "flux-kontext": {
        "name": "Flux Kontext",
        "desc": "Testo-immagine di alta qualità e modifica"
      },
      "qwen-image-2-0-pro": {
        "name": "Qwen Image 2.0 Pro",
        "desc": "Generazione testo-immagine ad alta risoluzione con dettagli fini"
      },
      "z-image-turbo": {
        "name": "Z Image Turbo",
        "desc": "Generazione testo-immagine ad alta risoluzione"
      },
      "sd-3-5": {
        "name": "Stable Diffusion 3.5",
        "desc": "Generazione testo-immagine con Stable Diffusion 3.5"
      }
    },
    "video": {
      "pollodance": {
        "name": "Pollo Dance",
        "desc": "Controllo movimento, riferimenti e stile cinematografico"
      },
      "seegen": {
        "name": "SeeGen",
        "desc": "Testo e immagine in video, multirisoluzione"
      },
      "seedance": {
        "name": "Seedance AI",
        "desc": "Sincronizzazione audio-video nativa"
      },
      "wan-2-5": {
        "name": "Wan 2.5",
        "desc": "Stile animazione"
      },
      "wan-2-6": {
        "name": "Wan 2.6",
        "desc": "Qualità migliorata"
      },
      "veo-3-1": {
        "name": "Veo 3.1",
        "desc": "Riferimento multi-immagine"
      },
      "veo-3-1-fast": {
        "name": "Veo 3.1 Fast",
        "desc": "Veloce, supporta frame finale"
      },
      "kling-2-6": {
        "name": "Kling 2.6",
        "desc": "Sincronizzazione labiale"
      },
      "kling-3": {
        "name": "Kling 3",
        "desc": "Sincronizzazione labiale"
      },
      "sora-2": {
        "name": "Sora 2",
        "desc": "4 s / 8 s / 12 s"
      },
      "kling-2-5": {
        "name": "Kling 2.5",
        "desc": "Standard"
      },
      "wan-2-2": {
        "name": "Wan 2.2",
        "desc": "Classico"
      },
      "vidu-q3-pro": {
        "name": "Vidu Q3 Pro",
        "desc": "Testo/immagine a video, multi-risoluzione"
      },
      "veo-3-0": {
        "name": "Veo 3.0",
        "desc": "Testo/Immagine a video"
      },
      "hailuo-2-3": {
        "name": "Hailuo 2.3",
        "desc": "Video creativo"
      },
      "runway": {
        "name": "Runway",
        "desc": "Workbench"
      },
      "wan-animate": {
        "name": "Wan Animate",
        "desc": "Immagine e video di riferimento per animare il personaggio. Qualità standard/pro, filigrana opzionale."
      }
    }
  },
  "tools": {
    "demoTitle": "Demo",
    "page": {
      "tag": "Cassetta degli attrezzi AI",
      "title": "Cassetta degli attrezzi AI professionale",
      "subtitle": "Rimozione watermark, ripristino foto, upscaling HD, miglioramento video e altri strumenti professionali per tutte le tue esigenze di post-produzione.",
      "allTools": "Tutti gli strumenti"
    },
    "detail": {
      "useNow": "Usa ora",
      "clickUpload": "Clicca o trascina per caricare",
      "support": "Supporta",
      "reupload": "Ricarica",
      "scale": "Scala",
      "process": "Elabora",
      "processing": "Elaborazione...",
      "before": "Prima",
      "after": "Dopo",
      "download": "Scarica risultato",
      "processNew": "Elabora nuovo file",
      "howToUse": "Come usare",
      "moreTools": "Altri strumenti",
      "notFound": "Strumento non trovato",
      "backToList": "Torna agli strumenti",
      "loginRequired": "Accesso richiesto",
      "loginRequiredDesc": "Accedi per utilizzare questo strumento",
      "loginNow": "Accedi ora",
      "demo": "Demo",
      "uploadOriginalFailed": "Caricamento dell'immagine originale non riuscito, riprova"
    },
    "steps": {
      "upload": {
        "title": "Carica file",
        "desc": "Seleziona o trascina il file immagine o video che desideri elaborare."
      },
      "adjust": {
        "title": "Regola impostazioni",
        "desc": "Configura i parametri di elaborazione come fattore di scala e formato di output."
      },
      "process": {
        "title": "Elabora con un clic",
        "desc": "L'AI elabora automaticamente, solitamente completato in pochi secondi o minuti."
      },
      "download": {
        "title": "Scarica risultato",
        "desc": "Anteprima il risultato e scarica l'output di alta qualità."
      }
    },
    "fileTypes": {
      "image": "Immagine",
      "video": "Video"
    },
    "imageEnhancer": {
      "name": "Miglioratore immagine",
      "desc": "Upscale immagini alla risoluzione 4K con dettagli migliorati",
      "fullDesc": "Upscale immagini alla risoluzione 4K con dettagli migliorati. Utilizza algoritmi AI avanzati per migliorare i dettagli, rendendo le immagini sfocate nitide e chiare."
    },
    "watermark-remover": {
      "name": "Rimuovi watermark",
      "desc": "Rimuovi i watermark dalle immagini con IA in un clic",
      "fullDesc": "Rimozione watermark AI preservando la qualità dell'immagine. Supporta l'elaborazione in batch, rilevamento automatico del watermark e rimozione precisa senza danneggiare l'immagine originale.",
      "audienceLabels": ["Venditori e-commerce", "Team marketing", "Designer e creator", "Negozi di moda e abbigliamento"],
      "audienceCases": [
        { "title": "Prepara i visual di prodotto 3 volte più velocemente", "desc": "Prima di creare immagini professionali per le schede prodotto, pulisci foto, immagini dei fornitori o bozze che sei autorizzato a usare. Rimuovi i segni di disturbo per concentrare l'attenzione sul prodotto." },
        { "title": "Riduci del 60% la pulizia manuale e crea campagne più rapidamente", "desc": "Prima di trasformare visual di proprietà o concessi in licenza in annunci, banner e grafiche del brand, rimuovi i watermark indesiderati. Le risorse pulite possono essere usate più rapidamente per campagne, lanci e poster di prodotto." },
        { "title": "Trasforma più rapidamente immagini pulite in nuovi concept", "desc": "Esplora nuove direzioni di design partendo da immagini sorgente pulite, senza ricostruire tutto da zero. Usa le bozze senza watermark come riferimento per schizzi IA, concept art o visual in stile poster." },
        { "title": "Rinnova il catalogo senza nuovi servizi fotografici", "desc": "Prima di preparare cataloghi, lanci stagionali o immagini per prove virtuali IA, pulisci le foto di abbigliamento autorizzate per valorizzare vestibilità, tessuto e dettagli del prodotto." }
      ],
      "fileTooLarge": "L'immagine è troppo grande. Usa un file sotto 15MB (JPG, PNG o WebP).",
      "notImageFile": "Carica un file immagine.",
      "noImageInResponse": "Nessuna immagine risultato restituita. Riprova più tardi.",
      "downloadName": "watermark-rimoso.png",
      "aiRepair": "Rimozione filigrana",
      "uploadLabel": "Carica immagine",
      "uploadHint": "Supporta immagini JPG, PNG o WebP fino a 15 MB.",
      "featuresKicker": "Veloce e preciso",
      "featuresTitle": "Rimuovi diverse filigrane dalle foto online",
      "featuresIntro": "Carica un'immagine JPG, PNG o WebP e lascia che l'intelligenza artificiale rilevi le aree della filigrana e ricostruisca lo sfondo senza spazzolare manualmente.",
      "features": [
        {
          "title": "Cancella filigrane a immagine intera",
          "desc": "Rimuovi testo traslucido ripetuto o filigrane di motivi che coprono l'intera immagine per un risultato più pulito.",
          "cta": "Prova AI Watermark Remover gratuitamente"
        },
        {
          "title": "Rimuovi timestamp e contrassegni di data",
          "desc": "Elimina date, timestamp e segni della fotocamera dagli angoli delle foto mentre ricostruisci lo sfondo dietro di essi.",
          "cta": "Cancella filigrane di immagini online"
        },
        {
          "title": "Cancella i loghi del marchio",
          "desc": "Rimuovi i loghi del marchio, i badge sugli angoli e i marchi promozionali dalle immagini che sei autorizzato a modificare.",
          "cta": "Rimuovi subito le filigrane dalle foto"
        },
        {
          "title": "Pulisci testo e segni di bozza",
          "desc": "Rimuovi le sovrapposizioni di testo da anteprime, bozze di progettazione e foto per creare contenuti visivi più puliti.",
          "cta": "Prova subito il dispositivo per la rimozione della filigrana"
        }
      ],
      "useCasesKicker": "Casi d'uso",
      "useCasesTitle": "Cosa può pulire il dispositivo di rimozione filigrana immagine AI?",
      "useCases": [
        {
          "title": "Rimozione della filigrana per le foto dei prodotti",
          "desc": "Pulisci testo, loghi e marchi promozionali dalle foto dei prodotti prima di inoltrare le tue risorse."
        },
        {
          "title": "Rimozione filigrana per foto social",
          "desc": "Rimuovi i contrassegni di piattaforma o i timestamp dalle tue foto per una versione di pubblicazione più pulita."
        },
        {
          "title": "Pulisci più filigrane",
          "desc": "Quando un'immagine contiene diverse filigrane, l'intelligenza artificiale può rilevare e pulire più aree coperte."
        }
      ],
      "howToKicker": "Tre semplici passaggi",
      "howToTitle": "Come rimuovere filigrane dalle immagini online gratuitamente",
      "howToIntro": "Non è necessaria alcuna installazione di software. Carica un'immagine, esegui il dispositivo di rimozione filigrana AI e scarica il risultato pulito.",
      "howToCta": "Rimuovi filigrane online adesso",
      "steps": {
        "upload": {
          "title": "Carica un'immagine con filigrana",
          "desc": "Scegli un'immagine JPG, PNG o WebP inferiore a 15 MB. Assicurati di avere il diritto di modificarlo e utilizzarlo."
        },
        "remove": {
          "title": "Rimuovi la filigrana con l'intelligenza artificiale",
          "desc": "Avvia l'elaborazione e l'intelligenza artificiale rileverà loghi, testo, timestamp o filigrane dell'immagine intera e ricostruirà lo sfondo."
        },
        "download": {
          "title": "Anteprima e download",
          "desc": "Confronta i risultati prima e dopo, quindi scarica l'immagine pulita o caricane un'altra."
        }
      },
      "faqTitle": "Domande frequenti sulla rimozione filigrana AI",
      "faqs": [
        {
          "q": "Cos'è un dispositivo per la rimozione della filigrana AI?",
          "a": "Un dispositivo di rimozione filigrana AI rileva le aree della filigrana e ricostruisce gli sfondi coperti utilizzando colori, trame e contenuti dell'immagine vicini."
        },
        {
          "q": "Come rimuovere gratuitamente la filigrana dalle foto online?",
          "a": "Iscriviti, carica un'immagine sul dispositivo di rimozione filigrana Miral AI e avvia l'elaborazione per visualizzare in anteprima il risultato pulito."
        },
        {
          "q": "Quali formati di immagine sono supportati?",
          "a": "Lo strumento attualmente supporta immagini JPG, PNG e WebP inferiori a 15 MB. Questa pagina non rimuove le filigrane dai video."
        },
        {
          "q": "Può rimuovere filigrane, loghi e timestamp dell'intera immagine?",
          "a": "Sì. L'intelligenza artificiale è in grado di elaborare filigrane ripetute a immagine intera, loghi di marchi, datari, testo e bozze. I risultati dipendono dall'opacità, dall'area coperta e dalla complessità dello sfondo."
        },
        {
          "q": "Quale strumento posso utilizzare per rimuovere più loghi o timestamp da una foto?",
          "a": "Il dispositivo di rimozione filigrana Miral AI può elaborare più aree di filigrana, inclusi loghi e timestamp. Controlla l'anteprima quando i segni grandi coprono persone o trame complesse."
        },
        {
          "q": "Rimuovere la filigrana da un'immagine è legale?",
          "a": "Elabora solo le immagini che possiedi, che sei autorizzato a modificare o che puoi utilizzare legalmente. La rimozione di filigrane protette da copyright senza autorizzazione può violare i diritti del proprietario."
        },
        {
          "q": "Come correggere le aree sfocate dopo aver rimosso una filigrana?",
          "a": "Inizia con l'immagine sorgente della massima qualità disponibile e controlla l'anteprima prima del download. L'intelligenza artificiale tenta di preservare la composizione, la risoluzione e i dettagli originali, ma il contenuto nascosto da filigrane di grandi dimensioni deve essere ricostruito, quindi i risultati locali potrebbero differire dall'originale."
        }
      ]
    },
    "full-watermark-remover": {
      "name": "Rimozione watermark IA",
      "desc": "Rimuovi watermark dalle immagini con IA",
      "fullDesc": "Usa l'IA per rilevare e rimuovere watermark dalle immagini preservando contenuto, dettagli e qualità visiva.",
      "notImageFile": "Carica un file immagine valido.",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB.",
      "downloadName": "watermark-completo-rimosso.png"
    },
    "ai-text-remover": {
      "name": "Rimozione testo IA",
      "desc": "Rimuovi testo indesiderato dalle immagini con IA",
      "fullDesc": "Rimuovi testo indesiderato dalle immagini con IA preservando sfondo, texture e dettagli naturali.",
      "notImageFile": "Carica un file immagine valido.",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB.",
      "downloadName": "testo-rimosso.png"
    },
    "ai-logo-remover": {
      "name": "Rimozione logo IA",
      "desc": "Rimuovi loghi indesiderati dalle immagini con IA",
      "fullDesc": "Rimuovi loghi indesiderati dalle immagini con IA preservando sfondo, texture e dettagli naturali.",
      "notImageFile": "Carica un file immagine valido.",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB.",
      "downloadName": "logo-rimosso.png"
    },
    "ai-passersby-remover": {
      "name": "Rimozione passanti IA",
      "desc": "Rimuovi passanti dalle immagini con IA",
      "fullDesc": "Usa l'IA per rilevare e rimuovere passanti dalle immagini preservando soggetto, texture dello sfondo e dettagli naturali.",
      "notImageFile": "Carica un file immagine valido.",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB.",
      "downloadName": "passanti-rimossi.png"
    },
    "background-remover": {
      "name": "Rimuovi sfondo",
      "desc": "Rimuovi lo sfondo delle immagini con IA in un clic",
      "heroTitle": "Rimozione sfondo IA gratuita per PNG trasparenti",
      "fullDesc": "Carica un'immagine JPG, PNG o WebP e lascia che l'IA rilevi ritratti, prodotti e bordi. Mantieni dettagli come i capelli e scarica un PNG trasparente senza Photoshop.",
      "uploadLabel": "Carica un'immagine da scontornare",
      "uploadHint": "Fai clic o trascina qui un'immagine",
      "uploadSpec": "Supporta JPG, PNG o WebP fino a 15MB. Il risultato viene scaricato come PNG trasparente.",
      "processButton": "Rimuovi lo sfondo",
      "previewAlt": "Anteprima prima della rimozione sfondo IA",
      "demoBeforeAlt": "Ritratto prima della rimozione dello sfondo",
      "demoAfterAlt": "Ritratto dopo la rimozione dello sfondo con IA",
      "processingAlt": "L'IA sta rimuovendo lo sfondo dell'immagine",
      "processingLabel": "Scontorno in corso",
      "resultLabel": "Sfondo trasparente pronto",
      "resultBeforeAlt": "Immagine originale prima della rimozione sfondo",
      "resultAfterAlt": "PNG trasparente dopo la rimozione sfondo IA",
      "productBeforeAlt": "Foto prodotto prima della rimozione sfondo",
      "productAfterAlt": "Prodotto scontornato su sfondo trasparente",
      "featuresKicker": "Rilevamento preciso del soggetto",
      "featuresTitle": "Rimozione sfondo IA per ritratti e foto prodotto",
      "featuresIntro": "Dai bordi complessi dei ritratti alle immagini ecommerce, l'IA separa automaticamente soggetto e sfondo senza pennelli, tracciati o maschere.",
      "features": [
        { "title": "Rimuovi lo sfondo dai ritratti preservando i capelli", "desc": "Rileva persone, abiti e capelli sottili per profili, ritratti professionali, poster e grafiche social con uno scontorno più pulito.", "cta": "Rimuovi gratis lo sfondo ritratto" },
        { "title": "Scontorna foto prodotto in un clic", "desc": "Rimuovi tavoli, pareti e set fotografici per usare il prodotto trasparente in schede, sfondi bianchi e pubblicità.", "cta": "Rimuovi lo sfondo prodotto" },
        { "title": "Scarica un PNG trasparente", "desc": "Mantieni la trasparenza per inserire il soggetto in nuovi sfondi, banner, presentazioni, miniature e progetti grafici.", "cta": "Rendi trasparente lo sfondo" }
      ],
      "featureAlts": { "portraitBefore": "Ritratto prima dello scontorno", "portraitAfter": "Ritratto scontornato con capelli preservati", "productBefore": "Prodotto prima della rimozione sfondo", "productAfter": "Prodotto su sfondo trasparente", "ecommerceBefore": "Immagine ecommerce prima dello scontorno", "ecommerceAfter": "PNG trasparente per ecommerce" },
      "useCasesKicker": "Casi d'uso popolari",
      "useCasesTitle": "Quali immagini funzionano con lo scontorno IA?",
      "useCasesIntro": "Usalo per isolare rapidamente un soggetto o creare risorse trasparenti per lavori creativi e commerciali.",
      "useCases": [
        { "title": "Foto prodotto ecommerce", "desc": "Prepara prodotti trasparenti per cataloghi, negozi e campagne." },
        { "title": "Ritratti e foto profilo", "desc": "Elimina l'ambiente preservando capelli, vestiti e contorni." },
        { "title": "Grafiche social", "desc": "Inserisci persone o prodotti in copertine, post e miniature." },
        { "title": "Foto professionali e documenti", "desc": "Isola la persona e aggiungi poi il colore di fondo necessario." },
        { "title": "Loghi e risorse grafiche", "desc": "Rimuovi uno sfondo indesiderato prima del riutilizzo." },
        { "title": "Pubblicità e graphic design", "desc": "Crea PNG trasparenti flessibili senza scontorni manuali ripetitivi." }
      ],
      "howToKicker": "Tre semplici passaggi",
      "howToTitle": "Come rimuovere gratis lo sfondo di un'immagine online",
      "howToIntro": "Carica un'immagine, avvia lo scontorno automatico IA e scarica il PNG trasparente.",
      "steps": [
        { "title": "Carica un JPG, PNG o WebP", "desc": "Scegli un ritratto, prodotto o progetto nitido sotto i 15MB." },
        { "title": "Rimuovi lo sfondo con IA", "desc": "L'IA separa il soggetto mantenendo i bordi importanti." },
        { "title": "Anteprima e scarica il PNG", "desc": "Confronta il risultato e salva l'immagine trasparente." }
      ],
      "faqTitle": "Domande frequenti sulla rimozione sfondo IA",
      "faqs": [
        { "q": "Come rimuovere gratis lo sfondo di un'immagine online?", "a": "Carica un JPG, PNG o WebP e avvia il processo. L'IA rileva il soggetto e genera un PNG trasparente." },
        { "q": "L'IA preserva capelli e bordi sottili?", "a": "Lo strumento cerca di mantenere capelli, vestiti e piccoli dettagli. Un buon contrasto tra soggetto e sfondo migliora il risultato." },
        { "q": "Posso rimuovere lo sfondo da una foto prodotto?", "a": "Sì. I prodotti ben visibili sono ideali per creare risorse trasparenti per ecommerce e pubblicità." },
        { "q": "Quale formato ottengo dopo il processo?", "a": "Il risultato viene scaricato come PNG con trasparenza." },
        { "q": "Quali formati e dimensioni sono supportati?", "a": "Sono supportati JPG, PNG e WebP fino a 15MB." },
        { "q": "Devo installare Photoshop?", "a": "No. L'IA rimuove lo sfondo direttamente nel browser." }
      ],
      "fileTooLarge": "L'immagine è troppo grande. Usa un file sotto 15MB (JPG, PNG o WebP).",
      "notImageFile": "Carica un file immagine.",
      "noImageInResponse": "Nessuna immagine risultato restituita. Riprova più tardi.",
      "downloadName": "sfondo-rimosso.png"
    },
    "image-eraser": {
      "name": "Cancellatore immagini",
      "desc": "Cancella qualsiasi oggetto, persona o filigrana dalle immagini con l'IA",
      "fullDesc": "Cancellatore di immagini basato sull'IA. Passa il pennello su qualsiasi oggetto, persona, filigrana o testo indesiderato nella tua foto e l'IA lo rimuoverà senza soluzione di continuità, riempiendo l'area con contenuti naturali. Perfetto per pulire le foto e rimuovere distrazioni.",
      "fileTooLarge": "L'immagine è troppo grande. Usa un file sotto 15MB (JPG, PNG o WebP).",
      "notImageFile": "Carica un file immagine.",
      "noImageInResponse": "Nessuna immagine risultato restituita. Riprova più tardi.",
      "downloadName": "image-erased.png"
    },
    "object-remover": {
      "name": "Rimuovi Oggetti",
      "desc": "Rimuovi oggetti indesiderati dalle tue foto con l'IA.",
      "fullDesc": "Rimuovi oggetti basato sull'IA. Passa il pennello su qualsiasi oggetto indesiderato nella tua foto e l'IA lo rimuoverà senza soluzione di continuità, riempiendo l'area con contenuti naturali. Perfetto per pulire le foto e rimuovere distrazioni.",
      "fileTooLarge": "L'immagine è troppo grande. Usa un file sotto 15MB (JPG, PNG o WebP).",
      "notImageFile": "Carica un file immagine.",
      "noImageInResponse": "Nessuna immagine risultato restituita. Riprova più tardi.",
      "downloadName": "object-removed.png",
      "uploadLabel": "Carica immagine",
      "uploadHint": "Fare clic o trascinare per caricare un'immagine",
      "uploadSpec": "Supporta immagini JPG, PNG o WebP.",
      "maskHint": "Spennella ogni parte dell'oggetto che vuoi che l'IA rimuova.",
      "processButton": "Rimuovi oggetto",
      "demoBeforeAlt": "Foto prima della rimozione dell'oggetto indesiderato",
      "demoAfterAlt": "Foto dopo la rimozione dell'oggetto indesiderato",
      "processingAlt": "L'intelligenza artificiale elabora la foto contrassegnata",
      "resultBeforeAlt": "Foto originale prima della rimozione dell'oggetto",
      "resultAfterAlt": "Foto pulita dopo la rimozione dell'oggetto",
      "featureImageLabels": {
        "object": "esempio di rimozione di oggetti indesiderati",
        "person": "esempio di rimozione di una persona",
        "distraction": "esempio di rimozione della distrazione dello sfondo"
      },
      "featuresKicker": "Pulizia fotografica precisa",
      "featuresTitle": "Rimuovi oggetti indesiderati dalle foto online",
      "featuresIntro": "Contrassegna l'area esatta che desideri pulire e utilizza la rimozione degli oggetti AI per distrazioni fotografiche quotidiane senza ricostruire manualmente lo sfondo.",
      "features": [
        {
          "title": "Spazza via gli oggetti indesiderati",
          "desc": "Utilizza un pennello regolabile per contrassegnare disordine, segnali, oggetti di scena o altri oggetti. L'intelligenza artificiale rimuove l'area selezionata e la riempie con i dettagli dell'immagine circostante.",
          "cta": "Rimuovi oggetti gratuitamente"
        },
        {
          "title": "Rimuovi le persone dagli sfondi fotografici",
          "desc": "Elimina i fotografi, i turisti o i passanti dagli scatti di viaggio e dai ritratti quando si distraggono dal soggetto principale.",
          "cta": "Sfondi fotografici puliti e gratuiti"
        },
        {
          "title": "Cancella le piccole distrazioni dello sfondo",
          "desc": "Rimuovi cavi, contenitori, disordine stradale, segni o distrazioni visive isolate per creare una composizione più pulita.",
          "cta": "Cancella le distrazioni fotografiche gratuitamente"
        }
      ],
      "useCasesKicker": "Casi d'uso popolari",
      "useCasesTitle": "Cosa puoi rimuovere con AI Object Remover?",
      "useCasesIntro": "Progettato per modifiche mirate in cui puoi sfiorare chiaramente l'area indesiderata e mantenere invariato il resto della foto.",
      "useCases": [
        {
          "title": "Pulizia delle foto di viaggio",
          "desc": "Rimuovi passanti, segnali, bidoni o disordine stradale dalle foto delle vacanze."
        },
        {
          "title": "Pulizia delle foto del prodotto",
          "desc": "Cancella oggetti di scena, etichette, cavi e oggetti che distraggono attorno a un prodotto."
        },
        {
          "title": "Pulizia dello sfondo del ritratto",
          "desc": "Rimuovi le persone sullo sfondo e i piccoli oggetti che distolgono l'attenzione dal soggetto."
        },
        {
          "title": "Foto immobiliari",
          "desc": "Elimina il disordine temporaneo e gli oggetti isolati dalle immagini delle stanze o delle proprietà."
        },
        {
          "title": "Immagini sui social media",
          "desc": "Lucida le foto prima di pubblicarle rimuovendo le distrazioni visibili dalla cornice."
        },
        {
          "title": "Fotoritocco creativo",
          "desc": "Cancella le aree selezionate prima di riutilizzare un'immagine in un layout o in un progetto visivo."
        }
      ],
      "howToKicker": "Tre semplici passaggi",
      "howToTitle": "Come rimuovere un oggetto da una foto online",
      "howToIntro": "Carica una foto, sfiora l'oggetto indesiderato e scarica il risultato pulito dall'intelligenza artificiale.",
      "steps": [
        {
          "title": "Carica la tua foto",
          "desc": "Scegli l'immagine che contiene la persona, l'oggetto o la distrazione che desideri eliminare."
        },
        {
          "title": "Spennellare l'oggetto",
          "desc": "Regola il pennello e copri l'intera area indesiderata. Usa Annulla o la gomma per rifinire la maschera."
        },
        {
          "title": "Rimuovi e scarica",
          "desc": "Avvia l'elaborazione AI, confronta le immagini prima e dopo, quindi scarica la foto pulita."
        }
      ],
      "faqTitle": "Domande frequenti sulla rimozione degli oggetti AI",
      "faqs": [
        {
          "q": "Come rimuovere oggetti indesiderati dalle foto online?",
          "a": "Carica una foto, passa il pennello sull'intero oggetto indesiderato e avvia l'elaborazione. L'intelligenza artificiale ricostruisce l'area selezionata utilizzando colori, trame e dettagli della scena vicini."
        },
        {
          "q": "Quale strumento posso utilizzare per rimuovere una persona dallo sfondo di una foto?",
          "a": "Usa il pennello per coprire la persona e includere dettagli come ombre o oggetti trasportati. I risultati sono generalmente migliori quando lo sfondo circostante è visibile."
        },
        {
          "q": "L’intelligenza artificiale può rimuovere segnali, cavi, bidoni e disordine stradale?",
          "a": "Sì. Contrassegna chiaramente l'area indesiderata ed evita di coprire i soggetti vicini che desideri conservare. Le distrazioni piccole e isolate sono generalmente più facili da ricostruire."
        },
        {
          "q": "Come posso ottenere un risultato di rimozione degli oggetti più naturale?",
          "a": "Utilizzare un'immagine sorgente chiara e di alta qualità e sfiorare leggermente oltre i bordi dell'oggetto. Elabora le aree difficili separatamente quando più oggetti si sovrappongono."
        },
        {
          "q": "La rimozione oggetti cambia l'intera foto?",
          "a": "La richiesta di rimozione è basata sulla maschera spazzolata. Lo strumento si concentra sull'area selezionata, sebbene l'intelligenza artificiale debba ricostruire i pixel attorno ai suoi bordi."
        },
        {
          "q": "Quali formati di immagine posso caricare?",
          "a": "Il controllo di caricamento accetta formati di immagine comuni tra cui JPG, PNG e WebP."
        }
      ]
    },
    "ai-person-remover": {
      "name": "Rimuovi Persone IA",
      "desc": "Rimuovi persone dalle tue foto con l'IA.",
      "fullDesc": "Rimuovi persone basato sull'IA. Passa il pennello su qualsiasi persona nella tua foto e l'IA la rimuoverà senza soluzione di continuità, riempiendo l'area con contenuti naturali. Perfetto per rimuovere passanti, turisti o sconosciuti dalle tue foto.",
      "fileTooLarge": "L'immagine è troppo grande. Usa un file sotto 15MB (JPG, PNG o WebP).",
      "notImageFile": "Carica un file immagine.",
      "noImageInResponse": "Nessuna immagine risultato restituita. Riprova più tardi.",
      "downloadName": "person-removed.png"
    },
    "background-blur": {
      "name": "Sfondo sfocato",
      "desc": "Sfoca lo sfondo dell'immagine con l'IA con un clic per evidenziare il soggetto",
      "fullDesc": "L'IA rileva automaticamente il soggetto in primo piano (persona/oggetto), mantiene il soggetto nitido e applica una sfocatura gaussiana allo sfondo per un effetto tipo Modalità Ritratto. Ideale per ritratti e primi piani di prodotto.",
      "fileTooLarge": "L'immagine è troppo grande. Usa un file sotto 15MB (JPG, PNG o WebP).",
      "notImageFile": "Carica un file immagine.",
      "noImageInResponse": "Nessuna immagine risultato restituita. Riprova più tardi.",
      "downloadName": "sfondo-sfocato.png"
    },
    "white-background": {
      "name": "Sfondo Bianco",
      "desc": "Sostituzione sfondo con bianco tramite IA",
      "fullDesc": "Sostituzione sfondo con bianco tramite IA con un clic. Rileva con precisione il contorno del soggetto, preserva dettagli fini come i capelli, output immagine con sfondo bianco pulito. Ideale per foto prodotto e foto tessera.",
      "fileTooLarge": "L'immagine è troppo grande. Usa un file sotto 15MB (JPG, PNG o WebP).",
      "notImageFile": "Carica un file immagine.",
      "noImageInResponse": "Nessuna immagine risultato restituita. Riprova più tardi.",
      "downloadName": "sfondo-bianco.png"
    },
    "blue-background": {
      "name": "Sfondo Blu",
      "desc": "Sostituzione sfondo con blu tramite IA",
      "fullDesc": "Sostituzione sfondo con blu tramite IA con un clic. Rileva con precisione il contorno del soggetto, preserva dettagli fini come i capelli, output immagine con sfondo blu pulito. Ideale per foto tessera e foto passaporto.",
      "fileTooLarge": "L'immagine è troppo grande. Usa un file sotto 15MB (JPG, PNG o WebP).",
      "notImageFile": "Carica un file immagine.",
      "noImageInResponse": "Nessuna immagine risultato restituita. Riprova più tardi.",
      "downloadName": "sfondo-blu.png"
    },
    "face-swap": {
      "name": "Scambio volti nelle foto",
      "desc": "Scambia visi nelle foto con l'IA in un clic",
      "fullDesc": "Scambio viso alimentato dall'IA. Carica una foto target e una foto del viso sorgente per fondere il viso nell'immagine target in modo trasparente. Supporta scene con più persone con risultati realistici.",
      "fileTooLarge": "L'immagine è troppo grande. Usa un file sotto 15MB (JPG, PNG o WebP).",
      "notImageFile": "Carica un file immagine.",
      "targetImage": "Foto target",
      "sourceImage": "Viso sorgente",
      "effectImageLabel": "Risultato",
      "downloadName": "scambio-viso-risultato.png",
      "step1Title": "Carica foto",
      "step1Desc": "Carica la foto target e la foto del viso sorgente",
      "step2Title": "Scambio viso IA",
      "step2Desc": "Clicca elabora, l'IA scambia il viso automaticamente",
      "step3Title": "Scarica",
      "step3Desc": "Anteprima e scarica il risultato",
      "processButton": "Scambia faccia",
      "targetPreviewAlt": "Anteprima della foto di destinazione per lo scambio del volto AI",
      "sourcePreviewAlt": "Anteprima del volto sorgente per lo scambio del volto AI",
      "processingAlt": "Anteprima dell'elaborazione dello scambio di volti AI",
      "resultBeforeAlt": "Foto di destinazione prima dello scambio di volti",
      "resultAfterAlt": "Foto dopo lo scambio del volto con l'IA",
      "featuresKicker": "Sostituzione naturale del viso",
      "featuresTitle": "Scambia i volti tra le foto con l'intelligenza artificiale",
      "featuresIntro": "Utilizza una foto di destinazione per la posa e la composizione, quindi fornisci un volto sorgente chiaro per uno scambio di volti mirato.",
      "features": [
        {
          "title": "Crea uno scambio di volti dall'aspetto naturale",
          "desc": "L'intelligenza artificiale fonde l'identità di origine nella foto di destinazione seguendone la posa, l'inquadratura, l'illuminazione e lo stile visivo generale.",
          "cta": "Crea uno scambio di foto di volti gratuitamente"
        },
        {
          "title": "Mantieni la composizione fotografica di destinazione",
          "desc": "Usa un ritratto, un selfie, l'immagine di un personaggio o una scena creativa come target mantenendone lo sfondo e la composizione.",
          "cta": "Prova Photo Face Swap gratuitamente"
        },
        {
          "title": "Utilizzare un volto con origine chiara",
          "desc": "Carica un'immagine sorgente frontale e ben illuminata con dettagli del viso visibili per aiutare il modello a creare una sostituzione più coerente.",
          "cta": "Carica e scambia gratuitamente"
        }
      ],
      "useCasesKicker": "Idee fotografiche creative",
      "useCasesTitle": "Usi popolari per lo scambio di volti di foto online",
      "useCasesIntro": "Crea modifiche fotografiche giocose e creative utilizzando un'immagine di destinazione e un'immagine del volto sorgente.",
      "useCases": [
        {
          "title": "Scambio di selfie e foto del profilo",
          "desc": "Sostituisci un volto in un selfie o in un ritratto preservando la posa, lo sfondo e l'inquadratura target. Esplora concetti di foto del profilo e idee per ritratti personali con un volto di origine chiaro.",
          "cta": "Crea gratuitamente uno scambio di volti con ritratto",
          "imageAlt": "Esempio di scambio di volti con intelligenza artificiale per selfie e foto del profilo"
        },
        {
          "title": "Meme e immagini di reazione sociale",
          "desc": "Trasforma le foto familiari in meme personalizzati, immagini di reazione giocose e contenuti social condivisibili. Un'espressione target chiara aiuta a mantenere l'immagine finale facile da riconoscere.",
          "cta": "Crea uno scambio di volti di meme gratuitamente",
          "imageAlt": "Caso d'uso dell'immagine di meme creativo e reazione sociale"
        },
        {
          "title": "Cosplay, personaggi e storie creative",
          "desc": "Prova un volto in un costume, un ritratto fantasy, un personaggio illustrato o una scena a tema. Usa lo scambio di volti per esplorare i concetti dei personaggi e creare storie visive da immagini che puoi modificare.",
          "cta": "Prova gratuitamente lo scambio di volti dei personaggi",
          "imageAlt": "Caso d'uso per cosplay e scambio di volti dei personaggi"
        }
      ],
      "howToKicker": "Tre semplici passaggi",
      "howToTitle": "Come scambiare i volti nelle foto online con l'intelligenza artificiale",
      "howToIntro": "Scegli una foto di destinazione, aggiungi un volto sorgente chiaro e lascia che l'IA generi il risultato con lo scambio di volti.",
      "faqTitle": "Domande frequenti sullo scambio di volti di foto",
      "faqs": [
        {
          "q": "Come scambiare un volto tra due foto online?",
          "a": "Carica la foto di cui desideri mantenere la posa e la composizione come target, quindi carica l'identità che desideri utilizzare come volto di origine e avvia l'elaborazione."
        },
        {
          "q": "Qual è la differenza tra la foto di destinazione e il volto di origine?",
          "a": "La foto di destinazione fornisce la posa, lo sfondo e la composizione. Il volto di origine fornisce l'identità facciale utilizzata per la sostituzione."
        },
        {
          "q": "Come faccio a scegliere una buona immagine sorgente per lo scambio di volti?",
          "a": "Utilizza un'immagine chiara e ben illuminata con un volto non ostruito. Un angolo di origine e un'espressione simili al target possono produrre un risultato più coerente."
        },
        {
          "q": "Posso utilizzare lo scambio di volti tramite intelligenza artificiale per selfie, meme o foto di cosplay?",
          "a": "Sì. Questi sono usi creativi comuni quando possiedi o sei autorizzato a modificare le immagini caricate."
        },
        {
          "q": "Perché lo scambio di volti a volte sembra meno realistico?",
          "a": "Grandi differenze nell'angolazione del viso, nell'illuminazione, nell'espressione, nella risoluzione o nell'occlusione pesante possono rendere più difficile la fusione. Prova foto sorgente più chiare e compatibili."
        },
        {
          "q": "Quali formati di immagine e dimensioni di file sono supportati?",
          "a": "Sono supportate immagini JPG, PNG e WebP, con una dimensione massima del file di 15 MB per immagine."
        },
        {
          "q": "Posso scambiare un volto in un video in questa pagina?",
          "a": "No. Questa pagina elabora le immagini fisse e restituisce un risultato immagine."
        }
      ]
    },
    "image-enhancer": {
      "name": "Miglioratore immagine",
      "desc": "Migliora la nitidezza delle immagini con IA in un clic",
      "fullDesc": "Upscale immagini alla risoluzione 4K con dettagli migliorati. Utilizza algoritmi AI avanzati per migliorare i dettagli, rendendo le immagini sfocate nitide e chiare.",
      "fileTooLarge": "L'immagine è troppo grande. Usa un file sotto 15MB (JPG, PNG o WebP).",
      "notImageFile": "Carica un file immagine.",
      "downloadName": "immagine-migliorata.png",
      "targetResolution": "Risoluzione target",
      "outputFormat": "Formato output",
      "resolutions": {
        "2k": "2K",
        "4k": "4K",
        "8k": "8K"
      },
      "formats": {
        "JPEG": "JPEG",
        "PNG": "PNG",
        "WEBP": "WEBP"
      },
      "processFailed": "Elaborazione fallita. Prova un'altra immagine o formato di output."
    },
    "video-enhancer": {
      "name": "Miglioratore video",
      "desc": "Migliora la qualità del video con upscaling IA",
      "fullDesc": "Migliora i video a HD/4K con interpolazione dei fotogrammi e nitidezza assistita da IA.",
      "notVideoFile": "Carica un file video (es. MP4, MOV, AVI).",
      "fileTooLarge": "Il video è troppo grande. Usa un file sotto 100MB."
    },
    "cartoon-video-style-converter": {
      "name": "Convertitore stile cartoon",
      "desc": "Converti video in stile cartoon",
      "fullDesc": "Carica un video e l'IA lo convertirà in stile cartoon mantenendo movimento principale, inquadratura e ritmo.",
      "notVideoFile": "Carica un file video valido.",
      "fileTooLarge": "Il video è troppo grande. Seleziona un video sotto 100MB.",
      "downloadName": "cartoon-style-video.mp4"
    },
    "anime-video-style-converter": {
      "name": "Convertitore stile anime",
      "desc": "Converti video in stile anime",
      "fullDesc": "Carica un video e l'IA lo convertirà in stile anime mantenendo movimento del soggetto e ritmo della scena.",
      "notVideoFile": "Carica un file video valido.",
      "fileTooLarge": "Il video è troppo grande. Seleziona un video sotto 100MB.",
      "downloadName": "anime-style-video.mp4"
    },
    "oil-painting-video-style-converter": {
      "name": "Convertitore stile pittura a olio",
      "desc": "Converti video in stile pittura a olio",
      "fullDesc": "Carica un video e l'IA lo convertirà in stile pittura a olio con colori ricchi e texture pittorica.",
      "notVideoFile": "Carica un file video valido.",
      "fileTooLarge": "Il video è troppo grande. Seleziona un video sotto 100MB.",
      "downloadName": "oil-painting-style-video.mp4"
    },
    "cyberpunk-video-style-converter": {
      "name": "Convertitore stile cyberpunk",
      "desc": "Converti video in stile cyberpunk",
      "fullDesc": "Carica un video e l'IA lo convertirà in stile cyberpunk futuristico ad alto contrasto con luci neon.",
      "notVideoFile": "Carica un file video valido.",
      "fileTooLarge": "Il video è troppo grande. Seleziona un video sotto 100MB.",
      "downloadName": "cyberpunk-style-video.mp4"
    },
    "doc-crop-enhance": {
      "name": "Ritaglio e correzione immagine",
      "desc": "Ritaglia bordi e correggi la distorsione dei documenti con IA",
      "fullDesc": "Ritaglio, dewarping e miglioramento immagine. Rimuovi sfondo dei bordi, correggi distorsione e migliora con più modalità inclusi illuminazione, nitidezza, bianco e nero, scala di grigi e rimozione ombre.",
      "enhanceMode": "Modalità miglioramento",
      "enhanceModes": {
        "disabled": "Disabilitato",
        "brighten": "Illumina",
        "sharpen": "Migliora e nitidezza",
        "blackWhite": "Bianco e nero",
        "grayscale": "Scala di grigi",
        "deshadow": "Rimozione ombre",
        "bitmap": "Bitmap"
      },
      "cropImage": "Ritaglia bordi",
      "dewarpImage": "Correggi distorsione",
      "notImageFile": "Carica un file immagine valido",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB",
      "noImageInResponse": "Elaborazione fallita, riprova",
      "downloadName": "doc-ritagliato-migliorato.png",
      "featuresKicker": "MIGLIORAMENTO DELLA SCANSIONE DEI DOCUMENTI",
      "featuresTitle": "Trasforma le foto dei documenti in scansioni pulite e correttamente allineate",
      "featuresIntro": "Gestisci i bordi dei documenti, l'inclinazione, la prospettiva, le pagine curve, le ombre e la nitidezza del testo per le comuni esigenze di acquisizione mobile e miglioramento della scansione.",
      "features": [
        {
          "title": "Rileva e ritaglia automaticamente i bordi del documento",
          "desc": "Trova il confine tra il foglio e il suo sfondo, quindi rimuovi le scrivanie, le ombre dei bordi e le aree non correlate per una pagina più pulita.",
          "cta": "Ritaglia un documento gratuitamente"
        },
        {
          "title": "Raddrizza i documenti inclinati e correggi la prospettiva",
          "desc": "Correggi la distorsione trapezoidale, le pagine inclinate e le proporzioni causate dalle foto angolate del telefono di contratti, moduli e documenti di prova.",
          "cta": "Correggere una foto del documento"
        },
        {
          "title": "Dewarp pagine curve e documenti scansionati",
          "desc": "Correggere la distorsione vicino alle rilegature dei libri, alla carta arricciata e alle pagine piegate per facilitare la lettura dei libri di testo e delle foto.",
          "cta": "Dewarping un documento curvo"
        },
        {
          "title": "Rimuovi le ombre dalle scansioni dei documenti",
          "desc": "Riduci le ombre causate da telefoni, dita, dorsi di libri e illuminazione non uniforme per ricevute, fogli di lavoro e pagine scansionate più puliti.",
          "cta": "Rimuovi le ombre del documento"
        },
        {
          "title": "Schiarisci i documenti e rendi più nitido il testo",
          "desc": "Migliora la luminosità e i bordi del testo stampato nei documenti a basso contrasto per facilitare la lettura, la stampa e l'organizzazione.",
          "cta": "Rendere più nitido il testo scansionato"
        },
        {
          "title": "Crea scansioni in bianco e nero, in scala di grigi o bitmap",
          "desc": "Converti foto di documenti a colori in immagini in bianco e nero, in scala di grigi o ottimizzate bitmap per la stampa e l'archiviazione.",
          "cta": "Migliora l'immagine di un documento"
        }
      ],
      "useCasesKicker": "CASI D'USO COMUNI",
      "useCasesTitle": "Quali immagini di documenti possono essere ritagliate e migliorate?",
      "useCasesIntro": "Progettato per immagini di singoli documenti catturati tramite telefono o scanner con inquadrature irregolari, ombre, distorsioni o testo poco chiaro.",
      "useCases": [
        {
          "title": "Foto del telefono da scansionare",
          "desc": "Rimuovi gli sfondi della scrivania e correggi gli angoli della fotocamera per rendere le foto del telefono più simili a scansioni."
        },
        {
          "title": "Contratti e modulistica",
          "desc": "Ritaglia contratti, applicazioni e moduli per ripristinare bordi puliti e proporzioni della pagina."
        },
        {
          "title": "Ricevute e fatture",
          "desc": "Riduci le ombre e rendi più nitido il testo stampato sbiadito per una visualizzazione e un'archiviazione più chiare."
        },
        {
          "title": "Pagine di libro curve",
          "desc": "Curvatura corretta vicino alle rilegature di libri di testo, libri e cartelle di esercizi."
        },
        {
          "title": "Documenti di prova e fogli di lavoro",
          "desc": "Raddrizza le carte di prova, rimuovi le ombre e rendi più nitido il testo stampato per riutilizzarlo o stamparlo."
        },
        {
          "title": "Archivi in bianco e nero",
          "desc": "Converti le foto dei documenti in stili di scansione coerenti in bianco e nero o in scala di grigi."
        }
      ],
      "faqTitle": "Domande frequenti su ritaglio e correzione dei documenti AI",
      "faqs": [
        {
          "q": "Che cos'è il ritaglio e la correzione dei documenti AI?",
          "a": "Rileva l'area del documento, rimuove lo sfondo circostante e può correggere l'inclinazione, la prospettiva o la distorsione della pagina curva in base alle impostazioni."
        },
        {
          "q": "Come posso ritagliare automaticamente le immagini dei documenti scansionati online?",
          "a": "Abilita il ritaglio dei bordi, quindi carica l'immagine del documento scansionato. Lo strumento tenta di rilevare il limite della carta e rimuovere l'area esterna al documento."
        },
        {
          "q": "Posso raddrizzare un documento scansionato online?",
          "a": "Sì. Utilizza il raddrizzamento per una scansione inclinata e la correzione prospettica per una foto scattata con il telefono. Utilizza la correzione della distorsione solo quando la pagina stessa è curva."
        },
        {
          "q": "Qual è la differenza tra le modalità Deshadow e Sharpen?",
          "a": "Deshadow migliora l'illuminazione irregolare della pagina, mentre la nitidezza rafforza il testo e i bordi delle linee. Scegli la modalità che corrisponde al problema di origine."
        },
        {
          "q": "Quale strumento posso utilizzare per migliorare documenti di prova, contratti e ricevute scansionati?",
          "a": "Utilizza questo strumento di ritaglio e miglioramento dei documenti con attenuazione dell'ombra per un'illuminazione non uniforme, nitidezza per testo sbiadito e bianco e nero o scala di grigi durante la preparazione dei documenti per la stampa."
        },
        {
          "q": "Può trasformare una foto del telefono in un documento scansionato?",
          "a": "Il ritaglio, la correzione e il miglioramento possono produrre un'immagine simile alla scansione, ma lo strumento non genera PDF né estrae testo OCR."
        },
        {
          "q": "Quali formati di immagine e dimensioni di file sono supportati?",
          "a": "Sono supportate immagini JPG, PNG e WebP, con una dimensione massima del file di 15 MB."
        },
        {
          "q": "L'elaborazione modifica il contenuto del documento originale?",
          "a": "Lo strumento regola l'inquadratura, la geometria, la luminosità e la chiarezza. Non modifica il testo né estrae il contenuto del documento."
        }
      ],
      "education": {
        "kicker": "DOCUMENTI DI ISTRUZIONE",
        "title": "Trasforma le prove d'esame, i compiti e le foto dei libri di testo in scansioni nitide",
        "intro": "Rileva automaticamente i bordi dei documenti didattici e correggi l'inclinazione, la prospettiva, le pagine curve e le ombre per una stampa, un'archiviazione e un utilizzo in classe più puliti.",
        "items": [
          {
            "title": "Ritaglia foto su carta di prova",
            "desc": "Rileva i bordi della carta di prova e rimuovi lo sfondo della scrivania per creare una pagina pulita e incorniciata correttamente."
          },
          {
            "title": "Immagini corrette dei compiti",
            "desc": "Correggi l'inclinazione e la prospettiva delle foto dei compiti in modo che siano più facili da rivedere, inviare e stampare."
          },
          {
            "title": "Dewarp pagine di libri di testo",
            "desc": "Correggi le pagine curve vicino alle rilegature dei libri e riduci le ombre che rendono più difficile la lettura del contenuto stampato."
          },
          {
            "title": "Affinare i fogli di lavoro in classe",
            "desc": "Schiarisci e rendi più nitidi i fogli di lavoro o i materiali di studio con effetti di scansione puliti in bianco e nero o in scala di grigi."
          }
        ],
        "relatedTitle": "Hai bisogno di rimuovere le risposte scritte a mano da un documento di prova?",
        "relatedDesc": "Questo strumento gestisce il ritaglio, la correzione geometrica e il miglioramento dell'immagine. Utilizza la gomma per la scrittura a mano per rimuovere le risposte degli studenti, i calcoli o le annotazioni dell'insegnante.",
        "relatedCta": "Apri Gomma per grafia"
      }
    },
    "handwritten-erase": {
      "name": "Gomma scrittura a mano",
      "desc": "Cancella il testo scritto a mano dai documenti con IA",
      "fullDesc": "Rileva e cancella automaticamente il testo scritto a mano dai documenti preservando il contenuto stampato. Perfetto per esami, note, contratti e altro. Supporta ritaglio, dewarping e rotazione.",
      "docDirection": "Rotazione",
      "docDirections": {
        "none": "Nessuna rotazione",
        "rotate90": "90° in senso orario",
        "rotate180": "180° in senso orario",
        "rotate270": "270° in senso orario",
        "auto": "Rilevamento automatico"
      },
      "crop": "Ritaglia bordi",
      "dewarp": "Correggi distorsione",
      "notImageFile": "Carica un file immagine valido",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB",
      "noImageInResponse": "Elaborazione fallita, riprova",
      "downloadName": "scrittura-cancellata.png",
      "featuresKicker": "Rimozione della grafia dei documenti",
      "featuresTitle": "Rimuovi la grafia e ripristina documenti puliti",
      "featuresIntro": "Pulisci le risposte scritte a mano, le revisioni dei contratti, le note di revisione e i contrassegni dei documenti scansionati preservando il testo stampato e il layout originale.",
      "features": [
        {
          "title": "Rimuovere le risposte degli studenti dai documenti di prova",
          "desc": "Rileva automaticamente risposte scritte a mano, calcoli e annotazioni sui documenti di prova completati.",
          "cta": "La carta di prova pulita risponde gratuitamente"
        },
        {
          "title": "Cancella la scrittura dai contratti",
          "desc": "Pulisci le aggiunte scritte a mano, i cerchi, gli importi modificati, le frecce e le note di revisione preservando le clausole, le tabelle e il layout stampati.",
          "cta": "Scrittura a mano pulita del contratto online"
        },
        {
          "title": "Preparare e ristampare i test per l'insegnamento",
          "desc": "Pulisci le risposte degli studenti e le annotazioni degli insegnanti per le lezioni, la preparazione dei test e l'archiviazione dei documenti.",
          "cta": "Prova il detergente per carta di prova per insegnanti"
        },
        {
          "title": "Elimina i segni scritti a mano dai documenti scansionati",
          "desc": "Rimuovi segni di spunta, frecce, cerchi, note a margine e segni di revisione da moduli scansionati, rapporti di ispezione e documenti d'ufficio.",
          "cta": "Pulisci i segni dei documenti scansionati"
        }
      ],
      "useCasesKicker": "Per studenti e insegnanti",
      "useCasesTitle": "Casi d'uso nel settore didattico per la rimozione della grafia tramite intelligenza artificiale",
      "useCases": [
        {
          "title": "Rimozione della risposta di prova",
          "desc": "Cancella le risposte e i calcoli degli studenti dalle prove."
        },
        {
          "title": "Revisione degli errori",
          "desc": "Ripristina i documenti completati per un altro giro di pratica."
        },
        {
          "title": "Pulizia della cartella di lavoro",
          "desc": "Rimuovere i contenuti scritti a mano dai compiti e dai fogli di lavoro."
        },
        {
          "title": "Insegnamento e preparazione ai test",
          "desc": "Crea documenti puliti per lezioni, ristampa e archiviazione."
        },
        {
          "title": "Correzione della carta scansionata",
          "desc": "Ruota, ritaglia e correggi le immagini di documenti inclinati o curvi."
        },
        {
          "title": "Pulizia di contratti e note",
          "desc": "Rimuovi la scrittura a mano e le annotazioni dai documenti generali."
        }
      ],
      "howToKicker": "Tre semplici passaggi",
      "howToTitle": "Come rimuovere le risposte scritte a mano dai documenti di prova online",
      "howToIntro": "Carica un documento o un documento di prova, imposta le opzioni di rotazione, ritaglio e correzione della distorsione, quindi scarica il risultato ripulito.",
      "steps": {
        "upload": {
          "title": "Carica un documento o un documento di prova",
          "desc": "Carica un documento di prova, un foglio dei compiti o un documento scansionato in formato JPG, PNG o WebP di dimensioni inferiori a 15 MB."
        },
        "process": {
          "title": "Configura e rimuovi la grafia",
          "desc": "Scegli la direzione del documento e abilita il ritaglio o la correzione della distorsione secondo necessità, quindi avvia l'elaborazione."
        },
        "download": {
          "title": "Rivedi e scarica",
          "desc": "Confronta le immagini prima e dopo, scarica il documento pulito o elabora un'altra immagine."
        }
      },
      "faqTitle": "Domande frequenti sulla rimozione delle risposte della carta di prova AI",
      "faqs": [
        {
          "q": "Quale strumento posso utilizzare per rimuovere le risposte scritte a mano dai documenti di prova?",
          "a": "Il dispositivo di rimozione della grafia Miral AI rileva risposte, calcoli e annotazioni scritte a mano preservando le domande stampate e il layout originale, ove possibile."
        },
        {
          "q": "L’intelligenza artificiale può rimuovere la scrittura a mano preservando il testo stampato?",
          "a": "Può ripristinare una carta pulita preservando il testo stampato quando la grafia non si sovrappone pesantemente al contenuto stampato."
        },
        {
          "q": "Gli insegnanti possono pulire e ristampare le prove?",
          "a": "Sì. È adatto per la preparazione delle lezioni, le spiegazioni in classe, la creazione di test e l'archiviazione di documenti."
        },
        {
          "q": "Gli studenti possono reimpostare i documenti con risposta per la revisione?",
          "a": "Sì. I fogli di prova e i fogli di lavoro puliti possono essere riutilizzati per la revisione degli errori e per ulteriore pratica."
        },
        {
          "q": "Come posso cancellare note scritte a mano, segni di penna e annotazioni con inchiostro rosso?",
          "a": "Carica l'immagine del documento ed esegui la rimozione della grafia. Può elaborare diversi colori di grafia e strumenti di scrittura, sebbene i risultati dipendano dalla chiarezza e dalla sovrapposizione con il testo stampato."
        },
        {
          "q": "Come posso correggere una scansione inclinata o curva prima di rimuovere la scrittura a mano?",
          "a": "Allineare o ruotare prima una scansione inclinata. Utilizzare il ritaglio per lo sfondo in eccesso e la correzione della deformazione solo per le pagine veramente curve prima di elaborare la grafia."
        },
        {
          "q": "Quali formati di immagine sono supportati?",
          "a": "Sono supportate immagini JPG, PNG e WebP inferiori a 15 MB. I file PDF non sono supportati in questa pagina."
        }
      ]
    },
    "photo-restore": {
      "name": "Restauro fotografico",
      "desc": "Restore old, blurry or damaged photos with AI technology",
      "fullDesc": "Restore old, blurry or damaged photos with AI technology. Supports denoising, sharpening, and filling missing parts to bring precious memories back to life.",
      "notImageFile": "Carica un file immagine valido.",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB.",
      "downloadName": "foto-restaurata.png"
    },
    "blurry-photo-repair": {
      "name": "Ripara immagini sfocate",
      "desc": "Ripara immagini sfocate e recupera dettagli più nitidi con l'IA",
      "fullDesc": "Ripara immagini sfocate con l'IA. Migliora la nitidezza, recupera dettagli di volti e texture e rende più chiare le foto poco definite.",
      "notImageFile": "Carica un file immagine valido.",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB.",
      "downloadName": "immagine-sfocata-riparata.png"
    },
    "cartoon-digital-human": {
      "name": "Generatore di personaggi cartoon AI",
      "desc": "Trasforma un ritratto in stile cartoon",
      "fullDesc": "Genera un umano digitale cartoon in stile anime da un ritratto. Mantiene i tratti riconoscibili e crea un avatar curato con linee pulite e colori vivaci.",
      "notImageFile": "Carica un file immagine valido.",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB.",
      "downloadName": "umano-digitale-cartoon.png"
    },
    "manga-digital-human": {
      "name": "Generatore di personaggi manga AI",
      "desc": "Trasforma un ritratto in stile manga",
      "fullDesc": "Genera un umano digitale in stile manga da un ritratto. Mantiene i tratti riconoscibili e crea un look fumetto pulito con linee espressive e ombreggiature curate.",
      "notImageFile": "Carica un file immagine valido.",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB.",
      "downloadName": "umano-digitale-manga.png"
    },
    "oil-painting-digital-human": {
      "name": "Generatore AI di ritratti a olio",
      "desc": "Trasforma un ritratto in stile pittura a olio",
      "fullDesc": "Genera un umano digitale stile pittura a olio da un ritratto. Conserva i tratti riconoscibili creando un ritratto pittorico con colori ricchi e texture da pennello.",
      "notImageFile": "Carica un file immagine valido.",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB.",
      "downloadName": "umano-digitale-pittura-olio.png"
    },
    "id-photo-generator": {
      "name": "Generatore Foto Tessera",
      "desc": "Genera foto tessera standard da un ritratto",
      "fullDesc": "Genera una foto tessera pulita e professionale da un ritratto. L'IA prepara il soggetto con un aspetto ordinato da documento.",
      "notImageFile": "Carica un file immagine valido.",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB.",
      "downloadName": "foto-tessera.png"
    },
    "ai-change-clothes": {
      "name": "Cambio abiti AI",
      "desc": "Carica outfit e persona, cambio outfit con un clic",
      "fullDesc": "Carica prima l'immagine outfit, poi l'immagine della persona. L'IA trasferisce l'outfit selezionato sul ritratto preservando persona, posa e dettagli naturali dell'immagine.",
      "demoTitle": "Demo",
      "notImageFile": "Carica un file immagine valido.",
      "fileTooLarge": "Immagine troppo grande, seleziona un'immagine sotto 15MB.",
      "firstImageLabel": "Immagine outfit",
      "uploadFirstImage": "Carica immagine outfit",
      "changeFirstImage": "Cambia immagine outfit",
      "secondImageLabel": "Immagine persona",
      "uploadSecondImage": "Carica immagine persona",
      "changeSecondImage": "Cambia immagine persona",
      "uploadingSecondImage": "Caricamento immagine persona...",
      "downloadName": "outfit-cambiato-ia.png"
    },
    "category": {
      "image": "Elaborazione immagini",
      "video": "Elaborazione video",
      "document": "Elaborazione documenti"
    },
    "categoryModal": {
      "title": "Seleziona categoria strumento"
    },
    "convert": {
      "success": "Conversione completata!",
      "zipHint": "Il risultato è impacchettato come file ZIP contenente più immagini",
      "fileTooLarge": "File troppo grande, seleziona un file inferiore a 50MB",
      "demoTitle": "Anteprima conversione",
      "sourceLabel": "Formato sorgente",
      "targetLabel": "Formato output"
    },
    "pdf-to-word": {
      "name": "PDF in Word",
      "desc": "Converti file PDF in documenti Word modificabili",
      "fullDesc": "Converti intelligentemente file PDF in documenti Word modificabili, preservando con precisione layout, tabelle, immagini e altro."
    },
    "image-to-word": {
      "name": "Immagine in Word",
      "desc": "Converti testo nelle immagini in documenti Word",
      "fullDesc": "Riconosci intelligentemente testo, tabelle e altri contenuti nelle immagini e convertili in documenti Word, preservando il formato originale."
    },
    "pdf-to-excel": {
      "name": "PDF in Excel",
      "desc": "Converti tabelle PDF in file Excel modificabili",
      "fullDesc": "Riconosci intelligentemente il contenuto delle tabelle nei file PDF e convertilo in file Excel modificabili."
    },
    "pdf-to-ppt": {
      "name": "PDF in PPT",
      "desc": "Converti file PDF in presentazioni PPT modificabili",
      "fullDesc": "Converti intelligentemente file PDF in presentazioni PPT modificabili, preservando layout, immagini e testo originali."
    },
    "pdf-to-image": {
      "name": "PDF in Immagine",
      "desc": "Converti ogni pagina PDF in immagini di alta qualità",
      "fullDesc": "Converti ogni pagina di un file PDF in immagini di alta qualità. Supporta la conversione batch di PDF multipagina."
    },
    "word-to-pdf": {
      "name": "Word in PDF",
      "desc": "Converti documenti Word in file PDF",
      "fullDesc": "Converti rapidamente documenti Word in file PDF, preservando layout, caratteri e immagini originali."
    },
    "excel-to-pdf": {
      "name": "Excel in PDF",
      "desc": "Converti fogli di calcolo Excel in file PDF",
      "fullDesc": "Converti fogli di calcolo Excel in file PDF, preservando la struttura delle tabelle e il layout dei dati."
    },
    "image-to-pdf": {
      "name": "Immagine in PDF",
      "desc": "Unisci più immagini in un singolo file PDF",
      "fullDesc": "Unisci più immagini in un singolo file PDF. Supporta formati immagine comuni come JPG, PNG e BMP."
    },
    "word-to-image": {
      "name": "Word in Immagine",
      "desc": "Converti ogni pagina di documento Word in immagine",
      "fullDesc": "Converti ogni pagina di un documento Word in immagini di alta qualità. Supporta la conversione batch di documenti multipagina."
    }
  },
  "plans": {
    "basic": {
      "name": "Base",
      "features": [
        "Tutti i crediti consegnati in una volta",
        "Genera fino a 2.600 immagini AI",
        "Genera 520 video AI",
        "Genera fino a 480 brani musicali AI",
        "Nessun watermark",
        "Licenza commerciale"
      ]
    },
    "pro": {
      "name": "Pro",
      "features": [
        "Tutti i crediti consegnati in una volta",
        "Genera fino a 10.600 immagini AI",
        "Genera fino a 2.120 video AI",
        "Genera fino a 1.920 brani musicali AI",
        "Tutti i modelli premium",
        "Coda prioritaria",
        "Supporto prioritario",
        "Modalità privacy e conformità DPA"
      ]
    },
    "ultimate": {
      "name": "Ultimate",
      "features": [
        "Tutti i crediti consegnati in una volta",
        "Genera fino a 36.600 immagini AI",
        "Genera fino a 7.320 video AI",
        "Genera fino a 6.720 brani musicali AI",
        "Tutti i modelli premium",
        "Supporto dedicato",
        "Modalità privacy e conformità DPA"
      ]
    }
  },
  "langModal": {
    "title": "Seleziona lingua"
  },
  "home": {
    "generate": "Genera",
    "chatDisabledGenerateHint": "Inserisci un prompt",
    "compactChatPlaceholder": "Inserisci il prompt per generare splendide immagini e video AI e musica originale",
    "hero": {
      "title": "Miral – Creator AI tutto-in-uno per immagini, video e musica",
      "subtitle": "Basato su modelli AI versatili, Miral riunisce editing di immagini, generazione video e creazione musicale con l’AI. Modifica foto, crea video ritratto cinematografici e musica di sottofondo personalizzata per progetti personali e commerciali.",
      "createVideo": "Crea video",
      "createImage": "Crea immagine"
    },
    "stats": {
      "models": "Modelli AI top",
      "works": "Lavori generati",
      "tools": "Strumenti professionali",
      "platforms": "Piattaforme partner"
    },
    "generatorNew": {
      "promptPlaceholder": "Descrivi il video che vuoi generare...",
      "promptPlaceholderImage": "Descrivi l'immagine che vuoi generare...",
      "generating": "Generazione in corso...",
      "noHistory": "I risultati appariranno qui",
      "generationFailed": "Generazione fallita",
      "historyTitle": "Cronologia",
      "myAssets": "I miei asset"
    },
    "quickTools": {
      "title": "Strumenti AI rapidi"
    },
    "exploreMore": {
      "title": "Esplora altre funzioni IA"
    },
    "platform": {
      "tag": "Piattaforma",
      "title": "Cassetta degli attrezzi AI che rende la creazione semplice",
      "subtitle": "Tutto-in-uno per generazione immagini, creazione video, produzione musicale e strumenti professionali alimentati da modelli AI leader del settore.",
      "tabs": {
        "image": "Immagini AI",
        "video": "Video AI",
        "music": "Musica AI",
        "tools": "Cassetta degli attrezzi AI"
      },
      "image": {
        "title": "Genera e modifica immagini stupende con i migliori modelli AI globali",
        "desc": "Testo-immagine, modifica precisa, trasferimento stile e upscaling HD. Alimentato da FLUX, Midjourney, Seedream, GPT-Image-1 e Nano Banana.",
        "explore": "Esplora modelli immagine →"
      },
      "video": {
        "title": "Crea video cinematografici con AI",
        "desc": "Da testo-video a animazione immagine, alimentato da modelli Veo, Sora, Kling, Seedance e Wan. Genera video con audio sincronizzato e movimenti di camera professionali.",
        "explore": "Esplora modelli video →"
      },
      "music": {
        "title": "Creazione musicale originale alimentata da AI",
        "desc": "Genera musica originale da descrizioni, supportando vari stili e durate. Perfetto per colonne sonore video, musica di sottofondo podcast e altro.",
        "explore": "Esplora musica AI →"
      },
      "tools": {
        "title": "Cassetta degli attrezzi AI professionale",
        "desc": "Rimozione watermark, ripristino foto, upscaling HD, miglioramento video e altri strumenti professionali per tutte le tue esigenze di post-produzione.",
        "explore": "Vedi tutti gli strumenti →"
      }
    },
    "models": {
      "tag": "Modelli",
      "title": "Integrazione completa dei migliori modelli AI globali",
      "subtitle": "Una piattaforma che integra tutti i principali modelli AI. Basta cambiare tra account multipli e abbonamenti.",
      "imageModels": "Modelli immagine",
      "videoModels": "Modelli video",
      "musicModels": "Musica AI",
      "musicDesc": "Genera musica originale da descrizioni",
      "filterAll": "Tutti",
      "credits": "Crediti",
      "viewAll": "Vedi tutti →"
    },
    "features": {
      "tag": "Caratteristiche principali",
      "title": "Crea immagini, video e musica stupendi",
      "subtitle": "Da testo-immagine, testo-video a creazione musicale AI, più modifica precisa e upscaling HD — creazione completa in unico posto.",
      "items": {
        "textToImage": {
          "tag": "Testo a immagine",
          "title": "Testo a immagine",
          "desc": "Inserisci una descrizione, guarda la magia. Che si tratti di ritratti iperrealistici o paesaggi fantastici, usa Midjourney, Seedream, Nano Banana e altri modelli per generare capolavori visivi con semplici prompt.",
          "cta": "Generazione immagini",
          "imageAlt": "Genera capolavori visivi con prompt semplici usando Midjourney, Seedream, Nano Banana e altri modelli"
        },
        "imageEdit": {
          "tag": "Modifica immagine e trasferimento stile",
          "title": "Modifica immagine e trasferimento stile",
          "desc": "Usa AI per rimodellare con precisione le immagini. Che si tratti di cambiare stile, modificare oggetti, sostituire sfondo o modificare testo, tutto con alta coerenza.",
          "cta": "Modifica immagine",
          "beforeAlt": "Prima della modifica dell'immagine e del trasferimento di stile",
          "afterAlt": "Dopo la modifica dell'immagine e del trasferimento di stile"
        },
        "textToVideo": {
          "tag": "Testo a video",
          "title": "Testo a video",
          "desc": "Basta inserire i prompt per generare video cinematografici con audio sincronizzato, movimenti di camera professionali e movimenti realistici. Scegli tra modelli Veo, Sora, Kling, Seedance e Wan.",
          "cta": "Generazione video"
        },
        "imageToVideo": {
          "tag": "Immagine a video",
          "title": "Immagine a video",
          "desc": "Trasforma immagini statiche in video cinematografici. Che si tratti di foto prodotto, illustrazioni o immagini generate da AI, dagli vita con movimenti naturali e doppiaggio.",
          "cta": "Animazione immagine"
        },
        "upscale": {
          "tag": "Upscaling HD",
          "title": "Upscaling HD",
          "desc": "Usa AI per migliorare la qualità di immagini e video. Supporta upscaling HD senza perdita e migliora la risoluzione video al livello professionale 4K.",
          "cta": "Upscala ora",
          "imageAlt": "Migliora la qualità di immagini e video con l'IA"
        },
        "templates": {
          "tag": "40+ modelli immagine",
          "title": "40+ modelli immagine",
          "desc": "Massicci modelli per ispirare: modelli 3D, stile Ghibli, designer toys, generatore meme, copertine riviste e altro — carica una foto, risultati istantanei.",
          "cta": "Sfoglia modelli",
          "imageAlt": "Esempio di modello di immagine"
        }
      }
    },
    "gallery": {
      "tag": "Galleria",
      "title": "Esplora possibilità infinite",
      "subtitle": "Vedi cosa stanno costruendo i creatori con Miral — da immagini iperrealistiche a video cinematografici, ispirazione a portata di mano.",
      "images": {
        "alt1": "Esempio di immagine generata da Midjourney",
        "alt2": "Esempio di immagine generata da Seedream",
        "alt3": "Esempio di immagine generata da GPT-Image-1",
        "alt4": "Esempio di immagine generata da Flux",
        "alt5": "Esempio di immagine generata da Flux Pro",
        "alt6": "Esempio di immagine generata da Midjourney",
        "alt7": "Esempio di immagine generata da Seedream",
        "alt8": "Esempio di immagine generata da GPT-Image-1"
      }
    },
    "whyChoose": {
      "tag": "Perché scegliere Miral",
      "title": "Creazione completa, tutto ciò che serve",
      "subtitle": "Piattaforma completa che riunisce i migliori modelli AI di immagine, video e creazione musicale del mondo.",
      "items": {
        "allModels": {
          "title": "Tutti i modelli integrati, uno basta",
          "desc": "Accesso completo a 29+ modelli AI top da OpenAI, Google, Alibaba, ByteDance e altro. Basta cambiare tra strumenti o gestire abbonamenti multipli."
        },
        "fast": {
          "title": "Velocità fulminea",
          "desc": "La maggior parte della generazione immagini completa entro 30 secondi, generazione video richiede circa 1-6 minuti. Infrastruttura ottimizzata assicura no lunghe attese."
        },
        "credits": {
          "title": "Sistema crediti semplice",
          "desc": "Paga per consumo, prezzi trasparenti. Inizia con crediti gratuiti — nessun abbonamento necessario per iniziare a creare."
        },
        "api": {
          "title": "API sviluppatori",
          "desc": "Integra generazione di immagini, video e musica AI direttamente nelle tue applicazioni attraverso la nostra API completa. Costruisci il tuo prodotto su modelli AI top."
        }
      }
    },
    "testimonials": {
      "tag": "Storie utenti",
      "title": "Fidato dai creatori globali",
      "subtitle": "Unisciti a migliaia di professionisti e creatori che usano Miral per generare immagini, creare video e potenziare i loro flussi di lavoro creativi."
    },
    "faq": {
      "tag": "Supporto",
      "title": "Domande frequenti",
      "subtitle": "Guida completa alla piattaforma, modelli supportati, piani prezzi e caratteristiche."
    },
    "cta": {
      "title": "Inizia il tuo viaggio di creazione AI ora",
      "subtitle": "Unisciti a migliaia di creatori, designer e aziende che usano Miral per realizzare la loro creatività con i migliori modelli AI del mondo.",
      "createImage": "Crea immagine →",
      "createVideo": "Crea video →",
      "note": "Nuovi utenti ricevono crediti gratuiti alla registrazione. Nessuna carta di credito richiesta."
    },
    "apps": {
      "title": "Applicazioni",
      "quickTitle": "App AI rapide",
      "more": "Altro",
      "keywords": {
        "viralVideo": "Video virale",
        "tiktokAds": "Annunci TikTok",
        "productShowcase": "Showcase prodotto",
        "aiAvatar": "Avatar IA",
        "homeModernKitchen": "Cucina moderna"
      },
      "social": "Social Media",
      "posters": "Poster",
      "interior": "Casa",
      "entertainment": "Intrattenimento",
      "lifestyle": "Stile di Vita",
      "comic": "Fumetto",
      "items": {
        "viralVideo": "Video Virali",
        "celebrityVideo": "Video Celebrità",
        "productShowcase": "Showcase Prodotto",
        "tiktokAds": "Pubblicità TikTok",
        "aiMeme": "Meme IA",
        "aiAvatar": "Avatar IA",
        "logoAnimation": "Animazione Logo",
        "socialShorts": "Short Social",
        "brandStory": "Storia del Brand",
        "tutorialClip": "Tutorial",
        "musicVideo": "Video Musicale IA",
        "animeScene": "Scena Anime",
        "movieTrailer": "Trailer Film",
        "gameCinematic": "Cinematica Gioco",
        "visualPoetry": "Poesia Visiva",
        "natureDoc": "Documentario Natura",
        "cyberpunkCity": "Città Cyberpunk",
        "underwaterWorld": "Mondo Sottomarino",
        "timelapseArt": "Arte Timelapse",
        "dailyVlog": "Vlog Quotidiani",
        "cookingShow": "Programma Cucina",
        "fitnessCoach": "Coach Fitness",
        "travelDiary": "Diario di Viaggio",
        "fashionShow": "Sfilata di Moda",
        "petParadise": "Paradiso degli Animali",
        "weddingMoment": "Momento Matrimonio",
        "yogaFlow": "Flusso Yoga",
        "homeDecor": "Decorazione Casa",
        "sunsetRun": "Corsa al Tramonto",
        "instagramReels": "Instagram Reels",
        "youtubeIntro": "Intro YouTube",
        "linkedinPromo": "Promo LinkedIn",
        "aiThumbnail": "Miniatura IA",
        "podcastClip": "Clip Podcast",
        "horrorShort": "Corto Horror",
        "danceVideo": "Video Danza",
        "aiComic": "Fumetto IA",
        "magicShow": "Spettacolo di Magia",
        "fantasyWorld": "Mondo Fantasy",
        "diyCraft": "Fai da Te",
        "morningRoutine": "Routine Mattutina",
        "babyGrowth": "Crescita del Bambino",
        "streetFood": "Cibo di Strada",
        "bookTrailer": "Trailer Libro",
        "socialLuxuryBag": "Drop Borsa di Lusso",
        "socialFashionVote": "Voto di Moda",
        "socialSneakerDrop": "Sneaker Urban Premium",
        "socialTropicalCocktail": "Cocktail del Weekend",
        "socialCityBillboard": "Pubblicità Billboard Urbano",
        "socialStreetwearDrop": "Drop Streetwear",
        "socialBoxingGloves": "Pubblicità Guantoni da Boxe",
        "homeEclecticLiving": "Soggiorno Eclettico",
        "homeFarmhouseKitchen": "Cucina in Stile Fattoria",
        "homeModernKitchen": "Cucina Moderna Minimalista",
        "homeVictorianStairs": "Scala Vittoriana",
        "homeScandiLiving": "Soggiorno Scandinavo",
        "homeMediterraneanPatio": "Patio Mediterraneo",
        "homeBohoSunroom": "Veranda Bohémien",
        "homeEclecticBedroom": "Camera Eclettica",
        "comicPortrait": "Fumetto Supereroe",
        "animeCharacter": "Anime Mecha",
        "mangaScene": "Manga Notte Piovosa",
        "comicOilPainting": "Fumetto Quotidiano",
        "comicCover": "Fumetto Eroe Energetico",
        "animePortrait": "Fumetto Salto sui Tetti",
        "comicCouple": "Fumetto Giovane Eroe",
        "mangaWarrior": "Fumetto Stregone"
      }
    }
  },
  "musicTags": {
    "pop": "Pop",
    "electronic": "Elettronica",
    "classical": "Classica",
    "jazz": "Jazz"
  },
  "music": {
    "breadcrumb": {
      "home": "Home",
      "aiMusic": "Musica AI"
    },
    "model": {
      "label": "Modello",
      "aiMusicName": "Musica AI",
      "desc": "Genera musica originale da descrizioni, supportando vari stili e durate.",
      "tagMusic": "Generazione musicale",
      "tagLyrics": "Creazione testi"
    },
    "mode": {
      "describe": "Descrivi",
      "lyrics": "Scrivi testi"
    },
    "form": {
      "musicDesc": "Descrizione musica",
      "musicDescPlaceholder": "Descrivi lo stile musicale, emozione e scena che desideri...\n\nEsempio: Una musica elettronica allegra con melodie sintetizzate futuristiche, adatta per video promozionali di prodotti tecnologici",
      "optimize": "Ottimizza",
      "songTitle": "Titolo canzone",
      "songTitlePlaceholder": "Inserisci titolo canzone...",
      "lyricsDescLabel": "Descrizione testi",
      "lyricsDescPlaceholder": "Scrivi qui la tua descrizione dei testi...\n\nEsempio:\n[Intro]\n...\n[Strofa]\n...\n[Coro]\n...",
      "styleTags": "Tag stile",
      "styleTagsPlaceholder": "Clicca sui tag sotto per aggiungere (multi-selezione)"
    },
    "tags": {
      "sections": [
        {
          "label": "Strofa",
          "value": "[Strofa]\n"
        },
        {
          "label": "Coro",
          "value": "[Coro]\n"
        },
        {
          "label": "Bridge",
          "value": "[Bridge]\n"
        },
        {
          "label": "Intro",
          "value": "[Intro]\n"
        },
        {
          "label": "Outro",
          "value": "[Outro]\n"
        }
      ],
      "styles": [
        {
          "label": "Pop",
          "value": "Pop"
        },
        {
          "label": "Rock",
          "value": "Rock"
        },
        {
          "label": "Jazz",
          "value": "Jazz"
        },
        {
          "label": "Classica",
          "value": "Classica"
        },
        {
          "label": "Elettronica",
          "value": "Elettronica"
        },
        {
          "label": "R&B",
          "value": "R&B"
        },
        {
          "label": "Hip-Hop",
          "value": "Hip-Hop"
        },
        {
          "label": "Country",
          "value": "Country"
        },
        {
          "label": "Folk",
          "value": "Folk"
        },
        {
          "label": "Ambient",
          "value": "Ambient"
        },
        {
          "label": "Cinematica",
          "value": "Cinematica"
        },
        {
          "label": "Lo-fi",
          "value": "Lo-fi"
        },
        {
          "label": "Metal",
          "value": "Metal"
        },
        {
          "label": "Reggae",
          "value": "Reggae"
        },
        {
          "label": "Blues",
          "value": "Blues"
        },
        {
          "label": "Soul",
          "value": "Soul"
        },
        {
          "label": "Funk",
          "value": "Funk"
        },
        {
          "label": "Indie",
          "value": "Indie"
        }
      ]
    },
    "options": {
      "duration": "Durata",
      "instrumental": "Strumentale",
      "instrumentalDescOn": "Genera solo accompagnamento, nessuna voce",
      "instrumentalDescOff": "Includi prestazione vocale"
    },
    "errors": {
      "titleRequired": "Il titolo della canzone è obbligatorio",
      "lyricsDescRequired": "La descrizione dei testi è obbligatoria"
    },
    "footer": {
      "creditsRequired": "Crediti richiesti:",
      "creditsLeft": "Rimanenti:",
      "generate": "Genera musica"
    },
    "preview": {
      "generating": "Generazione musica...",
      "generatedTitle": "Musica generata",
      "emptyTitle": "Generatore di musica AI",
      "emptySubtitle": "Crea musica originale con AI. Descrivi lo stile o inserisci testi, e genera la tua canzone in pochi secondi.",
      "emptyTags": [
        "Pop",
        "Jazz",
        "Cinematica",
        "Lo-fi",
        "Rock"
      ],
      "track": "Traccia",
      "play": "Riproduci",
      "pause": "Pausa",
      "mute": "Muto",
      "unmute": "Attiva audio",
      "download": "Scarica",
      "showLyrics": "Mostra testi",
      "hideLyrics": "Nascondi testi",
      "generateFailed": "Generazione fallita",
      "requestFailed": "Richiesta fallita, riprova",
      "downloadMp3": "Scarica MP3",
      "downloadWav": "Scarica WAV",
      "regenerate": "Rigenera",
      "noHistory": "Nessuna cronologia ancora"
    },
    "intro": {
      "title": "Generatore di musica AI",
      "desc": "Utilizzando tecnologia AI avanzata, basta inserire una descrizione o testi per generare musica originale di alta qualità. Supporta più stili musicali, adatto per colonne sonore video, pubblicità, podcast e altro.",
      "tagMusic": "Generazione musicale",
      "tagLyrics": "Creazione testi",
      "tagStyles": "Stili multipli",
      "tagCommercial": "Licenza commerciale"
    },
    "features": {
      "badge": "Caratteristiche principali",
      "title": "Cosa può fare il generatore di musica AI per te?",
      "items": {
        "styles": {
          "icon": "🎵",
          "title": "Stili multipli",
          "desc": "Supporta Pop, Rock, Elettronica, Jazz, Classica, Hip-Hop e dozzine di stili musicali per soddisfare varie esigenze creative."
        },
        "lyrics": {
          "icon": "📝",
          "title": "Creazione testi",
          "desc": "Inserisci testi per generare canzoni complete con marcatori di sezione (Strofa, Coro, ecc.), AI organizza automaticamente e produce musica."
        },
        "vocals": {
          "icon": "🎤",
          "title": "Sintesi vocale",
          "desc": "Supporta voci maschili e femminili con vari timbri, AI canta i tuoi testi con risultati naturali e fluidi."
        },
        "instrumental": {
          "icon": "🎹",
          "title": "Modalità strumentale",
          "desc": "Genera accompagnamenti strumentali di alta qualità, adatti per colonne sonore video, musica di sottofondo podcast e altro."
        },
        "fast": {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "Modelli AI avanzati assicurano rapida produzione musicale, la maggior parte della musica può essere generata entro 30 secondi."
        },
        "commercial": {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutta la musica generata può essere utilizzata per scopi commerciali, inclusi video, pubblicità, podcast e altro."
        }
      }
    },
    "faq": {
      "title": "Domande frequenti",
      "items": {
        "howItWorks": {
          "q": "Come funziona il generatore di musica AI?",
          "a": "Il nostro generatore di musica AI utilizza modelli di deep learning avanzati per creare musica originale basata sulle tue descrizioni testuali o testi. Inserisci semplicemente lo stile musicale, emozione e descrizione della scena, e AI composerà automaticamente un pezzo musicale completo."
        },
        "commercial": {
          "q": "La musica generata può essere utilizzata per scopi commerciali?",
          "a": "Sì, tutta la musica generata utilizzando la nostra piattaforma può essere utilizzata per scopi commerciali, inclusi video YouTube, pubblicità, podcast, giochi e altro."
        },
        "styles": {
          "q": "Quali stili musicali sono supportati?",
          "a": "Supportiamo Pop, Rock, Elettronica, Jazz, Classica, Hip-Hop, R&B, Country, Metal, Folk e dozzine di altri stili musicali. Puoi anche mescolare più stili per creare musica unica."
        },
        "credits": {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "A seconda del modello selezionato, ogni generazione costa 8-10 crediti. Puoi ottenere tariffe migliori attraverso piani di abbonamento."
        },
        "download": {
          "q": "Posso scaricare la musica generata?",
          "a": "Sì, la musica generata supporta entrambi i formati MP3 e WAV per il download. Puoi scegliere il formato appropriato in base alle tue esigenze."
        }
      }
    },
    "demoTracks": {
      "summerBreeze": {
        "title": "Brezza estiva",
        "style": "Pop / Allegra",
        "duration": "2:00"
      },
      "spaceJourney": {
        "title": "Viaggio spaziale",
        "style": "Elettronica / Futuristica",
        "duration": "1:30"
      },
      "rainWalk": {
        "title": "Passeggiata sotto la pioggia",
        "style": "Jazz / Rilassato",
        "duration": "2:30"
      },
      "mountainDawn": {
        "title": "Alba montana",
        "style": "Classica / Serena",
        "duration": "3:00"
      }
    }
  },
  "pricing": {
    "title": "Ispirazione illimitata, scegli il piano più adatto a te",
    "subtitle": "Sblocca tutti i modelli AI, genera in batch immagini, video e musica.",
    "promo": "Offerta a tempo limitato — Risparmia il 30% sui piani annuali",
    "monthly": "Mensile",
    "yearly": "Annuale",
    "yearlyNote": "Piano annuale — crediti consegnati in una volta, pagamento unico più economico",
    "popular": "Più popolare",
    "currentPlan": "Piano attuale",
    "currentPlanBtn": "Piano attuale",
    "upgrade": "Aggiorna",
    "unavailable": "Non disponibile",
    "upgradeSuccess": "Aggiornamento riuscito!",
    "upgradeFailed": "Aggiornamento fallito",
    "upgradeModal": {
      "title": "Conferma aggiornamento",
      "item1": "Addebiteremo la differenza di prezzo sulla tua carta.",
      "item2": "Dopo il pagamento riuscito, il saldo extra verrà aggiunto automaticamente.",
      "item3": "Il nuovo piano entra in vigore dopo il pagamento riuscito.",
      "tip": "Suggerimento: Assicurati che il tuo metodo di pagamento sia valido. Il saldo si aggiorna entro pochi secondi dopo il pagamento.",
      "cancel": "Annulla",
      "confirm": "Conferma aggiornamento"
    },
    "subscribe": "Abbonati ora",
    "processing": "Elaborazione...",
    "creditsPer": "crediti /",
    "extraCredits": "crediti extra",
    "creditsRate": "100 crediti = $",
    "perMonth": "mese",
    "perYear": "anno",
    "yearlyBilling": "Fatturazione annuale",
    "saveVsMonthly": "Risparmia vs mensile:",
    "planDesc": {
      "basic": "Perfetto per iniziare",
      "pro": "Il meglio per creatori e professionisti",
      "ultimate": "Per team e utenti avanzati"
    },
    "creditsPack": {
      "title": "Acquista pacchetto crediti",
      "subtitle": "Acquisto una tantum, nessun abbonamento",
      "buy": "Acquista crediti",
      "oneTime": "Acquisto una tantum",
      "permanent": "I crediti non scadono mai",
      "tip": "Suggerimento: Gli abbonamenti sono più convenienti",
      "tipItems": [
        "Tariffe crediti inferiori (risparmia 40-60%)",
        "15% di sconto su tutti i pacchetti crediti"
      ]
    },
    "security": {
      "noTraining": "Non utilizzato per formazione AI",
      "encrypted": "Archiviazione crittografata",
      "gdpr": "Conforme GDPR",
      "delete": "Cancellazione account self-service"
    },
    "dataSafety": "Scopri il nostro impegno per la sicurezza dei dati →",
    "allPlansInclude": "Tutti i piani includono",
    "includes": {
      "models": "Modelli AI premium",
      "fast": "Generazione rapida",
      "privacy": "100% privacy",
      "commercial": "Uso commerciale"
    },
    "creditsInfo": {
      "title": "Guida crediti",
      "subtitle": "Visualizza consumo crediti per tutti i modelli",
      "model": "Modello",
      "type": "Tipo",
      "cost": "Costo crediti",
      "speed": "Velocità",
      "image": "Immagine",
      "video": "Video"
    },
    "questions": "Domande?",
    "contact": "Serve aiuto?",
    "contactUs": "Contattaci",
    "faq": {
      "items": [
        {
          "q": "Cosa posso creare con i crediti?",
          "a": "I crediti possono essere utilizzati per generare immagini, video e musica AI. La generazione immagini parte da 2 crediti, la generazione video da 10 crediti e la musica da 10 crediti per brano. I modelli premium possono consumare più crediti."
        },
        {
          "q": "Posso cancellare in qualsiasi momento?",
          "a": "Sì, puoi cancellare il tuo abbonamento in qualsiasi momento. Puoi continuare a utilizzare il servizio fino alla fine del tuo periodo di fatturazione attuale."
        },
        {
          "q": "Cosa succede se finisco i crediti?",
          "a": "Puoi acquistare pacchetti crediti una tantum in qualsiasi momento (nessun abbonamento richiesto). Gli abbonati ricevono il 15% di sconto sui pacchetti crediti. Puoi anche aggiornare il tuo piano per tariffe migliori sulle quote mensili."
        },
        {
          "q": "Esiste una politica di rimborso?",
          "a": "Sì. Per i primi acquisti di pacchetti una tantum o primi abbonamenti, puoi richiedere un rimborso entro 7 giorni calendario se l'utilizzo dei crediti è inferiore al 3%."
        }
      ]
    }
  },
  "modelDetail": {
    "breadcrumb": {
      "home": "Home",
      "models": "Modelli"
    },
    "model": "Modello",
    "modelVersion": "Versione modello",
    "standard": "Standard",
    "pro": "Pro",
    "standardDesc": "Qualità standard, generazione rapida",
    "proDesc": "Alta qualità, supporta alta risoluzione",
    "credits": "crediti",
    "imagePrompt": "Prompt immagine",
    "imagePromptPlaceholder": "Descrivi l'immagine che desideri generare...",
    "videoPrompt": "Prompt video",
    "videoPromptPlaceholder": "Descrivi il video che desideri generare...",
    "referenceImage": "Immagine di riferimento",
    "aspectRatio": "Rapporto d'aspetto",
    "thinkingLevel": "Livello di ragionamento",
    "thinkingMinimal": "Bassa latenza",
    "thinkingHigh": "Alta fedeltà",
    "characters": "caratteri",
    "imageSize": "Dimensione immagine",
    "auto": "Auto",
    "resolution": "Risoluzione",
    "duration": "Durata",
    "seconds": "secondi",
    "creditsRequired": "Crediti richiesti:",
    "creditsRemaining": "Rimanenti:",
    "remaining": "Rimanenti:",
    "generate": "Genera",
    "getMoreCredits": "Ottieni più crediti",
    "generating": "Generazione...",
    "demoPrompt": "Prompt demo",
    "modelLabel": "Modello:",
    "version": "Versione:",
    "size": "Dimensione:",
    "download": "Scarica",
    "regenerate": "Rigenera",
    "noHistory": "Nessuna cronologia generazione",
    "features": {
      "badge": "Caratteristiche principali",
      "title": "Cosa può fare questo modello?",
      "items": {
        "realistic": {
          "icon": "📷",
          "title": "Stile realistico",
          "desc": "Genera immagini fotorealistiche con illuminazione naturale e dettagli."
        },
        "artistic": {
          "icon": "🎨",
          "title": "Stile artistico",
          "desc": "Crea immagini artistiche con vari stili di pittura."
        },
        "portrait": {
          "icon": "👤",
          "title": "Ritratto",
          "desc": "Fotografia ritrattistica professionale con tonalità della pelle naturali."
        },
        "landscape": {
          "icon": "🏔️",
          "title": "Paesaggio",
          "desc": "Fotografia paesaggistica e naturale stupenda."
        },
        "product": {
          "icon": "📦",
          "title": "Prodotto",
          "desc": "Fotografia prodotto di alta qualità per e-commerce."
        },
        "fast": {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "La maggior parte delle immagini generate entro 10-30 secondi."
        },
        "highRes": {
          "icon": "🖼️",
          "title": "Alta risoluzione",
          "desc": "Supporta output risoluzione fino a 4K."
        },
        "cinematic": {
          "icon": "🎬",
          "title": "Cinematico",
          "desc": "Crea video cinematografici con movimenti di camera professionali."
        },
        "audioSync": {
          "icon": "🔊",
          "title": "Sincronizzazione audio",
          "desc": "Sincronizzazione audio-video nativa per video."
        },
        "lipSync": {
          "icon": "👄",
          "title": "Sincronizzazione labiale",
          "desc": "Sincronizzazione labiale accurata per video personaggio."
        },
        "animation": {
          "icon": "🎭",
          "title": "Animazione",
          "desc": "Animazione personaggio fluida e movimento."
        },
        "longVideo": {
          "icon": "⏱️",
          "title": "Video lungo",
          "desc": "Supporto per durate video più lunghe."
        },
        "privacy": {
          "icon": "🔒",
          "title": "Privacy e sicurezza",
          "desc": "Tutti i dati sono crittografati durante il transito e non utilizzati per la formazione AI. Le tue creazioni ti appartengono."
        }
      }
    },
    "whyChoose": {
      "items": [
        "Creazione intelligente alimentata da {name}",
        "Completa rapidamente compiti creativi complessi in modo efficiente",
        "Il contenuto generato può essere utilizzato commercialmente",
        "Aggiornamenti continui e capacità in miglioramento",
        "Sistema crediti unificato, paga per consumo"
      ]
    },
    "faq": {
      "title": "Domande frequenti",
      "imageType": "immagini",
      "videoType": "video",
      "imageFormats": "Formati di output PNG, JPEG e WebP sono supportati; scegli cosa si adatta al tuo flusso di lavoro.",
      "videoFormats": "I video sono forniti come MP4 con opzioni 480p e 720p e più aspect ratio.",
      "items": [
        {
          "q": "Come funziona {name}?",
          "a": "Carica un riferimento o inserisci un prompt testuale — {name} genera {type} di alta qualità basato sul tuo input. Il processo è semplice e non richiede competenze esperte."
        },
        {
          "q": "Posso usare {type} generati commercialmente?",
          "a": "Sì. Il contenuto da {name} può essere usato commercialmente, inclusi marketing, social media e uso prodotto."
        },
        {
          "q": "Quanti crediti per generazione?",
          "a": "Ogni generazione con {name} usa {credits} crediti. Gli abbonati ottengono tariffe crediti migliori."
        },
        {
          "q": "Quanto è veloce la generazione?",
          "a": "La velocità tipica per {name} è {speed}. Manteniamo l'ottimizzazione per risultati affidabili e veloci."
        },
        {
          "q": "Quali formati di output sono supportati?",
          "a": ""
        }
      ]
    },
    "qwenImage20Pro": {
      "negativePromptLabel": "Prompt negativo (opzionale)",
      "negativePromptPlaceholder": "Descrivi ciò che non vuoi vedere (ad es.: bassa nitidezza, mani deformi, ecc.)",
      "customWidth": "Larghezza",
      "customHeight": "Altezza",
      "sizeHint": "Intervallo: 512×512 fino a 2048×2048",
      "sizeErrorRequired": "Inserisci larghezza e altezza",
      "sizeErrorInteger": "Larghezza e altezza devono essere interi",
      "sizeErrorRange": "La risoluzione deve essere compresa tra 512×512 e 2048×2048",
      "promptEnhanceTitle": "Miglioramento del prompt",
      "promptEnhanceDesc": "Migliora i dettagli del prompt per ottenere risultati più ricchi",
      "watermarkTitle": "Filigrana",
      "watermarkDesc": "Aggiunge una filigrana alle immagini generate",
      "demoPromptText": "Tra montagne innevate, un bambino con tuta da sci e occhiali scivola felicemente sugli sci; fiocchi di neve si sollevano lungo la scia, dietro di lui si estendono creste coperte di neve.",
      "faqSizeSupportQ": "Quali risoluzioni sono supportate?",
      "faqSizeSupportA": "Inserisci larghezza e altezza nell'intervallo 512~2048 (ad es.: 2048*2048).",
      "faqMaxCountQ": "Quante immagini si possono generare al massimo in una sola richiesta?",
      "faqMaxCountA": "Fino a 4 immagini (n=1..4).",
      "faqLinkUsageQ": "Come si usano i link delle immagini dopo la generazione?",
      "faqLinkUsageA": "Scarica prima l'URL temporaneo restituito da DashScope, poi caricalo sul nostro server e restituisci un URL accessibile a lungo."
    },
    "zImageTurbo": {
      "promptExtendTitle": "Miglioramento del prompt",
      "promptExtendDesc": "Migliora i dettagli del prompt per ottenere risultati più ricchi",
      "customWidth": "Larghezza",
      "customHeight": "Altezza",
      "sizeHint": "Intervallo: 512×512 fino a 2048×2048",
      "sizeErrorRequired": "Inserisci larghezza e altezza",
      "sizeErrorInteger": "Larghezza e altezza devono essere interi",
      "sizeErrorRange": "La risoluzione deve essere compresa tra 512×512 e 2048×2048",
      "seedLabel": "Seed",
      "seedErrorRequired": "Inserisci una seed",
      "seedErrorInteger": "La seed deve essere un intero",
      "seedErrorRange": "La seed deve essere compresa tra 0 e 2147483647",
      "tagQuality": "Alta qualità",
      "tagOfficial": "Ufficiale diretto",
      "tagHighRes": "Alta risoluzione",
      "tagSeed": "Controllo seed",
      "tagPromptExtend": "Miglioramento del prompt",
      "feature1Title": "Output di alta qualità",
      "feature1Desc": "Genera immagini ad alta risoluzione e caricale per ottenere URL accessibili a lungo termine.",
      "feature2Title": "Risoluzione personalizzata",
      "feature2Desc": "Inserisci larghezza e altezza nel range 512–2048.",
      "feature3Title": "Generazione controllabile",
      "feature3Desc": "Supporta seed e miglioramento del prompt per riproducibilità e tuning.",
      "demoPromptText": "Su una sabbia dorata fine, una fila netta di impronte si perde in profondità nell'inquadratura; ai bordi la sabbia umida, la superficie luccica al sole e conduce verso un faro lontano.",
      "faqSizeSupportQ": "Quali risoluzioni sono supportate?",
      "faqSizeSupportA": "Inserisci larghezza e altezza nell'intervallo 512~2048 (ad es.: 1024*1536).",
      "faqSeedQ": "A cosa serve il seed?",
      "faqSeedA": "Con lo stesso prompt e parametri, il seed aiuta a riprodurre risultati simili.",
      "faqPromptExtendQ": "Cos'è il miglioramento del prompt?",
      "faqPromptExtendA": "Quando attivo, migliora i dettagli del prompt per ottenere risultati più ricchi."
    }
  },
  "modelIntro": {
    "common": {
      "videoMode": "Modalità video",
      "textToVideo": "Testo in video",
      "imageToVideo": "Immagine in video",
      "referenceImage": "Immagine di riferimento",
      "referenceAudio": "Audio di riferimento",
      "negativePrompt": "Prompt negativo",
      "duration": "Durata",
      "resolution": "Risoluzione",
      "aspectRatio": "Proporzioni",
      "seed": "Seed",
      "generateAudio": "Genera audio",
      "watermark": "Aggiungi filigrana",
      "endFrame": "Frame finale",
      "promptEnhance": "Migliora prompt",
      "promptExtend": "Estendi prompt",
      "imageSize": "Dimensione immagine",
      "imageCount": "Numero di immagini",
      "style": "Stile",
      "sizeMode": "Modalità dimensione",
      "width": "Larghezza",
      "height": "Altezza",
      "optional": "Opzionale",
      "uploading": "Caricamento...",
      "clickToUpload": "Clicca per caricare",
      "quality": "Qualità",
      "qualityAuto": "Auto",
      "qualityLow": "Bassa",
      "qualityMedium": "Media",
      "qualityHigh": "Alta",
      "multipleOf64Hint": "Larghezza e altezza devono essere multipli di 64."
    },
    "seegen": {
      "aspectAdaptive": "Auto",
      "genMode": "Modalità di generazione",
      "modeStand": "Standard",
      "modeSpeed": "Veloce"
    },
    "pollodance": {
      "variantLabel": "Variante modello",
      "card20": "2.0",
      "card20Fast": "2.0 FAST",
      "card20Ref": "2.0 REF",
      "card20FastRef": "2.0 FAST REF",
      "opt20Desc": "Controllo del movimento avanzato, trasferimento di stile cinematografico e generazione industriale.",
      "opt20FastDesc": "Generazione ad alta velocità e bassa latenza.",
      "opt20RefDesc": "Riferimenti tra video, trasferimento di stile e tracking del soggetto.",
      "opt20FastRefDesc": "Velocità e riferimenti precisi.",
      "refImages": "Immagini di riferimento (più file)",
      "refVideo": "Video di riferimento",
      "refAudio": "Audio di riferimento",
      "webSearch": "Ricerca web"
    },
    "nanoBanana": {
      "version": "Versione del modello",
      "title": "Generatore di immagini AI Nano Banana Pro",
      "desc": "Nano Banana è un modello di generazione di immagini AI ad alte prestazioni che supporta la generazione di immagini in stile realistico, eccellendo nei ritratti e nelle scene naturali. Disponibile nelle versioni Standard e Pro per soddisfare diverse esigenze.",
      "v25Type": "Bassa latenza",
      "v25TypeBadge": "Rapido",
      "v25TypeDesc": "Risoluzione fissa 1024px, velocità di generazione rapida",
      "v31Type": "Alta fedeltà",
      "v31TypeBadge": "Alta qualità",
      "v31TypeDesc": "Supporta risoluzioni multiple 1K/2K/4K",
      "demoPrompt": "Ritratto cinematografico, luce dell'ora dorata, texture della pelle naturale, sfondo bokeh morbido",
      "multiSize": "Dimensioni multiple",
      "multiSizeDesc": "Supporta auto, 1:1, 4:3, 3:4, 16:9, 9:16, 3:2, 2:3 e altre dimensioni immagine.",
      "featuresDesc": "Nano Banana fornisce capacità di generazione immagini di alta qualità con più opzioni di dimensione e risoluzione.",
      "flexiblePricing": "Prezzi flessibili",
      "flexiblePricingDesc": "Standard 5 crediti, Pro 20 crediti, scegli come necessario.",
      "commercial": "Licenza commerciale",
      "commercialDesc": "Tutte le immagini generate possono essere utilizzate per scopi commerciali.",
      "enterPrompt": "Inserisci un prompt",
      "generateFailed": "Generazione fallita",
      "requestFailed": "Richiesta fallita, riprova",
      "faq": [
        {
          "q": "Qual è la differenza tra le versioni Standard e Pro?",
          "a": "La versione Standard è adatta per generazione rapida di immagini di qualità standard, consumando 5 crediti. La versione Pro supporta risoluzioni più elevate (1K/2K/4K) con qualità immagine superiore, consumando 20 crediti."
        },
        {
          "q": "Come funziona Nano Banana?",
          "a": "Basta inserire una descrizione testuale e il modello Nano Banana genererà immagini in stile realistico di alta qualità basate sul tuo prompt."
        },
        {
          "q": "Quali dimensioni immagine sono supportate?",
          "a": "Supporta auto, 1:1 (quadrato), 4:3, 3:4, 16:9 (orizzontale), 9:16 (verticale), 3:2, 2:3 e altre dimensioni."
        },
        {
          "q": "Le immagini generate possono essere utilizzate commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando Nano Banana possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "nanoBanana2": {
      "genType": "Versione di generazione"
    },
    "seedream": {
      "title": "Generatore di immagini AI Seedream 4",
      "desc": "Seedream 4 è un modello di generazione immagini AI avanzato specializzato in immagini artistiche e creative. Perfetto per illustrazioni, concept art e visual stilizzati.",
      "webSearch": "Ricerca web",
      "webSearchDesc": "Abilita la ricerca web per informazioni di riferimento più accurate",
      "watermark": "Aggiungi watermark",
      "watermarkDesc": "Aggiungi watermark alle immagini generate",
      "sizeModeResolution": "Per risoluzione",
      "sizeModeCustom": "Dimensione personalizzata",
      "customWidth": "Larghezza",
      "customHeight": "Altezza",
      "sizeHint": "Area 1024×1024–4096×4096, aspect ratio 1/16–16",
      "sizeErrorArea": "L'area deve essere tra 1024×1024 e 4096×4096",
      "sizeErrorRatio": "L'aspect ratio deve essere tra 1/16 e 16",
      "demoPromptExample": "La luce laterale del pomeriggio illumina la tenda da campeggio, con la texture ruvida della tela della tenda chiaramente visibile. Un pastore tedesco giace all'interno; il suo proprietario si accovaccia per stringergli la mano.",
      "features": [
        {
          "icon": "🎨",
          "title": "Stile artistico",
          "desc": "Genera immagini artistiche stupende con vari stili di pittura e illustrazione."
        },
        {
          "icon": "🖼️",
          "title": "Alta risoluzione",
          "desc": "Supporta fino a risoluzione 4K per artwork dettagliati."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "La maggior parte delle immagini generate entro 15 secondi."
        },
        {
          "icon": "🎭",
          "title": "Trasferimento stile",
          "desc": "Applica vari stili artistici alle tue creazioni."
        },
        {
          "icon": "📐",
          "title": "Dimensioni multiple",
          "desc": "Supporta vari aspect ratio per diverse esigenze."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutte le immagini generate possono essere utilizzate per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Seedream 4 è migliore per cosa?",
          "a": "Seedream 4 eccelle nella generazione di immagini artistiche e creative, incluse illustrazioni, concept art e visual stilizzati."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Utilizzare Seedream 4 costa 8 crediti per generazione. Puoi ottenere tariffe crediti migliori attraverso piani di abbonamento."
        },
        {
          "q": "Quali stili sono supportati?",
          "a": "Seedream 4 supporta vari stili artistici inclusi pittura a olio, acquerello, arte digitale, anime e altro."
        },
        {
          "q": "Le immagini generate possono essere utilizzate commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando Seedream 4 possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "midjourney": {
      "title": "Generatore di immagini AI Midjourney",
      "desc": "Midjourney è un modello di generazione immagini AI leader noto per la sua eccezionale qualità artistica e capacità creative. Perfetto per artwork professionale e progetti creativi.",
      "referenceBoxTitle": "Aggiungi immagini di riferimento per immagine-immagine",
      "referenceBoxSubtitle": "Supporta PNG, JPEG, WEBP (max 100KB). Fino a 5 immagini. Meno immagini, risultati più precisi.",
      "demoPrompt": "Un'isola mistica fluttuante nel cielo, antiche rovine coperte di cristalli luminosi, cascate che scorrono nelle nuvole sottostanti, illuminazione eterea, stile fantasy art",
      "referenceImages": "Immagini di riferimento",
      "referenceImagesCount": "Fino a 5",
      "refImageMaxSize": "Ogni immagine non deve superare 100KB",
      "style": "Stile",
      "styleRealistic": "Realistico",
      "styleAnime": "Anime",
      "generationSpeed": "Velocità generazione",
      "fastDesc": "Generazione velocità standard",
      "turboDesc": "Generazione rapida, elaborazione prioritaria",
      "creative": "Creativo",
      "highQuality": "Alta qualità",
      "fastTurbo": "Fast/Turbo",
      "creativeGeneration": "Generazione creativa",
      "speed": "Velocità",
      "features": [
        {
          "icon": "🎨",
          "title": "Eccellenza artistica",
          "desc": "Qualità artistica e output creativi leader del settore."
        },
        {
          "icon": "🖼️",
          "title": "Alta risoluzione",
          "desc": "Genera immagini di alta qualità adatte per uso professionale."
        },
        {
          "icon": "🎭",
          "title": "Stili unici",
          "desc": "Stili artistici distinti che distinguono il tuo lavoro."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "La maggior parte delle immagini generate entro 20 secondi."
        },
        {
          "icon": "📐",
          "title": "Dimensioni multiple",
          "desc": "Supporta vari aspect ratio e risoluzioni."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutte le immagini generate possono essere utilizzate per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Qual è la differenza tra Fast e Turbo?",
          "a": "La modalità Fast costa 10 crediti con velocità standard. La modalità Turbo costa 20 crediti con generazione più rapida ed elaborazione prioritaria."
        },
        {
          "q": "Come funziona Midjourney?",
          "a": "Basta inserire una descrizione testuale e Midjourney genererà immagini artistiche basate sul tuo prompt."
        },
        {
          "q": "Quali dimensioni immagine sono supportate?",
          "a": "Supporta 1:1 (quadrato), 4:3, 3:4, 16:9 (orizzontale), 9:16 (verticale), 3:2, 2:3 e altre dimensioni."
        },
        {
          "q": "Le immagini generate possono essere utilizzate commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando Midjourney possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "gptImage": {
      "title": "Generatore di immagini AI GPT-Image-1",
      "desc": "GPT-Image-1 è il modello di generazione immagini versatile di OpenAI, capace di creare una vasta gamma di immagini da descrizioni testuali. Ottimo per generazione immagini multiuso.",
      "demoPromptExample": "Campi toscani al tramonto, colline ondulate coperte di grano dorato, cipressi e una fattoria di pietra antica in lontananza, il tramonto che tinge il cielo di un bagliore rosso caldo, caldo, curativo, fotografia paesaggistica, golden hour.",
      "imageCount": "Numero immagini",
      "promptEnhance": "Migliora prompt",
      "promptEnhanceDesc": "Ottimizza automaticamente i prompt per risultati di generazione migliori",
      "count": "Conteggio",
      "multiPurpose": "Multiuso",
      "batchGeneration": "Generazione batch",
      "size1024Square": "1024×1024 (quadrato)",
      "size1536Landscape": "1536×1024 (orizzontale)",
      "size1024Portrait": "1024×1536 (verticale)",
      "threeSizes": "Tre dimensioni fisse",
      "tagQuality": "Alta qualità",
      "tagCommercialShort": "Uso commerciale",
      "features": [
        {
          "icon": "🎨",
          "title": "Generazione versatile",
          "desc": "Crea una vasta gamma di immagini per qualsiasi scopo."
        },
        {
          "icon": "🖼️",
          "title": "Alta qualità",
          "desc": "Genera immagini di alta qualità con dettagli accurati."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "La maggior parte delle immagini generate entro 15 secondi."
        },
        {
          "icon": "📝",
          "title": "Comprensione testo",
          "desc": "Eccellente comprensione di descrizioni testuali complesse."
        },
        {
          "icon": "📐",
          "title": "Tre dimensioni fisse",
          "desc": "1024×1024 (quadrato), 1536×1024 (orizzontale), 1024×1536 (verticale)."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutte le immagini generate possono essere utilizzate per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Come funziona GPT-Image-1?",
          "a": "Basta inserire una descrizione testuale e GPT-Image-1 genererà immagini di alta qualità basate sul tuo prompt."
        },
        {
          "q": "Quali dimensioni immagine sono supportate?",
          "a": "Supporta tre dimensioni fisse: 1024×1024 (quadrato), 1536×1024 (orizzontale) e 1024×1536 (verticale)."
        },
        {
          "q": "Le immagini generate possono essere utilizzate commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando GPT-Image-1 possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "gptImage15": {
      "title": "Generatore di immagini AI GPT-Image-1.5",
      "desc": "GPT-Image-1.5 è il modello di generazione immagini versatile di OpenAI, capace di creare una vasta gamma di immagini da descrizioni testuali. Ottimo per generazione immagini multiuso.",
      "demoPromptExample": "Campi toscani al tramonto, colline ondulate coperte di grano dorato, cipressi e una fattoria di pietra antica in lontananza, il tramonto che tinge il cielo di un bagliore rosso caldo, caldo, curativo, fotografia paesaggistica, golden hour.",
      "imageCount": "Numero immagini",
      "promptEnhance": "Migliora prompt",
      "promptEnhanceDesc": "Ottimizza automaticamente i prompt per risultati di generazione migliori",
      "count": "Conteggio",
      "multiPurpose": "Multiuso",
      "batchGeneration": "Generazione batch",
      "size1024Square": "1024×1024 (quadrato)",
      "size1536Landscape": "1536×1024 (orizzontale)",
      "size1024Portrait": "1024×1536 (verticale)",
      "threeSizes": "Tre dimensioni fisse",
      "tagQuality": "Alta qualità",
      "tagCommercialShort": "Uso commerciale",
      "features": [
        {
          "icon": "🎨",
          "title": "Generazione versatile",
          "desc": "Crea una vasta gamma di immagini per qualsiasi scopo."
        },
        {
          "icon": "🖼️",
          "title": "Alta qualità",
          "desc": "Genera immagini di alta qualità con dettagli accurati."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "La maggior parte delle immagini generate entro 15 secondi."
        },
        {
          "icon": "📝",
          "title": "Comprensione testo",
          "desc": "Eccellente comprensione di descrizioni testuali complesse."
        },
        {
          "icon": "📐",
          "title": "Tre dimensioni fisse",
          "desc": "1024×1024 (quadrato), 1536×1024 (orizzontale), 1024×1536 (verticale)."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutte le immagini generate possono essere utilizzate per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Come funziona GPT-Image-1.5?",
          "a": "Basta inserire una descrizione testuale e GPT-Image-1.5 genererà immagini di alta qualità basate sul tuo prompt."
        },
        {
          "q": "Quali dimensioni immagine sono supportate?",
          "a": "Supporta tre dimensioni fisse: 1024×1024 (quadrato), 1536×1024 (orizzontale) e 1024×1536 (verticale)."
        },
        {
          "q": "Le immagini generate possono essere utilizzate commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando GPT-Image-1.5 possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "fluxKontext": {
      "title": "Generatore di immagini AI Flux Kontext",
      "desc": "Una giovane donna seduta su un tetto al golden hour, indossa una giacca in denim oversize, cuffie bianche al collo, sorseggiando caffè ghiacciato da una tazza di plastica trasparente. I suoi capelli corti ricci soffiano leggermente nel vento mentre le luci della città iniziano a brillare in lontananza.",
      "imageCount": "Numero immagini",
      "count": "Conteggio",
      "demoPrompt1": "Una giovane donna seduta su un tetto al golden hour, indossa una giacca in denim oversize, cuffie bianche al collo, sorseggiando caffè ghiacciato da una tazza di plastica trasparente. I suoi capelli corti ricci soffiano leggermente nel vento mentre le luci della città iniziano a brillare in lontananza.",
      "demoPrompt2": "Un uomo sui vent'anni seduto sul pavimento di uno studio d'arte disordinato, circondato da tele incompiute e tubi di vernice. Indossa una canotta bianca macchiata di colore e jeans strappati.",
      "demoPrompt3": "Una giovane madre che aggiusta il berretto del suo bambino seduta su una coperta picnic. Indossa un maglione crema e una gonna in velluto a coste lunghe, a piedi nudi sull'erba.",
      "highQuality": "Alta qualità",
      "fastGen": "Generazione rapida",
      "multiSize": "Dimensioni multiple",
      "outputStyle": "Stile output",
      "outputStyleDesc": {
        "auto": "Predefinito - il modello determina automaticamente lo stile, nessun aspetto forzato",
        "photographic": "Fotografico - foto realistiche, luce e ombre naturali",
        "digital_art": "Arte digitale - aspetto CG/illustrazione, colori vividi e ricchi",
        "anime": "Anime - stile anime/cartoon giapponese, linee pulite"
      },
      "outputStyleLabel": {
        "auto": "Predefinito",
        "photographic": "Fotografico",
        "digital_art": "Arte digitale",
        "anime": "Anime"
      },
      "features": [
        {
          "icon": "✨",
          "title": "Output alta qualità",
          "desc": "Genera immagini dettagliate e ad alta fedeltà."
        },
        {
          "icon": "🎨",
          "title": "Testo a immagine",
          "desc": "Genera accuratamente immagini da descrizioni testuali."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "La maggior parte delle immagini completa in circa 15 secondi."
        },
        {
          "icon": "📐",
          "title": "Dimensioni multiple",
          "desc": "Supporto per 1:1, 3:2, 2:3 aspect ratio."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Le immagini generate possono essere utilizzate per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Come funziona Flux Kontext?",
          "a": "Inserisci una descrizione testuale; Flux Kontext genera immagini di alta qualità e supporta singole o più immagini per richiesta."
        },
        {
          "q": "Quali dimensioni immagine sono supportate?",
          "a": "Supporta 1:1 (quadrato), 3:2 (orizzontale), 2:3 (verticale)."
        },
        {
          "q": "Posso generare più immagini contemporaneamente?",
          "a": "Sì, puoi generare 1–3 immagini, ognuna fatturata separatamente."
        },
        {
          "q": "Le immagini generate possono essere utilizzate commercialmente?",
          "a": "Sì, i contenuti generati con Flux Kontext possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "fluxPro11Ultra": {
      "title": "Generatore di immagini AI Flux Pro 1.1 Ultra",
      "desc": "Flux Pro 1.1 Ultra per testo-immagine di alta qualità con più aspect ratio e generazione batch.",
      "imageCount": "Numero immagini",
      "count": "Conteggio",
      "demoPrompt1": "Una giovane donna seduta su un tetto al golden hour, indossa una giacca in denim oversize, cuffie bianche al collo, sorseggiando caffè ghiacciato da una tazza di plastica trasparente. I suoi capelli corti ricci soffiano leggermente nel vento mentre le luci della città iniziano a brillare in lontananza.",
      "demoPrompt2": "Un uomo sui vent'anni seduto sul pavimento di uno studio d'arte disordinato, circondato da tele incompiute e tubi di vernice. Indossa una canotta bianca macchiata di colore e jeans strappati.",
      "demoPrompt3": "Una giovane madre che aggiusta il berretto del suo bambino seduta su una coperta picnic. Indossa un maglione crema e una gonna in velluto a coste lunghe, a piedi nudi sull'erba.",
      "highQuality": "Alta qualità",
      "fastGen": "Generazione rapida",
      "multiSize": "Dimensioni multiple",
      "outputStyle": "Stile output",
      "outputStyleDesc": {
        "auto": "Predefinito - il modello determina automaticamente lo stile, nessun aspetto forzato",
        "photographic": "Fotografico - foto realistiche, luce e ombre naturali",
        "digital_art": "Arte digitale - aspetto CG/illustrazione, colori vividi e ricchi",
        "anime": "Anime - stile anime/cartoon giapponese, linee pulite"
      },
      "outputStyleLabel": {
        "auto": "Predefinito",
        "photographic": "Fotografico",
        "digital_art": "Arte digitale",
        "anime": "Anime"
      },
      "features": [
        {
          "icon": "✨",
          "title": "Output alta qualità",
          "desc": "Genera immagini dettagliate e ad alta fedeltà."
        },
        {
          "icon": "🎨",
          "title": "Testo a immagine",
          "desc": "Genera accuratamente immagini da descrizioni testuali."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "La maggior parte delle immagini completa in circa 15 secondi."
        },
        {
          "icon": "📐",
          "title": "Dimensioni multiple",
          "desc": "Supporto per 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Le immagini generate possono essere utilizzate per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Come funziona Flux Pro 1.1 Ultra?",
          "a": "Inserisci una descrizione testuale per generare immagini di alta qualità; supporta 1–4 immagini per richiesta."
        },
        {
          "q": "Quali dimensioni immagine sono supportate?",
          "a": "Supporta 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "q": "Posso generare più immagini contemporaneamente?",
          "a": "Sì, puoi generare 1–4 immagini, ognuna fatturata separatamente."
        },
        {
          "q": "Le immagini generate possono essere utilizzate commercialmente?",
          "a": "Sì, i contenuti possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "fluxSchnell": {
      "title": "Generatore di immagini AI Flux Schnell",
      "desc": "Flux Schnell per testo-immagine rapido con più aspect ratio e generazione batch.",
      "imageCount": "Numero immagini",
      "count": "Conteggio",
      "demoPrompt1": "Una giovane donna seduta su un tetto al golden hour, indossa una giacca in denim oversize, cuffie bianche al collo, sorseggiando caffè ghiacciato da una tazza di plastica trasparente. I suoi capelli corti ricci soffiano leggermente nel vento mentre le luci della città iniziano a brillare in lontananza.",
      "demoPrompt2": "Un uomo sui vent'anni seduto sul pavimento di uno studio d'arte disordinato, circondato da tele incompiute e tubi di vernice. Indossa una canotta bianca macchiata di colore e jeans strappati.",
      "demoPrompt3": "Una giovane madre che aggiusta il berretto del suo bambino seduta su una coperta picnic. Indossa un maglione crema e una gonna in velluto a coste lunghe, a piedi nudi sull'erba.",
      "highQuality": "Alta qualità",
      "fastGen": "Generazione rapida",
      "multiSize": "Dimensioni multiple",
      "outputStyle": "Stile output",
      "outputStyleDesc": {
        "auto": "Predefinito - il modello determina automaticamente lo stile, nessun aspetto forzato",
        "photographic": "Fotografico - foto realistiche, luce e ombre naturali",
        "digital_art": "Arte digitale - aspetto CG/illustrazione, colori vividi e ricchi",
        "anime": "Anime - stile anime/cartoon giapponese, linee pulite"
      },
      "outputStyleLabel": {
        "auto": "Predefinito",
        "photographic": "Fotografico",
        "digital_art": "Arte digitale",
        "anime": "Anime"
      },
      "features": [
        {
          "icon": "✨",
          "title": "Output alta qualità",
          "desc": "Genera immagini dettagliate e ad alta fedeltà."
        },
        {
          "icon": "🎨",
          "title": "Testo a immagine",
          "desc": "Genera accuratamente immagini da descrizioni testuali."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "La maggior parte delle immagini completa in circa 15 secondi."
        },
        {
          "icon": "📐",
          "title": "Dimensioni multiple",
          "desc": "Supporto per 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Le immagini generate possono essere utilizzate per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Come funziona Flux Schnell?",
          "a": "Inserisci una descrizione testuale per generare rapidamente immagini di alta qualità; supporta 1–4 immagini per richiesta."
        },
        {
          "q": "Quali dimensioni immagine sono supportate?",
          "a": "Supporta 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "q": "Posso generare più immagini contemporaneamente?",
          "a": "Sì, puoi generare 1–4 immagini, ognuna fatturata separatamente."
        },
        {
          "q": "Le immagini generate possono essere utilizzate commercialmente?",
          "a": "Sì, i contenuti possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "flux2": {
      "title": "Generatore di immagini IA FLUX.2",
      "desc": "FLUX.2 offre efficienza aziendale e precisione professionale per la generazione di immagini da testo con dettagli fotorrealistici.",
      "variantLabel": "Variante del modello",
      "variantDesc": {
        "klein-04": "Tempo reale",
        "klein-09": "Equilibrato",
        "max": "Massima qualità",
        "pro": "Produzione",
        "flex": "Personalizzabile"
      },
      "promptUpsampling": "Upsampling del prompt",
      "promptUpsamplingHint": "Migliora i dettagli del prompt per un output più ricco (non disponibile per Klein).",
      "steps": "Passaggi",
      "stepsHint": "Più passaggi = più dettagli ma più lento. Solo variante Flex.",
      "guidance": "Guidance",
      "guidanceHint": "Controlla la fedeltà al prompt. Solo variante Flex.",
      "tagPhotorealism": "Fotorrealismo",
      "tagMultilingual": "Multilingue",
      "tagVariants": "5 Varianti",
      "demoPrompt1": "A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.",
      "features": [
        { "icon": "✨", "title": "Dettagli fotorrealistici", "desc": "Mani, volti, tessuti, loghi e oggetti piccoli precisi fino a 4MP." },
        { "icon": "🎨", "title": "Tipografia e design", "desc": "Rendering di tipografia chiara e leggibile, rispetto di istruzioni di layout complesse." },
        { "icon": "🌍", "title": "Multilingue", "desc": "Supporto nativo di prompt nella tua lingua con comprensione avanzata delle istruzioni." },
        { "icon": "🎯", "title": "5 varianti", "desc": "Klein 4B/9B (velocità), Max (qualità), Pro (produzione), Flex (controllo personalizzato)." },
        { "icon": "⚙️", "title": "Controllo flessibile", "desc": "Passaggi, guidance, dimensione e tolleranza di sicurezza regolabili." }
      ],
      "faq": [
        { "q": "Quali sono le varianti FLUX.2?", "a": "FLUX.2 offre 5 varianti: Klein 4B e 9B (veloce), Max (massima qualità con ricerca), Pro (produzione), Flex (passaggi e guidance regolabili)." },
        { "q": "Quali dimensioni immagine supporta?", "a": "FLUX.2 usa dimensioni in pixel (larghezza x altezza), multipli di 16. Preset: 1:1, 4:3, 3:4, 16:9, 9:16, 21:9, 9:21." },
        { "q": "Cos'è l'upsampling del prompt?", "a": "Attiva il miglioramento interno del prompt per maggiori dettagli. Disponibile per Max, Pro e Flex (non Klein)." },
        { "q": "Cosa sono passaggi e guidance in modalità Flex?", "a": "Passaggi (1-50): qualità di inferenza, più alto = più dettagli. Guidance (1.5-10): fedeltà al prompt, più alto = più vicino alla descrizione." },
        { "q": "Le immagini possono essere usate commercialmente?", "a": "Sì, i contenuti generati possono essere usati a scopi commerciali." }
      ]
    },
    "seedance": {
      "title": "Generatore di video AI Seedance",
      "desc": "Seedance è un modello video AI di nuova generazione che supporta sincronizzazione audio-video nativa, movimento cinematografico ed espressione emotiva. Copre modalità testo-video, immagine-video ed estensione video, video e audio generati in sincronia, assicurando che scena, dialogo e suono ambientale si adattino perfettamente.",
      "textToVideo": "Testo a video",
      "imageToVideo": "Immagine a video",
      "videoExtend": "Estensione video",
      "uploadImage": "Clicca per caricare immagine di riferimento",
      "uploadHint": "PNG, JPG, JPEG (max 20MB)",
      "endFrame": "Immagine frame finale",
      "endFrameHint": "(Opzionale) Carica immagine frame finale per controllare la fine del video",
      "uploadEndFrame": "Clicca per caricare immagine frame finale",
      "uploadVideo": "Clicca per caricare video di riferimento",
      "uploadVideoHint": "MP4, MOV, WebM (max 100MB)",
      "videoPrompt": "Prompt video",
      "promptPlaceholder": "Descrivi il video che desideri generare...",
      "videoPromptPlaceholder": "Descrivi il video che desideri generare...",
      "negativePrompt": "Prompt negativo",
      "negativePromptPlaceholder": "Descrivi ciò che non vuoi nel video (opzionale)",
      "duration": "Durata",
      "videoDuration": "Durata video",
      "resolution": "Risoluzione",
      "aspectRatio": "Aspect ratio",
      "promptEnhance": "Migliora prompt",
      "promptEnhanceDesc": "Ottimizza automaticamente i prompt per risultati di generazione migliori",
      "generateAudio": "Genera audio",
      "audioOn": "Audio nativo (voce + effetti sonori)",
      "audioOff": "Solo video, nessun audio",
      "seedValue": "Valore seed",
      "seedHint": "Il valore seed è l'identificatore unico dello stile generale. Usando lo stesso seed mantiene lo stile consistente, mentre la messa a punto di altri parametri aiuta a raffinare i dettagli visivi.",
      "seedPlaceholder": "-1 (casuale)",
      "characters": "caratteri",
      "creditsRequired": "Crediti richiesti:",
      "creditsRemaining": "Rimanenti:",
      "generate": "Genera",
      "generating": "Generazione...",
      "demoPrompt": "Prompt demo",
      "demoPromptExample": "Un piccolo gattino bianco soffice e carino balla felicemente sulle punte, il suo corpo soffice dondola dolcemente con minuscole zampe rosa sollevate. Su un tappeto morbido sotto luce giallo calda, stile cartoon curativo, dettagli squisiti, colori soffici e delicati.",
      "modelLabel": "Modello:",
      "durationLabel": "Durata:",
      "techSpecsTitle": "Specifiche tecniche",
      "techSpecsDesc": "Seedance supporta sincronizzazione audio-video nativa, movimento cinematografico ed espressione emotiva. Copre modalità testo-video, immagine-video ed estensione video.",
      "t2vTitle": "Testo a video (T2V)",
      "t2vDesc": "Trasforma i prompt in scene video cinematografiche",
      "i2vTitle": "Immagine a video (I2V)",
      "i2vDesc": "Anima una singola immagine usando AI",
      "input": "Input:",
      "textPrompt": "Prompt testuale",
      "imagePrompt": "Immagine + prompt",
      "audio": "Audio:",
      "nativeAudio": "Generazione audio nativa",
      "bestFor": "Il migliore per:",
      "t2vBestFor": "Perfetto per creazione contenuti cinematografici, pubblicità e video social media.",
      "i2vBestFor": "Il migliore per animazione ritratti, showcase prodotti e contenuti creativi.",
      "featuresDesc": "Che tu sia un designer, un marketer, un content creator o un utente occasionale, Seedance ti aiuta a creare rapidamente contenuti AI di alta qualità.",
      "features": [
        {
          "icon": "🎬",
          "title": "Generazione audio-video nativa",
          "desc": "Genera sincronamente video e audio in una volta, fornendo qualità cinematografica. Sincronizzazione labiale naturale e doppiaggio dialoghi."
        },
        {
          "icon": "😊",
          "title": "Sistema espressione emotiva",
          "desc": "Nuova consapevolezza delle espressioni per espressioni facciali più realistiche. Sottiglie espressioni includono esitazione, tristezza, tensione o ritenuto emotivo."
        },
        {
          "icon": "🎥",
          "title": "Controllo camera livello regista",
          "desc": "Supporta movimenti camera push, pull, pan, orbit e tracking. Guida primo e ultimo frame per transizioni fluide."
        },
        {
          "icon": "📱",
          "title": "Input multi-modale",
          "desc": "Supporta testo-video, immagine-video e altri flussi di lavoro creativi flessibili."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "Motore di inferenza ottimizzato assicura produzione rapida, la maggior parte dei video completa in pochi minuti."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutti i video generati possono essere utilizzati per scopi commerciali, adatti per pubblicità, social media e altro."
        }
      ],
      "enterPrompt": "Inserisci un prompt",
      "imageRequired": "La modalità immagine-video richiede un'immagine di riferimento",
      "videoRequired": "La modalità estensione video richiede un video di riferimento",
      "generateFailed": "Generazione fallita",
      "requestFailed": "Richiesta fallita, riprova",
      "faq": [
        {
          "q": "Come funziona Seedance?",
          "a": "Puoi caricare un'immagine di riferimento o inserire direttamente una descrizione testuale e il modello Seedance genererà contenuti video di alta qualità basati sulle tue istruzioni, con audio sincronizzato. Il processo è semplice e intuitivo, non richiede competenze professionali."
        },
        {
          "q": "I video generati possono essere utilizzati commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando Seedance possono essere utilizzati per scopi commerciali, inclusi materiali di marketing, social media, showcase prodotti e altro."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Utilizzare Seedance costa 18 crediti per generazione. Puoi ottenere tariffe crediti migliori attraverso piani di abbonamento."
        },
        {
          "q": "Quanto è veloce la generazione?",
          "a": "La velocità media di generazione di Seedance è di circa 1,5 minuti. Ottimizziamo costantemente la nostra infrastruttura per garantire generazione rapida e stabile."
        },
        {
          "q": "Quali formati di output sono supportati?",
          "a": "I video sono output in formato MP4, supportando risoluzioni 480p, 720p e 1080p, con durate di 5 o 10 secondi e più aspect ratio."
        }
      ]
    },
    "veo": {
      "title": "Generatore di video AI Veo 3.1",
      "desc": "Google Veo 3.1 è il modello video AI più avanzato, supportando generazione audio nativa, risoluzione ultra-alta e creazione video lunghi. Perfetto per produzione video professionale.",
      "fastType": "Tipo veloce",
      "fastTypeBadge": "Velocità rapida, costo inferiore",
      "fastTypeDesc": "(Supporta immagini di riferimento 16:9)",
      "qualityType": "Tipo qualità",
      "qualityTypeBadge": "Dettagli più ricchi",
      "qualityTypeDesc": "Movimento più fluido. Il frame finale è opzionale per la modalità immagine per controllare l'ultimo frame.",
      "imageMode": "Modalità generazione",
      "startEndFrames": "Frame iniziale/finale",
      "referenceImage": "Immagine di riferimento",
      "startFrame": "Frame iniziale",
      "startFrameHint": "Imposta il primo frame. Il video si anima da questo frame.",
      "uploadStartFrame": "Clicca per caricare frame iniziale",
      "endFrame": "Frame finale",
      "endFrameHint": "Imposta l'ultimo frame. Il video finisce a questo frame.",
      "uploadEndFrame": "Clicca per caricare frame finale",
      "negativePrompt": "Prompt negativo",
      "negativePromptPlaceholder": "Descrivi ciò che non vuoi nel video...",
      "features": [
        {
          "icon": "🎬",
          "title": "Generazione audio nativa",
          "desc": "Genera sincronamente video e audio, inclusi dialoghi ed effetti sonori."
        },
        {
          "icon": "📺",
          "title": "Risoluzione ultra HD",
          "desc": "Supporta output risoluzione fino a 4K per produzione video professionale."
        },
        {
          "icon": "⏱️",
          "title": "Supporto video lungo",
          "desc": "Genera video lunghi fino a 2 minuti, adatti a varie esigenze creative."
        },
        {
          "icon": "🎥",
          "title": "Movimento cinematografico",
          "desc": "Movimenti camera professionali e transizioni fluide."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "Motore di inferenza ottimizzato per produzione rapida."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutti i video generati possono essere utilizzati per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Qual è la differenza tra tipo veloce e tipo qualità?",
          "a": "Il tipo veloce è più veloce ed economico, adatto per iterazione rapida. Il tipo qualità produce dettagli più ricchi e movimento più fluido, ideale per output finale."
        },
        {
          "q": "Come funziona Veo 3.1?",
          "a": "Inserisci una descrizione testuale o carica un'immagine di riferimento e Veo 3.1 genererà contenuti video di alta qualità basati sulle tue istruzioni, opzionalmente con audio sincronizzato."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Utilizzare Veo 3.1 costa 30 crediti per generazione. Puoi ottenere tariffe crediti migliori attraverso piani di abbonamento."
        },
        {
          "q": "Quali risoluzioni e durate sono supportate?",
          "a": "Supporta risoluzioni 720p e 1080p, con durate di 5s, 10s, e fino a 2 minuti per video più lunghi."
        }
      ]
    },
    "veo30": {
      "title": "Generatore di video AI Veo 3.0",
      "desc": "Google Veo 3.0 è un modello video AI avanzato che supporta testo-video e immagine-video, con durate 4s/6s/8s e output 720p/1080p.",
      "fastType": "Tipo veloce",
      "fastTypeBadge": "Più veloce, costo inferiore",
      "fastTypeDesc": "(Supporta immagine di riferimento 16:9)",
      "qualityType": "Tipo qualità",
      "qualityTypeBadge": "Dettagli più ricchi",
      "qualityTypeDesc": "Movimento più fluido. Il frame finale in modalità immagine è opzionale per controllare l'ultimo frame.",
      "imageMode": "Modalità immagine",
      "startEndFrames": "Frame iniziale/finale",
      "referenceImage": "Immagine di riferimento",
      "referenceImageHint": "Carica un'immagine di riferimento; il video verrà generato basato su di essa.",
      "uploadReferenceImage": "Clicca per caricare immagine di riferimento",
      "startFrame": "Frame iniziale",
      "startFrameHint": "Imposta il primo frame. Il video si anima da questo frame.",
      "uploadStartFrame": "Clicca per caricare frame iniziale",
      "endFrame": "Frame finale",
      "endFrameHint": "Imposta l'ultimo frame. Il video finisce a questo frame.",
      "uploadEndFrame": "Clicca per caricare frame finale",
      "negativePrompt": "Prompt negativo",
      "negativePromptPlaceholder": "Descrivi ciò che non vuoi nel video...",
      "seedRangeError": "Seed deve essere un intero tra 0 e 2147483647.",
      "duration": "Durata",
      "resolution": "Risoluzione",
      "demoPrompt": "Una ragazza adolescente che disegna in un taccuino in un cafè, la pioggia batte sul vetro...",
      "features": [
        {
          "icon": "🎬",
          "title": "Generazione audio nativa",
          "desc": "Genera sincronamente video e audio, inclusi dialoghi ed effetti sonori."
        },
        {
          "icon": "📺",
          "title": "Risoluzione HD",
          "desc": "Supporta output 720p e 1080p per produzione video professionale."
        },
        {
          "icon": "⏱️",
          "title": "Durate multiple",
          "desc": "Supporta generazione video 4s, 6s e 8s."
        },
        {
          "icon": "🎥",
          "title": "Movimento cinematografico",
          "desc": "Movimenti camera professionali e transizioni fluide."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "Motore di inferenza ottimizzato per produzione rapida."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutti i video generati possono essere utilizzati per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Qual è la differenza tra tipo veloce e tipo qualità?",
          "a": "Il tipo veloce è più veloce ed economico, adatto per iterazione rapida. Il tipo qualità produce dettagli più ricchi e movimento più fluido, ideale per output finale."
        },
        {
          "q": "Come funziona Veo 3.0?",
          "a": "Inserisci una descrizione testuale o carica un'immagine di riferimento e Veo 3.0 genererà contenuti video di alta qualità basati sulle tue istruzioni, opzionalmente con audio sincronizzato."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Utilizzare Veo 3.0 costa 25 crediti per generazione. Puoi ottenere tariffe crediti migliori attraverso piani di abbonamento."
        },
        {
          "q": "Quali risoluzioni e durate sono supportate?",
          "a": "Supporta risoluzioni 720p e 1080p, con durate di 4s, 6s o 8s."
        }
      ]
    },
    "veo31fast": {
      "title": "Generatore di video AI Veo 3.1 Fast",
      "desc": "Google Veo 3.1 Fast per generazione più rapida, supportando testo-video e immagine-video con frame finale opzionale, durate 4s/6s/8s e output 720p/1080p/4K.",
      "referenceImage": "Immagine di riferimento",
      "referenceImageHint": "Carica un'immagine di riferimento; il video verrà generato basato su di essa.",
      "uploadReferenceImage": "Clicca per caricare immagine di riferimento",
      "endFrame": "Frame finale",
      "endFrameHint": "Opzionale. Imposta l'immagine per l'ultimo frame del video per controllare la fine.",
      "uploadEndFrame": "Clicca per caricare frame finale",
      "duration": "Durata",
      "resolution": "Risoluzione",
      "seedRangeError": "Seed deve essere un intero tra 0 e 2147483647.",
      "demoPrompt": "Una ragazza adolescente che disegna in un taccuino in un cafè, la pioggia batte sul vetro...",
      "features": [
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "Ottimizzato per output più rapido."
        },
        {
          "icon": "📺",
          "title": "Risoluzione 4K",
          "desc": "Supporta output 720p, 1080p e 4K."
        },
        {
          "icon": "⏱️",
          "title": "Durate multiple",
          "desc": "Supporta video 4s, 6s e 8s."
        },
        {
          "icon": "🖼️",
          "title": "Frame finale opzionale",
          "desc": "L'immagine-video può caricare un frame finale per controllare la fine."
        },
        {
          "icon": "🎥",
          "title": "Movimento cinematografico",
          "desc": "Movimenti camera professionali e transizioni fluide."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutti i video generati possono essere utilizzati per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Qual è la differenza tra Veo 3.1 Fast e Veo 3.1?",
          "a": "Veo 3.1 Fast è ottimizzato per velocità e costo crediti inferiore, con supporto 4K e frame finale opzionale."
        },
        {
          "q": "Cos'è il frame finale?",
          "a": "Per l'immagine-video, puoi caricare un'immagine frame finale così il video finirà su quel frame, permettendoti di controllare la fine."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Utilizzare Veo 3.1 Fast costa 20 crediti per generazione."
        },
        {
          "q": "Quali risoluzioni e durate sono supportate?",
          "a": "Supporta risoluzioni 720p, 1080p e 4K, con durate di 4s, 6s o 8s."
        }
      ]
    },
    "kling": {
      "title": "Generatore di video AI Kling 2.6",
      "desc": "Kling 2.6 è un modello video AI ad alte prestazioni che supporta testo-video e immagine-video, con qualità del movimento eccellente e velocità di generazione rapida.",
      "features": [
        {
          "icon": "🎬",
          "title": "Qualità movimento alta",
          "desc": "Movimento fluido e naturale con qualità output professionale."
        },
        {
          "icon": "📱",
          "title": "Aspect ratio multipli",
          "desc": "Supporta 1:1, 16:9, 9:16 e altri aspect ratio."
        },
        {
          "icon": "🔊",
          "title": "Generazione audio",
          "desc": "Generazione audio nativa opzionale per esperienza video completa."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "La maggior parte dei video generati entro 2 minuti."
        },
        {
          "icon": "🖼️",
          "title": "Immagine a video",
          "desc": "Anima immagini statiche con movimento AI."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutti i video generati possono essere utilizzati per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Come funziona Kling 2.6?",
          "a": "Inserisci una descrizione testuale o carica un'immagine di riferimento e Kling 2.6 genererà contenuti video di alta qualità basati sulle tue istruzioni."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Utilizzare Kling 2.6 costa 28 crediti per generazione. Puoi ottenere tariffe crediti migliori attraverso piani di abbonamento."
        },
        {
          "q": "Quali risoluzioni e durate sono supportate?",
          "a": "Supporta risoluzioni 720p e 1080p, con durate di 5s e 10s."
        },
        {
          "q": "I video generati possono essere utilizzati commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando Kling 2.6 possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "kling3": {
      "title": "Generatore di video AI Kling 3.0",
      "desc": "Kling 3.0 è un modello video AI ad alte prestazioni che supporta testo-video e immagine-video, con qualità del movimento eccellente e velocità di generazione rapida.",
      "features": [
        {
          "icon": "🎬",
          "title": "Qualità movimento alta",
          "desc": "Movimento fluido e naturale con qualità output professionale."
        },
        {
          "icon": "📱",
          "title": "Aspect ratio multipli",
          "desc": "Supporta 1:1, 16:9, 9:16 e altri aspect ratio."
        },
        {
          "icon": "🔊",
          "title": "Generazione audio",
          "desc": "Generazione audio nativa opzionale per esperienza video completa."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "La maggior parte dei video generati entro 2 minuti."
        },
        {
          "icon": "🖼️",
          "title": "Immagine a video",
          "desc": "Anima immagini statiche con movimento AI."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutti i video generati possono essere utilizzati per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Come funziona Kling 3.0?",
          "a": "Inserisci una descrizione testuale o carica un'immagine di riferimento e Kling 3.0 genererà contenuti video di alta qualità basati sulle tue istruzioni."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Utilizzare Kling 3.0 costa 28 crediti per generazione. Puoi ottenere tariffe crediti migliori attraverso piani di abbonamento."
        },
        {
          "q": "Quali risoluzioni e durate sono supportate?",
          "a": "Supporta risoluzioni 720p e 1080p, con durate di 5s e 10s."
        },
        {
          "q": "I video generati possono essere utilizzati commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando Kling 3.0 possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "sora": {
      "title": "Generatore di video AI Sora 2",
      "desc": "Sora 2 è il modello video AI avanzato di OpenAI, capace di generare video di alta qualità con movimento realistico e qualità cinematografica.",
      "demoPromptExample": "@sama Il CEO di OpenAI Sam sta introducendo questo prodotto armadietto, dicendo che è lo stesso della sua casa, molto utile.",
      "landscape": "Orizzontale",
      "portrait": "Verticale",
      "removeWatermark": "Rimuovi watermark",
      "enabled": "Abilitato",
      "disabled": "Disabilitato",
      "noWatermark": "Nessun watermark",
      "cinematic": "Qualità cinematografica",
      "restrictedAccess": "Accesso limitato",
      "60secDuration": "Durata 4 s / 8 s / 12 s",
      "photorealistic": "Fotorealistico",
      "physicsSimulation": "Simulazione fisica",
      "features": [
        {
          "icon": "🎬",
          "title": "Qualità cinematografica",
          "desc": "Genera video con aspetto cinematografico professionale."
        },
        {
          "icon": "🎥",
          "title": "Movimento realistico",
          "desc": "Movimento naturale e realistico per personaggi e scene."
        },
        {
          "icon": "⏱️",
          "title": "Durata flessibile",
          "desc": "Supporta varie lunghezze video per diverse esigenze."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "Ottimizzato per produzione video rapida."
        },
        {
          "icon": "🖼️",
          "title": "Input multi-modale",
          "desc": "Supporta modalità testo-video e immagine-video."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutti i video generati possono essere utilizzati per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Come funziona Sora 2?",
          "a": "Inserisci una descrizione testuale o carica un'immagine di riferimento e Sora 2 genererà contenuti video di alta qualità basati sulle tue istruzioni."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Utilizzare Sora 2 costa 15 crediti per generazione. Puoi ottenere tariffe crediti migliori attraverso piani di abbonamento."
        },
        {
          "q": "Cosa ha di speciale Sora 2?",
          "a": "Sora 2 eccelle nella generazione di movimento realistico e video di qualità cinematografica, ideale per creazione contenuti professionale."
        },
        {
          "q": "I video generati possono essere utilizzati commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando Sora 2 possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "wan": {
      "title": "Generatore di video AI Wan",
      "desc": "Wan è un modello video AI versatile che supporta testo-video e immagine-video con qualità e velocità eccellenti.",
      "multiFormat": "Formati multipli",
      "smoothMotion": "Movimento fluido",
      "referenceAudio": "Audio di riferimento",
      "uploadAudio": "Clicca per caricare audio di riferimento",
      "uploadAudioHint": "MP3, WAV, M4A (opzionale, guida colonna sonora video)",
      "features": [
        {
          "icon": "🎬",
          "title": "Output alta qualità",
          "desc": "Genera video professionali da testo o immagini."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "Produzione video efficiente per flusso di lavoro rapido."
        },
        {
          "icon": "📱",
          "title": "Formati multipli",
          "desc": "Supporta vari aspect ratio e risoluzioni."
        },
        {
          "icon": "🖼️",
          "title": "Animazione immagine",
          "desc": "Porta in vita immagini statiche con movimento AI."
        },
        {
          "icon": "🎥",
          "title": "Movimento fluido",
          "desc": "Movimento naturale e fluido nei video generati."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutti i video generati possono essere utilizzati per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Come funziona Wan?",
          "a": "Inserisci una descrizione testuale o carica un'immagine di riferimento e Wan genererà contenuti video di alta qualità basati sulle tue istruzioni."
        },
        {
          "q": "Quale versione Wan dovrei usare?",
          "a": "Wan 2.5 e 2.6 offrono le funzionalità più recenti e la migliore qualità. Wan 2.2 è un'opzione economica per progetti più semplici."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Wan 2.6 costa 70 crediti, Wan 2.5 costa 60 crediti e Wan 2.2 costa 10 crediti per generazione."
        },
        {
          "q": "I video generati possono essere utilizzati commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando Wan possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "wan25": {
      "title": "Generatore di video AI Wan 2.5",
      "desc": "Wan 2.5 è un modello video AI versatile che supporta testo-video e immagine-video con qualità e velocità eccellenti.",
      "features": [
        {
          "icon": "🎬",
          "title": "Output alta qualità",
          "desc": "Genera video professionali da testo o immagini."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "Produzione video efficiente per flusso di lavoro rapido."
        },
        {
          "icon": "📱",
          "title": "Formati multipli",
          "desc": "Supporta vari aspect ratio e risoluzioni."
        },
        {
          "icon": "🖼️",
          "title": "Animazione immagine",
          "desc": "Porta in vita immagini statiche con movimento AI."
        },
        {
          "icon": "🎥",
          "title": "Movimento fluido",
          "desc": "Movimento naturale e fluido nei video generati."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutti i video generati possono essere utilizzati per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Come funziona Wan 2.5?",
          "a": "Inserisci una descrizione testuale o carica un'immagine di riferimento e Wan 2.5 genererà contenuti video di alta qualità basati sulle tue istruzioni."
        },
        {
          "q": "Qual è la differenza tra Wan 2.5 e Wan 2.6?",
          "a": "Wan 2.6 offre ulteriori miglioramenti in qualità e stabilità; Wan 2.5 è conveniente e adatto per la maggior parte dei casi d'uso."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Wan 2.5 costa 60 crediti per generazione."
        },
        {
          "q": "I video generati possono essere utilizzati commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando Wan 2.5 possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "wan26": {
      "title": "Generatore di video AI Wan 2.6",
      "desc": "Wan 2.6 è un modello video AI migliorato con qualità e stabilità migliorate, supportando testo-video e immagine-video.",
      "features": [
        {
          "icon": "🎬",
          "title": "Output alta qualità",
          "desc": "Genera video professionali da testo o immagini con qualità migliorata."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "Produzione video efficiente per flusso di lavoro rapido."
        },
        {
          "icon": "📱",
          "title": "Formati multipli",
          "desc": "Supporta vari aspect ratio e risoluzioni."
        },
        {
          "icon": "🖼️",
          "title": "Animazione immagine",
          "desc": "Porta in vita immagini statiche con movimento AI."
        },
        {
          "icon": "🎥",
          "title": "Movimento fluido",
          "desc": "Movimento naturale e fluido nei video generati."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "Tutti i video generati possono essere utilizzati per scopi commerciali."
        }
      ],
      "faq": [
        {
          "q": "Qual è la differenza tra Wan 2.6 e Wan 2.5?",
          "a": "Wan 2.6 offre ulteriori miglioramenti in qualità e stabilità per output di qualità superiore."
        },
        {
          "q": "Come funziona Wan 2.6?",
          "a": "Inserisci una descrizione testuale o carica un'immagine di riferimento e Wan 2.6 genererà contenuti video di alta qualità basati sulle tue istruzioni."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Wan 2.6 costa 70 crediti per generazione."
        },
        {
          "q": "I video generati possono essere utilizzati commercialmente?",
          "a": "Sì, tutti i contenuti generati utilizzando Wan 2.6 possono essere utilizzati per scopi commerciali."
        }
      ]
    },
    "wan22": {
      "title": "Generatore di video AI Wan 2.2 Classic",
      "desc": "Wan 2.2 è un modello video AI classico per testo-video e immagine-video, focalizzato su output stabile e forte efficienza costi.",
      "demoPromptExample": "Una ragazza con pochi efelidi e capelli rossi disordinati seduta su un tetto al tramonto, giacca di denim leggermente usata, che tiene una macchina fotografica Polaroid, lo skyline della città che brilla in toni sfumati dietro di lei.",
      "resolutionBadge": "720p",
      "classicVersion": "Versione classica",
      "stableReliable": "Stabile e affidabile",
      "costEffective": "Conveniente",
      "features": [
        {
          "icon": "🎬",
          "title": "Testo/Immagine a video",
          "desc": "Supporta sia testo-video che immagine-video per creazione quotidiana e test batch."
        },
        {
          "icon": "⚡",
          "title": "Risultati stabili",
          "desc": "Modello classico maturo con output qualità prevedibile."
        },
        {
          "icon": "💰",
          "title": "Conveniente",
          "desc": "Utilizzo crediti inferiore per flussi di lavoro ad alta frequenza."
        },
        {
          "icon": "📐",
          "title": "Aspect ratio comuni",
          "desc": "Supporta aspect ratio comuni come 16:9 e 9:16."
        },
        {
          "icon": "🎥",
          "title": "Output pulito",
          "desc": "Fornisce qualità video stabile e pulita."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "I contenuti generati possono essere usati commercialmente."
        }
      ],
      "faq": [
        {
          "q": "Qual è la differenza tra Wan 2.2 e Wan 2.5?",
          "a": "Wan 2.2 è migliore per scenari sensibili ai costi e ad alto volume; Wan 2.5/2.6 forniscono capacità e qualità superiori."
        },
        {
          "q": "Come funziona Wan 2.2?",
          "a": "Inserisci un prompt o carica un'immagine di riferimento e il modello genera il video basato sulle tue istruzioni."
        },
        {
          "q": "I video generati possono essere utilizzati commercialmente?",
          "a": "Sì, gli output Wan 2.2 possono essere usati per scopi commerciali."
        }
      ]
    },
    "kling25": {
      "title": "Generatore di video AI Kling 2.5",
      "desc": "Kling 2.5 è un modello video AI standard che supporta testo-video e immagine-video con qualità stabile e buon rapporto qualità-prezzo.",
      "standard": "Standard",
      "reliable": "Affidabile",
      "costEffective": "Conveniente",
      "standardQuality": "Qualità standard",
      "textToVideo": "Testo a video",
      "imageToVideo": "Immagine a video",
      "referenceImage": "Immagine di riferimento",
      "referenceImageHint": "Clicca per caricare o trascinare",
      "referenceImageFormats": "Supporta PNG, JPG, JPEG, WEBP (<=10MB)",
      "endFrame": "Immagine frame finale",
      "endFrameOptional": "Opzionale",
      "endFrameFormats": "PNG, JPG, JPEG",
      "endFrameHint": "Vincola il frame finale; meglio quando corrisponde all'aspect ratio dell'immagine di riferimento",
      "videoPrompt": "Prompt video",
      "promptPlaceholder": "Descrivi il contenuto video che desideri generare...",
      "negativePrompt": "Prompt negativo",
      "negativePromptPlaceholder": "Descrivi cosa dovrebbe essere escluso...",
      "duration": "Durata",
      "aspectRatio": "Aspect ratio",
      "uploading": "Caricamento...",
      "clickToUploadReference": "Clicca per caricare immagine di riferimento",
      "clickToUploadEndFrame": "Clicca per caricare immagine frame finale",
      "remove": "Rimuovi",
      "creditsRequired": "Crediti richiesti:",
      "remaining": "Rimanenti:",
      "generate": "Genera",
      "generating": "Generazione...",
      "demoPrompt": "Prompt demo",
      "demoPromptExample": "Usa l'immagine del vicolo cyberpunk caricata come primo frame. Mantieni lo stesso vicolo, insegne neon, riflessi e la donna con cappuccio che si allontana. Muovi lentamente la telecamera in avanti lungo il vicolo...",
      "model": "Modello:",
      "durationLabel": "Durata:",
      "introTitle": "Crea video AI di alta qualità con Kling 2.5 Standard",
      "featuresBadge": "Caratteristiche principali",
      "featuresTitle": "Cosa può fare {name}?",
      "faqTitle": "FAQ",
      "errorPromptRequired": "Inserisci un prompt",
      "errorImageRequired": "L'immagine di riferimento è richiesta in modalità immagine-video",
      "errorGenerationFailed": "Generazione fallita",
      "errorRequestFailed": "Richiesta fallita, riprova",
      "errorUploadFailed": "Caricamento fallito, riprova",
      "features": [
        {
          "icon": "🎬",
          "title": "Testo/Immagine a video",
          "desc": "Supporta sia testo-video che immagine-video con opzioni durata 5s/10s."
        },
        {
          "icon": "⚡",
          "title": "Output affidabile",
          "desc": "Modello standard maturo con prestazioni stabili."
        },
        {
          "icon": "💰",
          "title": "Ottimo valore",
          "desc": "Consumo crediti inferiore rispetto ai modelli di fascia alta."
        },
        {
          "icon": "📐",
          "title": "Aspect ratio multipli",
          "desc": "Supporta 1:1, 16:9 e 9:16."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "I contenuti generati possono essere usati commercialmente."
        }
      ],
      "faq": [
        {
          "q": "Qual è la differenza tra Kling 2.5 e Kling 2.6?",
          "a": "Kling 2.5 è ottimizzato per costi ed efficienza, mentre Kling 2.6 offre capacità complessive più forti."
        },
        {
          "q": "Come funziona Kling 2.5?",
          "a": "Inserisci un prompt o carica un'immagine di riferimento e Kling 2.5 genera il video di conseguenza."
        },
        {
          "q": "I video generati possono essere utilizzati commercialmente?",
          "a": "Sì, gli output Kling 2.5 possono essere usati commercialmente."
        }
      ]
    },
    "wanAnimate": {
      "title": "Wan Animate",
      "desc": "Animazione del personaggio da immagine e video di riferimento. Qualità standard o professionale, filigrana opzionale.",
      "refImageLabel": "Immagine di riferimento",
      "refImageHint": "Personaggio da animare (JPG/PNG/JPEG/BMP/WEBP, max 5 MB, lati 200–4096 px, rapporto 1:3–3:1).",
      "refVideoLabel": "Video di riferimento",
      "refVideoHint": "Movimento di riferimento (MP4/AVI/MOV, 2–30 s, max 200 MB, lati 200–2048 px, rapporto 1:3–3:1).",
      "animateModeLabel": "Modalità animazione",
      "modeAnimate": "Immagine in azione",
      "modeReplace": "Scambio persona nel video",
      "referenceVideo": "Video di riferimento",
      "btnAnimate": "Anima",
      "animateModeBadgeAnimate": "Movimento",
      "animateModeBadgeReplace": "Sostituisci",
      "btnAnimateDesc": "Combina il personaggio dell’immagine con il movimento del video.",
      "btnReplace": "Sostituisci",
      "btnReplaceDesc": "Sostituisci il personaggio nel video con quello dell’immagine.",
      "qualityLabel": "Modalità qualità",
      "qualityStd": "Standard",
      "qualityPro": "Professionale",
      "watermarkLabel": "Filigrana",
      "uploadVideoRequired": "Carica un video di riferimento.",
      "uploadImage": "Carica immagine",
      "uploadVideo": "Carica video",
      "uploading": "Caricamento…",
      "imageUploadHint": "JPG, PNG, JPEG, BMP, WEBP · max 5 MB",
      "videoUploadHint": "MP4, AVI, MOV · 2–30 s · max 200 MB",
      "uploadImageRequired": "Carica un’immagine di riferimento.",
      "errImageFileTooLarge": "L’immagine supera il limite (max 5 MB).",
      "errImageDimensions": "Larghezza e altezza dell’immagine devono essere tra 200 e 4096 px.",
      "errImageAspect": "Il rapporto dell’immagine deve essere tra 1:3 e 3:1.",
      "errImageInvalid": "File immagine non valido o illeggibile.",
      "errVideoFileTooLarge": "Il video supera il limite (max 200 MB).",
      "errVideoDuration": "La durata del video deve essere tra 2 e 30 secondi.",
      "errVideoDimensions": "Larghezza e altezza del video devono essere tra 200 e 2048 px.",
      "errVideoAspect": "Il rapporto del video deve essere tra 1:3 e 3:1.",
      "errVideoInvalid": "File video non valido o illeggibile.",
      "defaultModelName": "Wan Animate",
      "demoEmptyHint": "Carica un’immagine del personaggio e un video di movimento e crea straordinarie animazioni con Wan Animate.",
      "demoEmptyTitle": "Animazione personaggio",
      "demoStepCharacter": "Personaggio",
      "demoStepMotion": "Movimento",
      "demoStepAnimate": "Animazione",
      "faqCredits": "La modalità professionale consuma più crediti della standard. Vedi la riga sopra.",
      "characterAnimation": "Animazione personaggio",
      "faceSwap": "Scambio volto",
      "motionTransfer": "Trasferimento movimento",
      "identityReplacement": "Sostituzione identità",
      "motionAccuracy": "Fedeltà del movimento",
      "features": [
        { "icon": "🎭", "title": "Due modalità", "desc": "Trasferimento movimento o sostituzione completa del personaggio." },
        { "icon": "📐", "title": "DashScope ufficiale", "desc": "Wan 2.2 Animate su Alibaba Cloud." },
        { "icon": "⚡", "title": "Std / Pro", "desc": "Qualità standard o professionale per ogni attività." },
        { "icon": "💧", "title": "Filigrana opzionale", "desc": "Attiva o disattiva la filigrana sull’output." }
      ],
      "faq": [
        { "q": "Quali input servono?", "a": "Dopo il caricamento, URL HTTPS pubblici per immagine e video. Rispetta limiti di dimensione e rapporto." },
        { "q": "Differenza tra Anima e Sostituisci?", "a": "Anima applica il movimento del video al personaggio dell’immagine. Sostituisci scambia il personaggio nel video con quello dell’immagine." },
        { "q": "Come si calcolano i crediti?", "a": "La modalità professionale costa di più per generazione rispetto alla standard, come indicato sulla pagina." }
      ]
    },
    "viduq3pro": {
      "title": "Vidu Q3 Pro – Video AI",
      "desc": "Vidu Q3 Pro: testo o immagine, risoluzione, 1–16 s, proporzioni e audio opzionale.",
      "imageUrlHint": "Solo URL immagine HTTPS (l’upload restituisce un URL pubblico). Rapporto d’aspetto tra 1:4 e 4:1.",
      "lengthLabel": "Durata (s)",
      "optional": "Facoltativo",
      "tagHighQuality": "Alta qualità",
      "tagLength": "1–16 s",
      "tagResolution": "Fino a 2K",
      "demoPromptExample": "Lungomare all’alba, jogger, gabbiani sull’acqua, una barca a vela in lontananza.",
      "features": [
        { "icon": "🎬", "title": "Testo e immagine", "desc": "Genera da prompt o immagine di riferimento." },
        { "icon": "📐", "title": "Proporzioni", "desc": "Modalità testo: 16:9, 9:16, 1:1, 4:3, 3:4." },
        { "icon": "⏱️", "title": "Durata", "desc": "Da 1 a 16 secondi." },
        { "icon": "🎵", "title": "Audio", "desc": "Audio naturale opzionale." },
        { "icon": "🎲", "title": "Seed", "desc": "Seed opzionale per maggiore riproducibilità." }
      ],
      "faq": [
        { "q": "Requisiti immagine→video?", "a": "URL HTTPS pubblico (JPG/PNG). Rapporto tra 1:4 e 4:1." },
        { "q": "Differenza testo vs immagine?", "a": "Il testo usa le proporzioni; l’immagine invia l’URL di riferimento." },
        { "q": "Crediti?", "a": "Secondo le regole mostrate: durata, risoluzione e audio." }
      ]
    },
    "hailuo": {
      "title": "Generatore di video AI Hailuo 2.3",
      "desc": "Hailuo 2.3 è un modello video AI di nuova generazione progettato per generazione video creativa e di alta qualità.",
      "demoPromptExample": "Un piano cinematografico di onde che si infrangono su una costa rocciosa al tramonto, luce dorata che si riflette sull'acqua...",
      "highQuality": "Alta qualità",
      "highQualityOutput": "Output alta qualità",
      "features": [
        {
          "icon": "🎬",
          "title": "Testo a video",
          "desc": "Genera video di alta qualità direttamente da prompt testuali."
        },
        {
          "icon": "✨",
          "title": "Migliora prompt",
          "desc": "Il miglioramento prompt aiuta a migliorare coerenza e qualità."
        },
        {
          "icon": "🌊",
          "title": "Stile creativo",
          "desc": "Ottimo per contenuti video e artistici creativi."
        },
        {
          "icon": "⚡",
          "title": "Generazione rapida",
          "desc": "Pipeline ottimizzati per turnaround più rapido."
        },
        {
          "icon": "🎨",
          "title": "Qualità visiva",
          "desc": "Produce output video dettagliato e di qualità stabile."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "I contenuti generati possono essere usati commercialmente."
        }
      ],
      "faq": [
        {
          "q": "Come funziona Hailuo 2.3?",
          "a": "Inserisci un prompt o carica un'immagine di riferimento e il modello genera il video corrispondente."
        },
        {
          "q": "Cos'è il miglioramento prompt?",
          "a": "Il miglioramento prompt riscrive e arricchisce i prompt per migliore qualità di generazione."
        },
        {
          "q": "I video generati possono essere utilizzati commercialmente?",
          "a": "Sì, gli output Hailuo 2.3 possono essere usati commercialmente."
        },
        {
          "q": "Quanti crediti costa ogni generazione?",
          "a": "Ogni generazione è fatturata secondo le regole crediti del modello attuale."
        }
      ]
    },
    "runway": {
      "title": "Generatore di video AI Runway",
      "desc": "Runway è un modello video AI professionale con controlli flessibili per ratio, durata e seed.",
      "demoPromptExample": "Al tramonto, i profili silenziosi delle gru in un cantiere edile a Singapore si stagliano contro un brillante tramonto. Diversi operai edili con caschi protettivi stanno raccogliendo gli attrezzi, pronti a partire...",
      "professional": "Professionale",
      "multiOption": "Opzioni multiple",
      "highQuality": "Alta qualità",
      "multiFormat": "Aspect ratio multipli",
      "reproducibleSeed": "Seed riproducibile",
      "features": [
        {
          "icon": "🎬",
          "title": "Immagine a video",
          "desc": "Carica un'immagine di riferimento e inserisci un prompt per generare rapidamente video di alta qualità."
        },
        {
          "icon": "📐",
          "title": "Aspect ratio multipli",
          "desc": "Supporta 16:9, 9:16, 1:1, 4:3, 3:4 e 21:9."
        },
        {
          "icon": "🎲",
          "title": "Controllo seed",
          "desc": "Usa seed per riprodurre risultati di generazione simili."
        },
        {
          "icon": "⚡",
          "title": "Output professionale",
          "desc": "Output coerente adatto per flussi di lavoro professionali e commerciali."
        },
        {
          "icon": "🖼️",
          "title": "Animazione immagine",
          "desc": "Trasforma immagini statiche in riprese video dinamiche."
        },
        {
          "icon": "💼",
          "title": "Licenza commerciale",
          "desc": "I contenuti generati possono essere usati commercialmente."
        }
      ],
      "faq": [
        {
          "q": "Come funziona Runway?",
          "a": "Carica un'immagine di riferimento e inserisci un prompt; il modello genera il video corrispondente."
        },
        {
          "q": "Quali aspect ratio sono supportati?",
          "a": "16:9, 9:16, 1:1, 4:3, 3:4 e 21:9 sono supportati."
        },
        {
          "q": "I video generati possono essere utilizzati commercialmente?",
          "a": "Sì, gli output Runway possono essere usati commercialmente."
        }
      ]
    }
  },
  "privacy": {
    "title": "Informativa sulla privacy",
    "lastUpdated": "Ultimo aggiornamento: 15 gennaio 2025",
    "navTerms": "Termini di servizio →",
    "navTrust": "Fiducia e sicurezza →",
    "sections": [
      {
        "title": "1. Raccolta informazioni",
        "paragraphs": [
          "Raccogliamo informazioni che fornisci durante la registrazione e l'uso dei servizi, inclusi indirizzo email, nome utente e informazioni di pagamento.",
          "Raccogliamo automaticamente dati di utilizzo come indirizzo IP, tipo di browser, ora di accesso e funzioni utilizzate."
        ]
      },
      {
        "title": "2. Uso informazioni",
        "paragraphs": [
          "Utilizziamo le informazioni raccolte per fornire, mantenere e migliorare i nostri servizi, elaborare transazioni, inviare notifiche relative ai servizi e prevenire frodi e abusi.",
          "Non vendiamo le tue informazioni personali a terze parti."
        ]
      },
      {
        "title": "3. Contenuto generato da AI",
        "paragraphs": [
          "Le immagini che carichi e i prompt che inserisci vengono utilizzati solo per generare il contenuto che richiedi e non vengono utilizzati per addestrare modelli AI.",
          "Il contenuto generato viene temporaneamente memorizzato sui nostri server per il download, quindi eliminato secondo la nostra politica di conservazione dati."
        ]
      },
      {
        "title": "4. Sicurezza dati",
        "paragraphs": [
          "Adottiamo misure di sicurezza standard del settore per proteggere le tue informazioni personali, inclusi crittografia SSL, controlli di accesso e audit di sicurezza regolari.",
          "Sebbene facciamo del nostro meglio per proteggere i tuoi dati, nessun metodo di trasmissione internet è sicuro al 100%."
        ]
      },
      {
        "title": "5. Uso cookie",
        "paragraphs": [
          "Utilizziamo cookie e tecnologie simili per migliorare l'esperienza utente, analizzare l'utilizzo e fornire contenuti personalizzati.",
          "Puoi gestire le preferenze cookie attraverso le impostazioni del browser. Disabilitare i cookie potrebbe influire su alcune funzioni."
        ]
      },
      {
        "title": "6. Servizi di terze parti",
        "paragraphs": [
          "Potremmo utilizzare fornitori di servizi terzi per aiutarci a fornire servizi, come elaborazione pagamenti, analisi dati e supporto clienti.",
          "Questi fornitori di servizi terzi accedono alle tue informazioni personali solo nella misura necessaria per eseguire servizi per noi."
        ]
      },
      {
        "title": "7. I tuoi diritti",
        "paragraphs": [
          "Hai il diritto di accedere, correggere o eliminare le tue informazioni personali. Hai anche il diritto di richiedere di limitare l'elaborazione dei tuoi dati o trasferire i tuoi dati a un altro servizio.",
          "Per esercitare questi diritti, contattaci all'indirizzo miral_support@miralvis.com. Risponderemo alla tua richiesta entro 30 giorni."
        ]
      },
      {
        "title": "8. Conformità GDPR",
        "paragraphs": [
          "Per gli utenti nello Spazio economico europeo, rispettiamo i requisiti del Regolamento generale sulla protezione dei dati (GDPR). La nostra base legale per elaborare i tuoi dati include esecuzione contrattuale, interessi legittimi e tuo consenso."
        ]
      },
      {
        "title": "9. Contattaci",
        "paragraphs": [
          "Se hai domande o preoccupazioni sulla nostra informativa sulla privacy, contatta il nostro team di protezione dati all'indirizzo miral_support@miralvis.com."
        ]
      }
    ]
  },
  "terms": {
    "title": "Termini di servizio",
    "lastUpdated": "Ultimo aggiornamento: 15 gennaio 2025",
    "navPrivacy": "Informativa sulla privacy →",
    "navTrust": "Fiducia e sicurezza →",
    "sections": [
      {
        "title": "1. Panoramica servizio",
        "paragraphs": [
          "Miral (di seguito \"la Piattaforma\") è una piattaforma AI che integra creazione di immagini, video e musica. Questi Termini di servizio (di seguito \"Termini\") regolano le condizioni e le regole per l'uso della Piattaforma.",
          "Usando la Piattaforma, accetti di essere vincolato da questi Termini. Se non accetti questi Termini, non usare la Piattaforma."
        ]
      },
      {
        "title": "2. Registrazione account",
        "paragraphs": [
          "Devi avere almeno 18 anni per registrare un account. Devi fornire informazioni di registrazione accurate e complete e sei responsabile della manutenzione della sicurezza dell'account.",
          "Sei responsabile di tutte le attività condotte attraverso il tuo account. Se scopri un uso non autorizzato, notificaci immediatamente."
        ]
      },
      {
        "title": "3. Uso servizio",
        "paragraphs": [
          "La Piattaforma fornisce servizi di generazione contenuti basati su crediti. I crediti possono essere ottenuti attraverso abbonamento o acquisto una tantum. Diversi modelli e funzioni AI consumano quantità diverse di crediti.",
          "Accetti di non usare la Piattaforma per scopi illegali, dannosi o lesivi. È vietato generare contenuti illegali, pornografici, violenti o che violano i diritti altrui."
        ]
      },
      {
        "title": "4. Proprietà intellettuale",
        "paragraphs": [
          "I diritti di proprietà intellettuale per il contenuto che generi attraverso la Piattaforma ti appartengono, soggetto ai termini di utilizzo di ciascun fornitore di modelli AI.",
          "I marchi, loghi, design dell'interfaccia e codice software della Piattaforma sono protetti dalle leggi sulla proprietà intellettuale e non possono essere utilizzati senza autorizzazione."
        ]
      },
      {
        "title": "5. Pagamento e rimborsi",
        "paragraphs": [
          "Tutti i pagamenti sono in dollari USA. Le tariffe di abbonamento sono addebitate mensilmente o annualmente, a seconda del piano scelto.",
          "Per i primi acquisti di pacchetti una tantum o primi abbonamenti, può essere richiesto un rimborso entro 7 giorni calendario se l'utilizzo dei crediti è inferiore al 3%."
        ]
      },
      {
        "title": "6. Esclusione di responsabilità",
        "paragraphs": [
          "La Piattaforma fornisce servizi \"così come sono\" e non fa alcuna garanzia espressa o implicita sulla disponibilità, accuratezza o idoneità dei servizi.",
          "Il contenuto generato da AI potrebbe essere inaccurato o imperfetto. Gli utenti dovrebbero giudicare da soli l'applicabilità del contenuto generato."
        ]
      },
      {
        "title": "7. Limitazione di responsabilità",
        "paragraphs": [
          "Nella misura massima consentita dalla legge, la Piattaforma non è responsabile per eventuali danni diretti, indiretti, incidentali o consequenziali risultanti dall'uso o incapacità di usare i servizi.",
          "La responsabilità totale della Piattaforma non supera l'importo totale che hai pagato negli ultimi 12 mesi."
        ]
      },
      {
        "title": "8. Modifica termini",
        "paragraphs": [
          "Ci riserviamo il diritto di modificare questi Termini in qualsiasi momento. I Termini modificati diventano efficaci quando pubblicati su questa pagina.",
          "L'uso continuato della Piattaforma indica l'accettazione dei Termini modificati. Le modifiche significative verranno notificate tramite email o notifica della Piattaforma."
        ]
      },
      {
        "title": "9. Contattaci",
        "paragraphs": [
          "Se hai domande su questi Termini, contattaci all'indirizzo miral_support@miralvis.com."
        ]
      }
    ]
  },
  "trustSafety": {
    "tag": "🛡️ Fiducia e sicurezza",
    "title": "La sicurezza dei tuoi dati è la nostra priorità assoluta",
    "subtitle": "Scopri come proteggiamo la tua privacy e sicurezza dei dati.",
    "badges": [
      {
        "icon": "🛡️",
        "title": "Nessuna formazione AI",
        "desc": "Il contenuto che carichi e le opere generate non vengono mai utilizzate per addestrare alcun modello AI."
      },
      {
        "icon": "🔒",
        "title": "Crittografia end-to-end",
        "desc": "Tutti i trasferimenti dati usano crittografia TLS 1.3, dati memorizzati usano crittografia AES-256."
      },
      {
        "icon": "✓",
        "title": "Conforme GDPR",
        "desc": "Pienamente conforme ai requisiti del Regolamento generale sulla protezione dei dati UE."
      },
      {
        "icon": "🗑️",
        "title": "Controllo dati self-service",
        "desc": "Puoi esportare o eliminare tutti i tuoi dati in qualsiasi momento, inclusa la cancellazione dell'account."
      }
    ],
    "sections": [
      {
        "title": "Trasparenza elaborazione dati",
        "paragraphs": [
          "Siamo completamente trasparenti su come gestiamo i dati. Le immagini e i video che carichi vengono utilizzati solo per generare il contenuto che richiedi ed eliminati dai server entro 24 ore dopo l'elaborazione.",
          "Il contenuto generato viene memorizzato nel tuo account e puoi scaricarlo o eliminarlo in qualsiasi momento. Non condividiamo il tuo contenuto senza il tuo consenso."
        ]
      },
      {
        "title": "Infrastruttura sicura",
        "paragraphs": [
          "I nostri servizi sono distribuiti su infrastruttura cloud leader mondiale con protezione sicurezza multilivello. Tutti i server si trovano in data center certificati SOC 2 e ISO 27001.",
          "Conduciamo regolari audit di sicurezza e test di penetrazione per garantire la sicurezza del sistema. Tutti i dipendenti ricevono formazione rigorosa sulla sicurezza."
        ]
      },
      {
        "title": "Sicurezza contenuti",
        "paragraphs": [
          "Distribuiamo sistemi avanzati di sicurezza contenuti che rilevano e bloccano automaticamente la generazione di contenuti dannosi. Questo include, ma non è limitato a, contenuti violenti, pornografici e lesivi.",
          "Se scopri contenuti che violano, segnalacelo all'indirizzo abuse@miral.org."
        ]
      },
      {
        "title": "Conformità e certificazione",
        "paragraphs": [
          "Rispettiamo le principali normative globali sulla protezione dati, inclusi GDPR (UE), CCPA (California) e LGPD (Brasile).",
          "La nostra elaborazione pagamenti è conforme agli standard PCI DSS, garantendo la sicurezza delle informazioni di pagamento."
        ]
      }
    ],
    "ctaTitle": "Preoccupazioni per la sicurezza?",
    "ctaDesc": "Il nostro team di sicurezza è pronto a rispondere alle tue domande",
    "ctaButton": "Contatta team sicurezza",
    "navTerms": "Termini di servizio →",
    "navPrivacy": "Informativa sulla privacy →"
  },
  "gallery": {
    "tag": "Cronologia creazioni",
    "title": "Le mie creazioni",
    "subtitle": "Visualizza tutta la cronologia delle tue creazioni AI.",
    "loginRequired": "Accedi per visualizzare la cronologia delle creazioni",
    "empty": "Nessuna creazione ancora",
    "loadMore": "Carica altro",
    "filters": {
      "all": "Tutti",
      "pending": "In elaborazione",
      "finish": "Completato",
      "failed": "Fallito"
    },
    "usePrompt": "Genera con questo prompt",
    "download": "Scarica",
    "status": {
      "pending": "In elaborazione",
      "finish": "Completato",
      "failed": "Fallito"
    }
  },
  "inspiration": {
    "title": "Ispirazione",
    "subtitle": "Vedi cosa stanno costruendo i creatori con Miral — da immagini iperrealistiche a video cinematografici, ispirazione a portata di mano.",
    "filters": {
      "all": "Tutti",
      "image": "Immagine",
      "video": "Video",
      "portrait": "Ritratto",
      "landscape": "Paesaggio",
      "fantasy": "Fantastico",
      "anime": "Anime"
    }
  },
  "profile": {
    "joinTime": "Iscritto",
    "tabs": {
      "account": "Account",
      "billing": "Fatturazione",
      "privacy": "Dati e privacy"
    },
    "balance": {
      "title": "Panoramica saldo",
      "available": "Crediti disponibili"
    },
    "subscription": {
      "currentPlan": "Piano attuale",
      "status": "Stato",
      "activated": "Attivato",
      "cancelled": "Si cancella alla fine del periodo attuale",
      "pending": "In elaborazione",
      "failed": "Pagamento fallito",
      "expiryDate": "Valido fino a",
      "permanent": "Permanente",
      "upgradePlan": "Aggiorna o cambia piano",
      "cancelPlan": "Cancella abbonamento",
      "cancelNote": "Il tuo abbonamento rimane attivo fino alla fine del periodo di fatturazione attuale",
      "cancelWarning": "Il tuo abbonamento verrà cancellato. Puoi continuare a utilizzare tutte le funzionalità fino a",
      "restorePlan": "Ripristina abbonamento"
    },
    "upgrade": {
      "title": "Aggiorna",
      "desc": "Ottieni accesso illimitato e vantaggi esclusivi",
      "btn": "Vedi piani"
    },
    "billing": {
      "title": "Cronologia pagamenti",
      "subtitle": "Visualizza i tuoi record di pagamento e scarica fatture",
      "empty": "Nessun record di fatturazione ancora",
      "creditsPack": "Pacchetto crediti",
      "oneTime": "Una tantum",
      "monthly": "Mensile",
      "yearly": "Annuale",
      "refresh": "Aggiorna",
      "plan": "Piano",
      "date": "Data",
      "amount": "Importo",
      "invoice": "Fattura",
      "download": "Scarica",
      "invoiceModal": {
        "title": "Dettagli fattura",
        "orderInfo": "Informazioni ordine",
        "invoiceInfo": "Informazioni fattura",
        "plan": "Piano",
        "date": "Data pagamento",
        "amount": "Importo pagato",
        "paymentId": "ID ordine",
        "close": "Chiudi",
        "download": "Scarica fattura",
        "fullName": "Nome completo",
        "fullNamePlaceholder": "Inserisci il tuo nome completo",
        "email": "Email",
        "emailPlaceholder": "Inserisci la tua email",
        "company": "Azienda",
        "companyPlaceholder": "Nome legale azienda",
        "taxId": "Partita IVA",
        "taxIdPlaceholder": "Inserisci partita IVA",
        "addressLine1": "Indirizzo 1",
        "addressLine1Placeholder": "Indirizzo stradale",
        "addressLine2": "Indirizzo 2",
        "addressLine2Placeholder": "Appartamento, suite, ecc. (opzionale)",
        "city": "Città",
        "cityPlaceholder": "Città",
        "province": "Provincia",
        "provincePlaceholder": "Provincia",
        "postalCode": "CAP",
        "postalCodePlaceholder": "Codice postale",
        "country": "Paese",
        "countryPlaceholder": "Paese",
        "invoiceRemarks": "Note",
        "invoiceRemarksPlaceholder": "Note fattura",
        "optional": "opzionale",
        "required": "Questo campo è obbligatorio"
      }
    },
    "privacy": {
      "title": "Impostazioni privacy",
      "cardTitle": "I tuoi dati sono protetti",
      "cardSubtitle": "Il nostro impegno per la tua privacy e sicurezza dei dati",
      "item1": "I tuoi dati non vengono mai utilizzati per la formazione di modelli AI",
      "item2": "Trasmissione e archiviazione dati sono completamente crittografate",
      "item3": "Le opere generate vengono automaticamente eliminate dopo il periodo di archiviazione",
      "item4": "Nessun ciclo di feedback, nessun uso secondario di dati derivati",
      "item5": "Rispetto rigoroso delle normative sulla protezione dei dati"
    },
    "support": {
      "title": "Serve aiuto?",
      "desc": "Il nostro team di supporto è qui per aiutarti",
      "btn": "Contatta supporto",
      "note": "miral_support@miralvis.com · Risposta entro 24 ore"
    }
  },
  "payment": {
    "success": {
      "title": "Pagamento riuscito",
      "message": "Grazie per il tuo acquisto! Il tuo ordine è stato elaborato con successo e i crediti sono stati aggiunti al tuo account.",
      "goHome": "Vai alla home",
      "viewProfile": "Vedi profilo"
    },
    "cancel": {
      "title": "Pagamento cancellato",
      "message": "Il tuo pagamento è stato cancellato. Se hai domande, non esitare a contattare il nostro team di supporto.",
      "tryAgain": "Riprova",
      "goHome": "Vai alla home"
    }
  },
  "faq": {
    "categories": {
      "all": "All",
      "general": "General",
      "pricing": "Pricing",
      "models": "Models",
      "features": "Features"
    },
    "items": [
      {
        "q": "What is Miral?",
        "a": "Miral is an all-in-one AI creation platform integrating 29+ top-tier AI models, supporting image generation, video creation, music production, and professional editing tools. No need to switch between platforms - one account gives you access to all major models including FLUX, Midjourney, Sora, Veo, Kling, and more."
      },
      {
        "q": "Which AI models are supported?",
        "a": "We support 29+ top-tier AI models, including image models (FLUX 2 Max, Midjourney, Seedream, GPT-Image-1, Nano Banana, etc.), video models (Veo 3.1, Sora 2, Kling 2.6, Seedance, Wan 2.5, etc.), and AI music generation models. All models are continuously updated."
      },
      {
        "q": "How does the credit system work?",
        "a": "We use a unified credit system. Image generation starts at 2 credits, video generation at 10 credits, and music at 10 credits per track. Premium models may consume more credits. Subscribers enjoy lower credit rates and can also purchase credit packs separately."
      },
      {
        "q": "Can I generate images, videos, and music?",
        "a": "Yes! Miral supports text-to-image, image editing, style transfer, text-to-video, image-to-video, AI music creation, and more - meeting all creative needs from personal projects to commercial work."
      },
      {
        "q": "How fast is the generation?",
        "a": "Most image generation completes within 30 seconds, video generation takes about 1-6 minutes. We continuously optimize our infrastructure to ensure fast and stable generation."
      },
      {
        "q": "Can I use Miral for commercial purposes?",
        "a": "Yes. All paid plans include commercial licenses, allowing you to use generated content for commercial projects, marketing materials, social media, and more."
      },
      {
        "q": "Is API access available?",
        "a": "Yes, the Ultimate plan includes API access. Through our comprehensive API, you can integrate AI image, video, and music generation directly into your applications."
      },
      {
        "q": "Can I generate music with AI?",
        "a": "Absolutely! Our AI music generator supports various music styles. Simply describe what you want to generate original music, perfect for video soundtracks, podcast background music, and more."
      },
      {
        "q": "How do you handle data privacy and security?",
        "a": "We strictly adhere to GDPR compliance standards. All data is encrypted and not used for AI training. Users can delete their accounts and all data at any time."
      },
      {
        "q": "Can others see my work?",
        "a": "By default, your work is only visible to you. Pro and Ultimate users can enable privacy mode to ensure complete privacy."
      },
      {
        "q": "How can I delete my account and data?",
        "a": "You can request account deletion in your account settings at any time. We will delete all your data and generated content within 30 days."
      },
      {
        "q": "Can I get support if I encounter issues?",
        "a": "Of course! You can contact our support team at miral_support@miralvis.com. Pro users get priority support, and Ultimate users get dedicated support."
      }
    ]
  },
  "testimonials": {
    "items": [
      {
        "name": "Alex Chen",
        "role": "Digital Marketing Director",
        "tag": "Save 90% Time",
        "content": "Miral has become our visual content hub. Generate product images with Midjourney, create promotional videos with Veo, then edit everything in Miral - all without switching platforms."
      },
      {
        "name": "Sarah Rodriguez",
        "role": "E-commerce Owner",
        "tag": "40% Higher Conversion",
        "content": "Accessing 29+ models in one place is amazing. I use Seedream for product photos, Seedance for video ads, and the upscaling tools for catalogs. Conversion increased by 40%!"
      },
      {
        "name": "David Kim",
        "role": "Content Creator",
        "tag": "500K+ Followers",
        "content": "I create images with FLUX and Nano Banana, then turn them into viral videos with Kling and Sora. The credit system is fair - pay as you go. My followers love the diverse content!"
      },
      {
        "name": "Emma Thompson",
        "role": "Graphic Designer",
        "tag": "Professional Grade",
        "content": "As a designer, I was skeptical about AI platforms. But Miral's rich model library and precise editing tools are truly impressive - from concept sketches to final products, it's all easy."
      },
      {
        "name": "James Wilson",
        "role": "Video Producer",
        "tag": "10x Faster Workflow",
        "content": "The video models here are incredible - Veo is cinematic, Seedance is fast, and Wan's character animation is natural. All models share one credit system - saves time and money."
      },
      {
        "name": "Lisa Park",
        "role": "Creative Agency Owner",
        "tag": "Team's Top Choice",
        "content": "Our entire team has switched to Miral. API integration is smooth, and the variety of models means we always find the right tool. This is the best AI platform available."
      }
    ]
  },
  "seo": {
    "default": {
      "title": "Miral - Piattaforma AI per immagini, video e musica",
      "description": "Miral è una piattaforma tutto-in-uno che supporta i migliori modelli IA come Seedream 4, Midjourney, GPT Image, Veo 3 e Sora 2.",
      "keywords": "generatore di immagini IA, generatore di video IA, generatore di musica IA, testo in immagine, Seedream, Midjourney, Veo, Sora, Miral"
    },
    "home": { "title": "Miral: generatore di immagini, video e musica con IA", "description": "Crea immagini, video e musica di alta qualità su Miral con modelli avanzati come Seedream 5, Midjourney, Veo 3.1, Sora 2 e altri, tutti in un’unica piattaforma." },
    "pricing": { "title": "Prezzi - Miral", "description": "Miral offre prezzi flessibili. Acquista crediti, paga per uso, senza abbonamento." },
    "profile": { "title": "Profilo - Miral", "description": "Gestisci il tuo account Miral, consulta lo storico degli ordini." },
    "models": { "title": "Modelli IA - Miral", "description": "Esplora i migliori modelli IA su Miral: immagini, video e musica." },
    "music": { "title": "Generatore di musica IA - Miral", "description": "Crea musica unica da descrizioni testuali con l'IA di Miral." },
    "tools": { "title": "Strumenti immagine IA - Miral", "description": "Miral offre strumenti di elaborazione immagini IA: rimozione filigrana, sfondo, miglioramento." },
    "inspiration": { "title": "Ispirazione - Miral", "description": "Sfoglia le creazioni in evidenza della community Miral." },
    "gallery": { "title": "La mia galleria - Miral", "description": "Consulta e gestisci tutte le tue creazioni su Miral." },
    "faq": { "title": "FAQ - Miral", "description": "Domande frequenti sulla piattaforma Miral." },
    "about": {
      "title": "About Us - Miral",
      "description": "Learn about the Miral AI platform for image, video, and music creation."
    },
    "contact": {
      "title": "Contact Us - Miral",
      "description": "Contact Miral support for help and feedback."
    },
    "terms": { "title": "Termini di servizio - Miral", "description": "Termini di servizio e accordo utente di Miral." },
    "privacy": { "title": "Informativa sulla privacy - Miral", "description": "Informativa sulla privacy e protezione dei dati di Miral." },
    "trustSafety": { "title": "Fiducia e sicurezza - Miral", "description": "Politiche di fiducia e sicurezza di Miral." },
    "models": {
     "wan25": { "title": "Wan 2.5 - Modello video IA potente", "description": "Wan 2.5 offre generazione video IA di nuova generazione. Crea video realistici e fluidi con movimento e dettagli avanzati, ideale per creatori e aziende." },
      "wan26": { "title": "Wan 2.6 - Generatore video IA avanzato", "description": "Aggiorna la tua creazione video con Wan 2.6. Questo modello IA avanzato genera video ultrarealistici con movimento, dettaglio e velocità migliorati per contenuti professionali." },
      "wan22": { "title": "Wan 2.2 - Generatore video IA veloce", "description": "Wan 2.2 è un modello video IA veloce e affidabile. Genera video di alta qualità rapidamente, ideale per creatori che necessitano produzione professionale efficiente." },
      "wanAnimate": { "title": "Wan Animate - Animazione personaggio - Miral", "description": "Anima personaggi con immagine e video di riferimento tramite Alibaba Wan 2.2 Animate." },
       "veo30": { "title": "Veo 3.0 - Modello video IA leader", "description": "Veo 3.0 è un generatore video IA di prima categoria. Crea video realistici e cinematografici con IA avanzata, perfetto per creazione di contenuti professionali." },
      "veo31": { "title": "Veo 3.1 - Top generazione video IA", "description": "Veo 3.1 è un modello video IA leader per video straordinari e realistici. Crea clip cinematografiche e animazioni con qualità e velocità senza pari." },
     "kling26": { "title": "Kling 2.6 - Modello video IA premium", "description": "Kling 2.6 dà vita alla generazione video IA professionale. Genera video di alta qualità e fluidi con IA avanzata per creatori, marketer e aziende." },
      "kling25": { "title": "Kling 2.5 - Modello video IA affidabile", "description": "Kling 2.5 offre potente generazione video IA per creatori. Produce video di alta qualità con movimento fluido e dettagli, perfetto per contenuti e marketing." },
      "seedance": { "title": "Seedance AI - Generatore video IA avanzato", "description": "Genera video IA di alta qualità con Seedance AI. Crea clip, animazioni e contenuti cinematografici con modelli IA all'avanguardia per risultati professionali veloci." },
      "sora2": { "title": "Generatore video IA Sora 2 – Da testo e immagini a video | Miral", "description": "Crea video Sora 2 da testo o immagini su Miral. Provalo con crediti gratuiti e scegli 4–12 s, 720p/1080p e formato 16:9/9:16." },
      "hailuo23": { "title": "Hailuo 2.3 - Generatore video IA intelligente", "description": "Hailuo 2.3 offre generazione video IA intelligente. Crea video creativi di alta qualità con IA avanzata per creatori di contenuti e aziende." },
      "runway": { "title": "Runway - Piattaforma di creazione video IA", "description": "Runway è una piattaforma video IA leader per creatori. Modifica, genera e migliora video con potenti strumenti IA, perfetta per produzione di contenuti professionali." },
      "nanobanana": { "title": "Nano Banana - Generatore immagini IA - Miral", "description": "Genera rapidamente immagini creative con Nano Banana." },
      "seedream4": { "title": "Seedream 4 - Generatore di immagini IA", "description": "Crea immagini IA straordinarie in alta risoluzione con Seedream 4. Genera arte fotorrealistico, illustrazioni e design con IA avanzata per lavoro creativo professionale." },
      "midjourney": { "title": "Midjourney - Generatore di arte IA", "description": "Midjourney è un generatore di arte IA leader. Crea immagini e design straordinari da testo, perfetto per artisti, designer e creatori di contenuti." },
      "gptimage1": { "title": "GPT-Image-1 - Modello immagini IA OpenAI", "description": "GPT-Image-1 di OpenAI genera immagini IA di alta qualità da testo. Crea visual realistici e creativi per design, marketing e creazione di contenuti." },
      "gptimage15": { "title": "GPT Image 1.5 - OpenAI immagini IA - Miral", "description": "Genera immagini IA con OpenAI GPT Image 1.5." },
      "fluxpro11ultra": { "title": "Flux Pro 1.1 Ultra - Generatore immagini IA premium", "description": "Flux Pro 1.1 Ultra offre generazione di immagini IA ultra alta qualità. Crea immagini fotorrealistiche e dettagliate con IA avanzata per design professionale." },
      "fluxschnell": { "title": "Flux Schnell - Generatore immagini IA veloce", "description": "Flux Schnell è un generatore di immagini IA ultraveloce. Crea immagini di alta qualità rapidamente, ideale per creatori che necessitano contenuti visivi professionali veloci." },
      "flux2": {
        "title": "FLUX.2 - Generatore di immagini IA - Miral",
        "description": "Genera immagini IA professionali con FLUX.2 — 5 varianti per velocità, qualità e controllo."
      },
      "zimageturbo": {
        "title": "Z Image Turbo - Generatore di immagini IA - Miral",
        "description": "Genera immagini ad alta risoluzione con il modello Z Image Turbo."
      }
    },
    "tools": {
      "watermarkRemover": { "title": "Rimozione filigrane online gratis con IA | Miral", "description": "Rimuovi online filigrane, loghi, date, testi e bozze dalle foto con l’IA. Conserva i dettagli ed esporta risultati puliti in formato JPG, PNG o WebP." },
      "backgroundRemover": { "title": "Rimozione sfondo IA gratis online | Miral", "description": "Rimuovi gratis lo sfondo delle immagini con IA. Scontorna ritratti e prodotti, preserva capelli e bordi e crea PNG trasparenti da JPG, PNG o WebP." },
      "imageEraser": { "title": "Cancellatore immagini IA - Rimuovi oggetti dalle foto", "description": "Cancella oggetti, persone, filigrane e testo indesiderati dalle foto con l'IA. Passa il pennello sull'area e l'IA la rimuove senza soluzione di continuità, riempiendo lo spazio con contenuti naturali. Perfetto per pulire le immagini." },
      "objectRemover": { "title": "Rimuovi Oggetti IA - Rimuovi oggetti dalle foto", "description": "Rimuovi oggetti indesiderati dalle foto con l'IA. Passa il pennello sull'oggetto e l'IA lo rimuove senza soluzione di continuità, riempiendo l'area con contenuti naturali. Perfetto per pulire le tue foto." },
      "aiPersonRemover": { "title": "Rimuovi Persone IA - Rimuovi persone dalle foto", "description": "Rimuovi persone dalle foto con l'IA. Passa il pennello su qualsiasi persona e l'IA la rimuove senza soluzione di continuità, riempiendo l'area con contenuti naturali. Perfetto per rimuovere passanti e sconosciuti dalle tue foto." },
      "whiteBackground": { "title": "Sfondo Bianco IA - Sostituisci sfondo con bianco", "description": "Sostituisci automaticamente gli sfondi delle immagini con bianco usando l’IA. Ideale per foto prodotto e-commerce, foto tessera e immagini catalogo." },
      "blueBackground": { "title": "Sfondo Blu IA - Sostituisci sfondo con blu", "description": "Sostituisci automaticamente gli sfondi delle immagini con blu usando l’IA. Ideale per foto tessera, foto passaporto e documenti ufficiali." },
      "faceSwap": { "title": "Scambio viso IA - Scambia visi nelle foto", "description": "Scambia visi nelle foto con l'IA. Carica una foto target e un viso sorgente per fondere i visi in modo trasparente con risultati realistici e naturali." },
      "imageEnhancer": { "title": "Miglioratore immagini IA - Ingrandisci e migliora", "description": "Migliora e ingrandisci immagini con l'IA. Affina i dettagli, correggi sfocatura, aumenta risoluzione e ripristina foto vecchie per risultati professionali." },
      "docCropEnhance": { "title": "Ritaglio e correzione documenti online con IA | Miral", "description": "Ritaglia e correggi documenti, verifiche, compiti e libri online. Sistema inclinazione, prospettiva, pagine curve e ombre per scansioni chiare e nitide." },
      "handwrittenErase": { "title": "Rimozione scrittura IA per verifiche e compiti | Miral", "description": "Rimuovi risposte scritte a mano da verifiche, compiti e quaderni con l’IA conservando il testo stampato. Include rotazione, ritaglio e raddrizzamento." }
    },
    imageModels: {
            title: "Modelli di immagini AI - Miral",
            description: "Esplora i migliori modelli di immagini AI su Miral e genera immagini straordinarie da istruzioni di testo.",
            relatedModelsTitle: "Esplora altri modelli di immagini AI",
            demoPrompt: "Richiesta di testo",
            demoOutput: "Immagine generata",
            demoPlaceholder: "Immagine di esempio: disponibile a breve",
            promptLabel: "Crea con",
            usePrompt: "Usa questo suggerimento →",
            imagePlaceholder: "Esempio di immagine AI",
            replaceImageHint: "Generato dal prompt mostrato accanto a questa immagine",
            flux1: {
                title: "FLUX.1 Generatore di immagini AI online gratuito | Miral",
                description: "Crea immagini AI di alta qualità online con FLUX.1 utilizzando Flux Pro 1.1 Ultra o Flux Schnell. Esplora nove proporzioni, stili visivi e crediti gratuiti.",
                heroHeadline: "FLUX.1 Generatore di immagini AI",
                heroIntro: "Utilizza gratuitamente il generatore di immagini AI FLUX.1 di Black Forest Labs su Miral AI. Iscriviti per ricevere crediti gratuiti e scegli tra l'output di alta qualità di Flux Pro 1.1 Ultra e la creazione veloce e multi-stile di Flux Schnell.",
                eyebrow: "Laboratori della Foresta Nera · FLUX.1",
                sectionKicker: "FLUSSO.1",
                ctaTag: "FLUX.1 · Miral",
                badges: ["Testo in immagine", "9 Proporzioni", "Pro e Schnell", "Fotografia/Arte digitale/Anime"],
                previewLabel: "Flusso Pro 1.1 Ultra",
                previewMeta: ["1:1", "16:9", "9:16", "9 rapporti"],
                previewTitle: "Scegli tra qualità raffinata ed esplorazione creativa rapida",
                previewDesc: "Usa Pro 1.1 Ultra per immagini dettagliate o Schnell per esplorare rapidamente le direzioni fotografiche, di arte digitale e di anime.",
                keyFeaturesTitle: "Crea immagini di alta qualità con il generatore di testo in immagini FLUX.1",
                keyFeaturesIntro: "Esplora le funzionalità Flux Pro 1.1 Ultra e Flux Schnell per una comprensione immediata, velocità di output, stili visivi e proporzioni flessibili.",
                exploreTitle: "Esplora altri modelli di immagini AI",
                mainFeaturesTitle: "Caratteristiche principali di FLUX.1",
                generatedImageLabel: "Immagine generata",
                versionLabel: "Versione",
                featureLabel: "Caratteristiche principali",
                useCaseLabel: "Ideale per",
                controlsTitle: "Scegli il modello, il rapporto e lo stile visivo giusti",
                controlsIntro: "Utilizza Flux Pro 1.1 Ultra per immagini finali raffinate o Flux Schnell per un'esplorazione più rapida, quindi abbina le proporzioni e lo stile al canale desiderato.",
                galleryTitle: "Altri esempi di immagini FLUX.1",
                discussionTitle: "Domande comuni sulla selezione di FLUX.1",
                communityTitle: "Modi popolari per creare con FLUX.1",
                tutorialPrompt: "Una tranquilla libreria in serra in riva al mare all'alba, calde lampade da lettura, scaffali in rovere chiaro, morbidi riflessi sul pavimento, fotografie realistiche di interni.",
                qualityBenefits: [
                    "Renderizza materiali, illuminazione e profondità spaziale con una finitura più lucida.",
                    "Segui le istruzioni dettagliate che combinano soggetto, composizione, fotocamera e stile.",
                    "Esplora indicazioni fotografiche, artistiche digitali e anime da istruzioni di testo in chiaro."
                ],
                features: [
                    { name: "Testo FLUX.1 di alta qualità in immagine", short: "Trasforma le istruzioni scritte in immagini dettagliate e professionali.", desc: "Flux Pro 1.1 Ultra è adatto per lavorare dove i dettagli dell'immagine, i materiali, l'illuminazione e la finitura complessiva contano. Descrivere chiaramente il soggetto, la composizione, la fotocamera e lo stile aiuta a indirizzare l'immagine verso la direzione del tuo progetto.", demo: { type: 'table', rows: [
                        { prompt: "Esterno di un boutique hotel nel deserto all'ora blu, pareti in terra battuta, calda luce delle finestre, erbe autoctone, lunghe ombre, fotografia architettonica realistica.", image: require('@/assets/images/flux1/b9d1e267-bb35-4d5c-a196-fae49460749d.webp') },
                        { prompt: "Fotografia editoriale di ravioli fatti a mano su un piatto nero opaco, olio al basilico, tovagliolo di lino, luce direzionale della finestra, profondità di campo ridotta.", image: require('@/assets/images/flux1/2ab9dde4-0420-4594-b875-a8465741b767.webp') }
                    ] } },
                    { name: "Generazione veloce con Flux Schnell", short: "Crea bozze rapide, verifica le richieste ed esplora rapidamente le idee.", desc: "Flux Schnell è particolarmente adatto ai flussi di lavoro che richiedono test rapidi di composizione, stile o concetto. Genera una bozza, rivedi la direzione, quindi perfeziona la richiesta per un'altra iterazione.", prompt: "Uno stand fieristico modulare in cartone per una startup ecologica, semplici basi per prodotti, texture di carta riciclata, illuminazione espositiva brillante, layout pulito.", image: require('@/assets/images/flux1/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.webp') },
                    { name: "Nove proporzioni dell'immagine", short: "Copre formati ultra-wide, orizzontali, quadrati, verticali e alti.", desc: "Flux Pro 1.1 Ultra e Flux Schnell supportano entrambi 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 e 9:21 per banner, immagini di prodotti, contenuti social, poster e immagini mobili.", prompt: "Un osservatorio alpino panoramico 21:9 sopra un mare di nuvole, piattaforma panoramica in vetro, luce del primo mattino, piccoli escursionisti in scala, pittura opaca cinematografica.", image: require('@/assets/images/flux1/a5efd8d2-571d-406d-9a01-f30581d4ea3b.webp') },
                    { name: "Stili visivi multipli in Schnell", short: "Scegli Auto, Fotografia, Arte digitale o Anime.", desc: "Flux Schnell offre indicazioni di stile automatico, fotografico, arte digitale e anime, semplificando il passaggio tra immagini fotorealistiche, illustrate e anime senza cambiare modello.", demo: { type: 'table', rows: [
                        { prompt: "Stile fotografico: un meccanico di biciclette che aggiusta una bici da corsa vintage in un garage soleggiato, mani macchiate di grasso, riflessi cromati realistici.", image: require('@/assets/images/flux1/2b870b40-a436-42b9-980f-538e303cdfce.webp') },
                        { prompt: "Stile anime: un accogliente cat café all'interno di uno sky train, nuvole color pastello al tramonto fuori dalle finestre, personaggi espressivi, disegni dal tratto pulito.", image: require('@/assets/images/flux1/faded76c-4da1-49bb-98dc-10b8276f7da8.webp') }
                    ] } },
                    { name: "Casi d'uso creativi flessibili", short: "Crea immagini di prodotti, marketing, ritratti, concept e social.", desc: "La famiglia FLUX.1 supporta immagini raffinate di prodotti e marchi, nonché concetti rapidi di campagne, ritratti, design di ambienti e proporzioni specifiche della piattaforma.", prompt: "Immagine di lancio di sneaker sostenibili con trama di tessuto riciclato, dettagli in pizzo fluttuante, sfondo sfumato verde muschio, spazio vuoto in grassetto per il testo dell'annuncio social.", image: require('@/assets/images/flux1/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.webp') }
                ],
                showcaseKicker: "Esempi suggeriti",
                showcaseTitle: "FLUX.1 Esempi di suggerimenti per immagini AI migliori",
                showcaseIntro: "Utilizzare questi prompt FLUX.1 come punto di partenza. Descrivi chiaramente il soggetto, la composizione, l'illuminazione, la fotocamera, i materiali, la tavolozza dei colori e lo stile visivo.",
                variantsKicker: "Guida al modello",
                variantsTitle: "Flux Pro 1.1 Ultra contro Flux Schnell",
                variantsIntro: "Scegli un modello FLUX.1 in base alla qualità, velocità e controllo dello stile di cui il tuo progetto ha bisogno.",
                variants: [
                    { name: "Flusso Pro 1.1 Ultra", tag: "Alta qualità", desc: "Progettato per lavori di conversione testo-immagine dettagliati, realistici e raffinati con nove proporzioni supportate.", bestFor: "Ideale per fotografie di prodotti, immagini di eroi della campagna e immagini finali raffinate" },
                    { name: "Flusso Schnell", tag: "Veloce", desc: "Progettato per un'iterazione rapida con nove proporzioni e stili Auto, Fotografico, Arte digitale e Anime.", bestFor: "Ideale per bozze, test rapidi, contenuti social ed esplorazione rapida" }
                ],
                useCasesKicker: "Realizzato per il vero lavoro",
                useCasesTitle: "Casi d'uso popolari di FLUX.1",
                useCases: [
                    { name: "FLUX.1 per la fotografia di prodotti", desc: "Crea immagini di prodotti, scene di lifestyle e concetti visivi di e-commerce." },
                    { name: "FLUX.1 per il marketing e la pubblicità", desc: "Genera annunci social, banner di campagna e immagini di marketing del marchio." },
                    { name: "FLUX.1 per ritratti fotorealistici", desc: "Crea ritratti simili a foto con illuminazione, sfondi e composizione controllati." },
                    { name: "FLUX.1 per l'arte digitale", desc: "Usa Schnell per esplorare rapidamente l'illustrazione, il fantasy e le indicazioni artistiche digitali." },
                    { name: "FLUX.1 per immagini anime", desc: "Utilizza lo stile Schnell Anime per i personaggi e le scene degli anime." },
                    { name: "FLUX.1 per l'arte concettuale", desc: "Esplora ambienti cinematografici, scene di gioco, personaggi e mondi visivi." },
                    { name: "FLUX.1 per le immagini dei social media", desc: "Utilizza nove proporzioni per i contenuti della piattaforma orizzontale, quadrata e verticale." },
                    { name: "FLUX.1 per poster e striscioni", desc: "Scegli un rapporto adatto per eventi, promozioni e concetti di layout di pagina mobile." }
                ],
                howToKicker: "Tre semplici passaggi",
                howToTitle: "Come utilizzare gratuitamente il generatore di immagini AI FLUX.1",
                howToIntro: "Iscriviti per ricevere crediti gratuiti e utilizzare Flux Pro 1.1 Ultra o Flux Schnell online su Miral.",
                howToSteps: [
                    { title: "Inserisci una richiesta dettagliata", desc: "Descrivi il soggetto, l'ambientazione, la composizione, l'illuminazione, la fotocamera, i materiali, i colori e lo stile del target." },
                    { title: "Scegli Modello e Rapporto", desc: "Scegli Pro 1.1 Ultra per una qualità raffinata o Schnell per un'esplorazione rapida, quindi imposta le proporzioni e lo stile Schnell." },
                    { title: "Generare e perfezionare", desc: "Genera l'immagine, rivedila e scaricala oppure regola il prompt, il rapporto o lo stile per un'altra versione." }
                ],
                howToCta: "Utilizza il generatore di immagini AI FLUX.1 gratuitamente",
                faqTitle: "Domande frequenti su FLUX.1",
                faqs: [
                    { q: "Cos'è il generatore di immagini AI FLUX.1?", a: "FLUX.1 è una famiglia di modelli di generazione di immagini di Black Forest Labs. Su Miral, utilizza Flux Pro 1.1 Ultra e Flux Schnell per trasformare i suggerimenti di testo in immagini di prodotti, marketing, ritratti, anime e concept art." },
                    { q: "Posso utilizzare gratuitamente il generatore di immagini FLUX.1 AI?", a: "Sì. Iscriviti per ricevere crediti gratuiti e inizia subito a creare immagini di alta qualità con il generatore di immagini AI FLUX.1. La generazione delle immagini utilizza i crediti corrispondenti." },
                    { q: "Qual è la differenza tra Flux Pro 1.1 Ultra e Flux Schnell?", a: "Flux Pro 1.1 Ultra è adatto per immagini finali raffinate in cui i dettagli e la finitura contano. Flux Schnell è adatto per bozze veloci, test rapidi ed esplorazione multi-stile, con stili Auto, Fotografico, Arte digitale e Anime." },
                    { q: "Quali proporzioni dell'immagine supporta FLUX.1?", a: "Flux Pro 1.1 Ultra e Flux Schnell su Miral supportano 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 e 9:21, per un totale di nove proporzioni." },
                    { q: "Quali stili supporta Flux Schnell?", a: "Flux Schnell supporta Auto, Fotografia, Arte digitale e Anime per la corrispondenza automatica, immagini fotorealistiche, illustrazioni digitali e immagini di anime." },
                    { q: "Come posso utilizzare il generatore di immagini AI FLUX.1 online?", a: "Inserisci un messaggio di testo, scegli Flux Pro 1.1 Ultra o Flux Schnell e imposta le proporzioni. Con Schnell, puoi anche selezionare uno stile visivo prima di fare clic su Genera." },
                    { q: "Quali sono i migliori esempi di prompt FLUX.1?", a: "I suggerimenti FLUX.1 efficaci descrivono chiaramente il soggetto, l'ambientazione, la composizione, l'illuminazione, la fotocamera, i materiali, la tavolozza dei colori e lo stile target. Utilizza gli esempi in questa pagina come punto di partenza e adattali al tuo progetto." },
                    { q: "FLUX.1 vs FLUX.2: quale dovrei usare?", a: "Scegli FLUX.1 per risultati raffinati con Flux Pro 1.1 Ultra o una creazione veloce multi-stile con Flux Schnell. Scegli la pagina FLUX.2 su Miral quando ti servono le varianti Klein, Max, Pro e Flex." },
                    { q: "FLUX.1 vs Midjourney: quale dovrei usare?", a: "FLUX.1 è perfetto per proporzioni esplicite, il flusso di lavoro Schnell veloce o l'output Pro 1.1 Ultra raffinato. Midjourney può essere adatto agli utenti che preferiscono i suoi stili artistici, il flusso di lavoro delle immagini di riferimento e il processo creativo." }
                ],
                ctaTitle: "Usa FLUX.1 gratuitamente su Miral!",
                ctaDesc: "Iscriviti per ricevere crediti gratuiti. Scegli Flux Pro 1.1 Ultra o Flux Schnell e crea immagini con il rapporto e lo stile di cui il tuo progetto ha bisogno."
            },
            flux2: {
                title: "FLUX.2 Generatore di immagini AI online gratuito | Miral",
                description: "Crea immagini AI fotorealistiche online con FLUX.2. Scegli cinque varianti di modello per foto di prodotti, poster, opere d'arte ed elementi visivi di marketing raffinati.",
                heroHeadline: "Generatore di immagini AI FLUX.2",
                heroIntro: "Utilizza gratuitamente il generatore di immagini FLUX.2 AI di Black Forest Labs su Miral AI. Iscriviti per ricevere crediti gratuiti e creare istantaneamente immagini fotorealistiche di alta qualità, fotografie di prodotti, poster ed elementi visivi di marketing.",
                eyebrow: "Laboratori della Foresta Nera · FLUX.2",
                sectionKicker: "FLUSSO.2",
                ctaTag: "FLUX.2 · Miral",
                badges: ["Testo in immagine", "Fotorealistico", "Tipografia precisa", "Rapporti d'aspetto multipli"],
                previewLabel: "FLUSSO.2",
                previewMeta: ["1:1", "1024×1024", "PNG"],
                previewTitle: "Da una richiesta precisa a un'immagine pronta per la produzione",
                previewDesc: "Crea scatti dettagliati di prodotti, concetti di campagna, ritratti e progetti ricchi di testo in un unico flusso di lavoro ottimizzato.",
                keyFeaturesTitle: "Crea immagini professionali con il generatore di testo in immagini FLUX.2",
                keyFeaturesIntro: "Esplora le funzionalità chiave del generatore di immagini AI FLUX.2 per istruzioni precise, dettagli raffinati, output realistico e controllo visivo affidabile.",
                exploreTitle: "Esplora altri modelli di immagini AI",
                mainFeaturesTitle: "Caratteristiche principali di FLUX.2",
                generatedImageLabel: "Immagine generata",
                versionLabel: "Versione",
                featureLabel: "Caratteristiche principali",
                useCaseLabel: "Ideale per",
                controlsTitle: "Scegli la versione FLUX.2 giusta e le impostazioni di output",
                controlsIntro: "Utilizza Klein per un'iterazione rapida, Max per la massima qualità finale, Pro per flussi di lavoro di produzione o Flex per la tipografia e il controllo dei dettagli precisi.",
                galleryTitle: "Altri esempi di immagini FLUX.2",
                discussionTitle: "Domande comuni sul modello FLUX.2",
                communityTitle: "Modi popolari per creare con FLUX.2",
                tutorialPrompt: "Fotografia della campagna premium di una bottiglia di profumo traslucido color smeraldo su pietra calcarea chiara, morbida luce mattutina, rifrazione realistica del vetro, tipografia raffinata, generoso spazio negativo.",
                qualityBenefits: [
                    "Segui le istruzioni dettagliate con un maggiore controllo su soggetto, composizione, illuminazione e stile.",
                    "Crea texture realistiche, profondità e dettagli raffinati per il lavoro visivo professionale.",
                    "Gestisci poster ricchi di testo, etichette di prodotti e grafica della campagna con una tipografia più chiara."
                ],
                features: [
                    { name: "Sintesi di immagini di fascia alta", short: "Offre una maggiore aderenza immediata e qualità dell'immagine senza ulteriore latenza.", desc: "FLUX.2 migliora notevolmente l'allineamento dei prompt e supporta anche input di lunga durata come script dettagliati e descrizioni di scene. Garantisce che le immagini generate offrano una maggiore fedeltà senza compromettere la velocità, riducendo la necessità di regolazioni iterative e consentendo ai creatori di raggiungere un risultato finale più velocemente.", demo: { type: 'table', rows: [
                        { prompt: "Un paesaggio mozzafiato con colori vivaci e dettagli intricati, che mostra un tramonto su una catena montuosa.",image: require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp') },
                        { prompt: "Arte astratta per la traduzione tra linguaggi funzionali e linguaggi di basso livello." ,image: require('@/assets/images/flux2/sample.webp')},
                        { prompt: "Un headshot di un personaggio anime/cartone animato, dettagliato e ben realizzato ma sembra fatto dall'uomo." ,image: require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp')}
                    ] } },
                    { name: "Dettagli e realismo superiori", short: "Produce texture, illuminazione e profondità realistiche per immagini di livello professionale.", desc: "FLUX.2 cattura texture fini, illuminazione realistica e profondità naturale che fanno sì che le immagini generate sembrino autenticamente fotografiche. Ciò lo rende particolarmente adatto per scatti di prodotti, ritratti e immagini cinematografiche in cui la credibilità è più importante.", prompt: "Fotografia del prodotto in studio di un orologio meccanico in argento su ardesia scura, illuminazione laterale morbida, struttura realistica in metallo spazzolato, profondità di campo ridotta, riflessi sottili, composizione editoriale premium." ,image: require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp') },
                    { name: "Forte adesione immediata", short: "Segue da vicino istruzioni complesse, inclusi argomenti, stili e composizioni specifici.", desc: "FLUX.2 interpreta istruzioni stratificate e composte da più parti con una precisione impressionante, gestendo argomenti specifici, stili artistici, tavolozze di colori e istruzioni compositive in un'unica generazione. Ciò offre ai creatori un maggiore controllo e meno ripetizioni nel descrivere esattamente ciò che desiderano.", prompt: "Un tram rosso che attraversa una piovosa piazza europea al crepuscolo, tre ciclisti in primo piano, calde vetrine di un caffè sulla sinistra, cielo blu, composizione simmetrica, fotografia cinematografica.",image: require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp') },
                    { name: "Gestione avanzata della tipografia", short: "Rende il testo all'interno delle immagini con un'ortografia più pulita e una coerenza di stile.", desc: "FLUX.2 offre una generazione di testo e un controllo migliorati sulle immagini, con una coerenza più accurata dello stile dei caratteri. Ciò rende possibile produrre materiali basati su testo e segnaletica per poster, pubblicità, fumetti e grafica del marchio con molti meno artefatti.", demo: { type: 'table', rows: [
                        { prompt: "Una bellissima foto di paesaggio mistico con il testo \"FLUX 2\", bellezza sottile, che incorpora mirtilli." ,image: require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp') },
                        { prompt: "Una torta gateau della Foresta Nera con la scritta \"FLUX 2 Pro\", gustosa fotografia di cibo." ,image: require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp') }
                    ] } },
                    { name: "Generazione veloce e scalabile", short: "Scegli tra iterazione inferiore al secondo e output di massima qualità.", desc: "FLUX.2 comprende modelli Klein veloci e varianti Pro, Max e Flex focalizzate sulla produzione. Questa gamma lo rende pratico per bozze rapide, produzione di contenuti batch e risorse creative o di marketing di qualità finale.", prompt: "Una foto editoriale pulita di un flacone di profumo verde traslucido su pietra calcarea, luce soffusa del mattino, ombre tenui, estetica premium della campagna." ,image: require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp')}
                ],
                showcaseKicker: "Esempi suggeriti",
                showcaseTitle: "FLUX.2 Esempi di suggerimenti per immagini AI migliori",
                showcaseIntro: "Utilizza questi esempi di prompt FLUX.2 come punto di partenza, personalizza il soggetto, la composizione, l'illuminazione e lo stile, quindi invia il tuo prompt direttamente al generatore.",
                variantsKicker: "Guida al modello",
                variantsTitle: "Confronto tra modelli FLUX.2: Klein vs Max vs Pro vs Flex",
                variantsIntro: "Confronta FLUX.2 Klein, Max, Pro e Flex per scegliere il modello di immagine AI giusto per un'iterazione rapida, risorse di qualità finale, scala di produzione o controllo tipografico accurato.",
                variants: [
                    { name: "FLUX.2 Klein 4B / 9B", tag: "Il più veloce", desc: "Scegli FLUX.2 Klein per la generazione rapida di immagini, bozze e prototipazione rapida in grandi volumi.", bestFor: "Ideale per bozze, batch e iterazioni rapide" },
                    { name: "FLUSSO.2Max", tag: "Massima qualità", desc: "Scegli FLUX.2 Max per le risorse finali, il seguito più efficace e la generazione radicata.", bestFor: "Ideale per campagne premium e immagini hero" },
                    { name: "FLUX.2 Pro", tag: "Produzione", desc: "Scegli FLUX.2 Pro per un equilibrio di livello produttivo tra qualità dell'immagine, tempi di consegna e output scalabile.", bestFor: "Ideale per il marketing e la produzione di contenuti" },
                    { name: "FLUX.2 Flessibile", tag: "Controllo", desc: "Scegli FLUX.2 Flex per guida regolabile, tipografia, rendering del testo e conservazione di piccoli dettagli.", bestFor: "Ideale per poster, etichette e risorse di progettazione" }
                ],
                useCasesKicker: "Realizzato per il vero lavoro",
                useCasesTitle: "Casi d'uso popolari di FLUX.2",
                useCases: [
                    { name: "FLUX.2 per la fotografia di prodotti", desc: "Crea scatti di prodotti raffinati, scene di lifestyle e variazioni di immagini di e-commerce." },
                    { name: "FLUX.2 per marketing e pubblicità", desc: "Trasforma i concetti della campagna in annunci social, banner e immagini coerenti del marchio." },
                    { name: "FLUX.2 per poster e tipografia", desc: "Utilizza il rendering del testo FLUX.2 per produrre titoli, etichette, poster e grafica basata su testo più chiari." },
                    { name: "FLUX.2 per ritratti fotorealistici", desc: "Genera ritratti AI dettagliati con illuminazione, stile e composizione controllati." },
                    { name: "FLUX.2 per l'arte concettuale", desc: "Esplora rapidamente ambienti cinematografici, personaggi e direzioni visive." },
                    { name: "FLUX.2 per il design editoriale", desc: "Crea illustrazioni e copertine distintive per articoli e presentazioni." }
                ],
                howToKicker: "Tre semplici passaggi",
                howToTitle: "Come utilizzare il generatore di immagini AI FLUX.2 online",
                howToIntro: "Utilizza il generatore di immagini AI FLUX.2 online su Miral per passare da un messaggio di testo dettagliato a un'immagine generata.",
                howToSteps: [
                    { title: "Inserisci il tuo suggerimento", desc: "Descrivi il soggetto, la composizione, l'illuminazione, i colori, lo stile e l'eventuale testo che desideri venga visualizzato nell'immagine." },
                    { title: "Scegli Impostazioni FLUX.2", desc: "Apri il generatore, seleziona Klein, Max, Pro o Flex, quindi scegli la dimensione di output adatta al tuo progetto." },
                    { title: "Genera la tua immagine", desc: "Inizia la generazione, esamina il risultato e scarica l'immagine o perfeziona la richiesta per un'altra versione." }
                ],
                howToCta: "Prova il generatore di immagini AI FLUX.2",
                faqTitle: "Domande frequenti su FLUX.2",
                faqs: [
                    { q: "Cos'è FLUX.2?", a: "FLUX.2 è il modello AI text-to-image di nuova generazione di Black Forest Labs. Trasforma le istruzioni scritte in immagini dettagliate e di alta qualità ed è disponibile su Miral per arte, design, marketing e creazione visiva di prodotti direttamente nel tuo browser." },
                    { q: "Quale strumento posso utilizzare per creare fotografie di prodotti e immagini di marketing ricche di testo?", a: "FLUX.2 combina coerenza immediata, dettaglio, fotorealismo e gestione tipografica per fotografie di prodotti professionali e immagini di marketing ricche di testo che richiedono fedeltà e accuratezza." },
                    { q: "Posso utilizzare gratuitamente il generatore di immagini FLUX.2 AI?", a: "Sì. Iscriviti per ricevere crediti gratuiti e inizia subito a creare immagini di alta qualità con il generatore di immagini AI FLUX.2. La generazione delle immagini utilizza i crediti corrispondenti." },
                    { q: "Come posso utilizzare il generatore di immagini AI FLUX.2 online?", a: "Inserisci un messaggio di testo dettagliato, scegli FLUX.2 Klein, Max, Pro o Flex, seleziona una dimensione di immagine e fai clic su Genera. FLUX.2 funziona bene per materiali di marketing, fotografie di prodotti, concetti cinematografici, creativi sociali e design di poster." },
                    { q: "Quanto tempo impiega FLUX.2 per essere generato?", a: "Il tempo di generazione dipende dalla variante FLUX.2 selezionata, dalla dimensione dell'immagine e dal carico di servizio attuale. Klein è progettato per un'iterazione molto rapida, mentre Max, Pro e Flex danno priorità a diversi equilibri di qualità e controllo." },
                    { q: "Come riparare un'immagine FLUX.2 che non segue la mia richiesta?", a: "Descrivi il soggetto, l'ambientazione, la composizione, l'illuminazione, lo stile della fotocamera o artistico, i colori e qualsiasi testo richiesto in modo più esplicito. Utilizza gli esempi di prompt FLUX.2 in questa pagina come punto di partenza e personalizzali per il tuo progetto." },
                    { q: "Quale modello FLUX.2 dovrei scegliere?", a: "Scegli FLUX.2 Klein per bozze e lotti rapidi, Max per risorse finali della massima qualità, Pro per la generazione di immagini su scala di produzione o Flex quando la tipografia e il controllo accurato contano di più." },
                    { q: "FLUX.2 Max vs Pro: qual è la differenza?", a: "FLUX.2 Max dà priorità alla massima qualità, a un forte seguito immediato e alla generazione radicata. FLUX.2 Pro bilancia qualità di livello produttivo, tempi di consegna più rapidi e output scalabile per i flussi di lavoro creativi di tutti i giorni." },
                    { q: "FLUX.2 vs Midjourney: quale dovrei usare?", a: "Scegli in base al flusso di lavoro piuttosto che a un vincitore universale. FLUX.2 è particolarmente adatto per il follow-up preciso, la tipografia, le immagini dei prodotti e la produzione basata su API. Midjourney può essere adatto ai creatori che preferiscono il suo flusso di lavoro artistico distintivo e gli strumenti della community." }
                ],
                ctaTitle: "Prova FLUX.2 gratuitamente su Miral!",
                ctaDesc: "Inserisci la tua idea qui sopra e utilizza il generatore di immagini AI FLUX.2 per creare immagini dettagliate con la variante del modello che si adatta al tuo flusso di lavoro."
            },
            seedream: {
                title: "Generatore di immagini AI Seedream online gratuito | Miral",
                description: "Genera immagini AI di alta qualità online con Seedream. Ottieni una comprensione rapida e precisa, un rendering del testo chiaro e un output dettagliato 2K-4K per progetti creativi.",
                heroHeadline: "Generatore di immagini AI di Seedream",
                heroIntro: "Utilizza gratuitamente il generatore di immagini AI Seedream. Iscriviti per ricevere crediti gratuiti e creare immediatamente immagini di prodotti, poster, ritratti e immagini di marketing di alta qualità.",
                eyebrow: "Seme ByteDance · Seedream AI",
                sectionKicker: "Seedream AI",
                ctaTag: "Seedream · Miral",
                badges: ["Testo in immagine", "Comprensione dell'intento", "Uscita 2K / 3K / 4K", "Visualizzazione chiara del testo"],
                previewLabel: "Seedream AI",
                previewMeta: ["1:1", "2K / 3K / 4K", "Dimensioni personalizzate"],
                previewTitle: "Dall'intento creativo a una visione precisa e ad alta risoluzione",
                previewDesc: "Crea composizioni complesse, scatti di prodotti, ritratti e progetti ricchi di testo con dettagli raffinati e controllo immediato e affidabile.",
                keyFeaturesTitle: "Crea immagini precise con il generatore di testo e immagine AI di Seedream",
                keyFeaturesIntro: "Esplora le funzionalità AI di Seedream per una comprensione più profonda delle intenzioni, composizione complessa, output ad alta risoluzione, dettagli realistici e rendering accurato del testo attraverso la generazione di testo in immagine.",
                exploreTitle: "Esplora i modelli AI di Seedream",
                mainFeaturesTitle: "Funzionalità principali di conversione testo in immagine dell'intelligenza artificiale di Seedream",
                seedream5Desc: "Utilizza l'ultimo modello Seedream per suggerimenti precisi, realismo raffinato, rendering del testo e output ad alta risoluzione.",
                seedream4Desc: "Apri il flusso di lavoro consolidato di Seedream 4 per la creazione affidabile di testo in immagine e impostazioni di output flessibili.",
                features: [
                    { name: "Comprensione immediata e più profonda", short: "Interpreta l'intento creativo, le relazioni spaziali e le istruzioni dettagliate.", desc: "L'intelligenza artificiale di Seedream va oltre la corrispondenza di termini immediati isolati. Ragiona sulle relazioni tra soggetti, layout, attributi e contesto visivo per produrre risultati più coerenti da istruzioni testuali complesse.", demo: { type: 'table', rows: [
                        { prompt: "Uno scaffale espositivo 3x3, vista frontale, con nove oggetti diversi disposti per materiale e colore, illuminazione da studio coerente e allineamento spaziale accurato.", image: require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp') },
                        { prompt: "Foto editoriale di un orologio accanto a un lino piegato e una tazza di ceramica, composizione triangolare equilibrata, morbida luce mattutina.", image: require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp') },
                        { prompt: "Una scena di mercato cinematografica con acquirenti in primo piano, un soggetto centrale chiaro, profondità stratificata e luce calda riflessa sul pavimento bagnato.", image: require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp') }
                    ] } },
                    { name: "Controllo della composizione complessa", short: "Gestisce più argomenti, attributi e layout strutturati con maggiore coerenza.", desc: "Il generatore di immagini AI di Seedream segue istruzioni in più parti attraverso scene complesse, aiutando a preservare gli attributi, le posizioni, i colori e le relazioni degli oggetti richiesti in un'unica composizione.", prompt: "Una scena editoriale frontale con tre vasi in ceramica di forme diverse su piattaforme di pietra sfalsate, una sfera rossa dietro il vaso più alto, illuminazione laterale morbida, spaziatura equilibrata, sfondo da studio neutro.", image: require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp') },
                    { name: "Uscita 2K, 3K e 4K", short: "Seleziona una risoluzione di output in base ai dettagli e alle dimensioni di cui il tuo progetto ha bisogno.", desc: "Seedream AI supporta l'output selezionabile 2K, 3K e 4K su Miral, oltre a dimensioni di immagine personalizzate. Scegli in base alle dimensioni e al livello di dettaglio richiesto per il tuo utilizzo finale.", prompt: "Un ampio paesaggio cinematografico di una futuristica città costiera all'alba, architettura a strati, acqua riflettente, profondità atmosferica, intricati dettagli costruttivi, composizione panoramica.", image: require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp') },
                    { name: "Rendering del testo migliorato", short: "Crea testo più chiaro per poster, layout, etichette e grafica di presentazione.", desc: "Seedream AI combina il ragionamento visivo con una migliore creazione di testo, rendendolo utile per poster, grafica di presentazione, pubblicità, concetti di packaging e altri layout in cui il testo leggibile fa parte dell'immagine.", demo: { type: 'table', rows: [
                        { prompt: "Poster dell'evento minimalista con il titolo \"DESIGN FOR TOMORROW\", caratteri geometrici in grassetto, sfondo bianco, griglia con accenti verdi.", image: require('@/assets/images/seedream/0217834957232579f663fff68d336b1dca042ed755c42d2babd5a_0.webp') },
                        { prompt: "Confezione di caffè premium etichettata \"MIRAL ROAST\", note di degustazione concise, trama di carta calda, fotografia del prodotto in studio.", image: require('@/assets/images/seedream/021783495813482572fdc12977fa128088f145c73a50ff1524591_0.webp') }
                    ] } },
                    { name: "Dettagli raffinati e realismo", short: "Produce illuminazione, materiali, profondità e presentazione del prodotto convincenti.", desc: "Seedream AI rende trame raffinate e illuminazione coerente per fotografie di prodotti, ritratti, immagini editoriali e concetti cinematografici in cui la chiarezza e la struttura credibile sono importanti.", prompt: "Una foto editoriale pulita di un flacone di profumo verde traslucido su pietra calcarea, luce soffusa del mattino, ombre tenui, estetica premium della campagna.", image: require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp') }
                ],
                showcaseKicker: "Esempi suggeriti",
                showcaseTitle: "Esempi di suggerimenti AI Seedream per immagini AI migliori",
                showcaseIntro: "Utilizza questi esempi di prompt AI di Seedream come punto di partenza. Descrivi chiaramente soggetti, relazioni spaziali, testo, illuminazione e layout, quindi invia il messaggio direttamente al generatore.",
                variantsKicker: "Guida alla risoluzione",
                variantsTitle: "Guida alla risoluzione dell'intelligenza artificiale di Seedream: 2K, 3K e 4K",
                variantsIntro: "Scegli una risoluzione di output AI Seedream in base alla velocità con cui desideri eseguire l'iterazione e alla quantità di dettagli richiesti dalla risorsa finale.",
                variants: [
                    { name: "2K", tag: "Uscita standard", desc: "Una soluzione pratica per contenuti social, lavoro creativo quotidiano e layout digitali standard.", bestFor: "Ideale per i normali contenuti digitali" },
                    { name: "3K", tag: "Maggiori dettagli", desc: "Aggiunge più dettagli all'immagine e supporta layout più grandi per lavori di marketing e presentazione.", bestFor: "Ideale per risorse di marketing e presentazione" },
                    { name: "4K", tag: "Massimo dettaglio", desc: "Utilizza l'impostazione predefinita più alta quando contano texture fini, layout con testo pesante o qualità di consegna premium.", bestFor: "Ideale per campagne finali e output ad alta risoluzione" }
                ],
                useCasesKicker: "Realizzato per il vero lavoro",
                useCasesTitle: "Casi d'uso popolari dell'IA Seedream",
                useCases: [
                    { name: "Seedream AI per la fotografia di prodotti", desc: "Crea scatti di prodotti raffinati, scene di lifestyle e concetti di immagini di e-commerce." },
                    { name: "Seedream AI per il marketing", desc: "Trasforma le idee di campagne strutturate in annunci social, banner e immagini del marchio." },
                    { name: "Seedream AI per poster e testo", desc: "Produci concetti di poster, grafica di presentazione, etichette e layout basati su testo." },
                    { name: "Seedream AI per composizioni complesse", desc: "Disporre più soggetti e attributi richiesti in una struttura visiva coerente." },
                    { name: "L'intelligenza artificiale di Seedream per l'arte concettuale", desc: "Esplora ambienti cinematografici, personaggi e indicazioni visive dettagliate." },
                    { name: "Seedream AI per immagini editoriali", desc: "Crea copertine, illustrazioni, infografiche e immagini pronte per la presentazione." }
                ],
                howToKicker: "Tre semplici passaggi",
                howToTitle: "Come utilizzare gratuitamente il generatore di immagini AI Seedream online",
                howToIntro: "Iscriviti per ricevere crediti gratuiti e utilizza il generatore di immagini AI Seedream online con un messaggio chiaro e la risoluzione richiesta dal tuo progetto.",
                howToSteps: [
                    { title: "Inserisci il tuo intento creativo", desc: "Descrivi i soggetti, le relazioni spaziali, la composizione, l'illuminazione, lo stile e il testo richiesto nel modo più chiaro possibile." },
                    { title: "Scegli Risoluzione e Dimensioni", desc: "Apri il generatore e seleziona 2K, 3K, 4K o una dimensione personalizzata supportata in base all'utilizzo finale." },
                    { title: "Genera e rivedi", desc: "Inizia la generazione, rivedi la composizione e i dettagli, quindi scarica il risultato o modifica la richiesta." }
                ],
                howToCta: "Utilizza il generatore di immagini AI Seedream gratuitamente",
                faqTitle: "Domande frequenti sull'intelligenza artificiale di Seedream",
                faqs: [
                    { q: "Cos'è il generatore di immagini AI Seedream?", a: "Seedream AI è un modello di creazione di immagini intelligente del team Seed di ByteDance. Su Miral, trasforma istruzioni di testo dettagliate in immagini ad alta risoluzione per design, marketing, concetti di prodotto, poster e immagini editoriali." },
                    { q: "Quale strumento posso utilizzare per creare poster ad alta risoluzione con testo chiaro?", a: "Seedream AI combina una comprensione più profonda delle intenzioni, una composizione precisa, una migliore creazione del testo e un output selezionabile ad alta risoluzione per poster e altri layout ricchi di testo." },
                    { q: "Posso utilizzare gratuitamente il generatore di immagini AI Seedream?", a: "Sì. Iscriviti per ricevere crediti gratuiti e inizia subito a creare immagini di alta qualità con il generatore di immagini AI Seedream. La generazione delle immagini utilizza i crediti corrispondenti." },
                    { q: "Come posso utilizzare il generatore di immagini AI Seedream online?", a: "Inserisci un messaggio di testo dettagliato, scegli l'output 2K, 3K o 4K, seleziona facoltativamente una dimensione personalizzata e fai clic su Genera. Per ottenere risultati migliori, descrivi chiaramente i soggetti, le relazioni spaziali, gli attributi, l'illuminazione, il testo e il layout." },
                    { q: "Seedream AI supporta immagini 2K, 3K e 4K?", a: "Sì. Miral espone le preimpostazioni di risoluzione 2K, 3K e 4K per Seedream AI, insieme a dimensioni personalizzate supportate per diverse proporzioni ed esigenze di consegna." },
                    { q: "Come correggere le immagini Seedream con testo o composizione errati?", a: "Descrivi l'argomento, le relazioni tra gli oggetti, la composizione, l'illuminazione, i colori, lo stile e il testo richiesto in modo più esplicito. Utilizza gli esempi Seedream presenti in questa pagina come punto di partenza e indica chiaramente ogni requisito visivo." },
                    { q: "Quale risoluzione AI di Seedream dovrei scegliere?", a: "Scegli 2K per contenuti digitali standard, 3K quando i layout di marketing o presentazione richiedono maggiori dettagli e 4K quando il massimo dettaglio è importante per campagne finali di grandi dimensioni, poster o risorse di progettazione premium." },
                    { q: "Seedream AI vs Midjourney: quale dovrei usare?", a: "Seedream AI è particolarmente adatto per prompt strutturati, composizioni complesse, layout ricchi di testo e output selezionabile ad alta risoluzione in Miral. Midjourney può essere adatto ai creatori che preferiscono il suo flusso di lavoro artistico distintivo e gli strumenti della community." }
                ],
                ctaTitle: "Usa Seedream AI gratuitamente su Miral!",
                ctaDesc: "Iscriviti per ricevere crediti gratuiti. Descrivi la tua idea, scegli la risoluzione giusta e utilizza il generatore di immagini AI Seedream per creare immagini precise e ad alta risoluzione."
            },
            gptImage: {
                title: "Generatore di immagini AI di immagini GPT online gratuito | Miral",
                description: "Genera immagini AI di alta qualità online con GPT Image e GPT-Image-1.5 su Miral AI. Scegli dimensioni pratiche e livelli di qualità per poster, prodotti e ritratti.",
                heroHeadline: "Generatore di immagini AI di immagini GPT",
                heroIntro: "Utilizza gratuitamente il generatore di immagini GPT Image AI su Miral AI. Iscriviti per ricevere crediti gratuiti e creare istantaneamente immagini di prodotti, poster, ritratti ed elementi visivi di marketing di alta qualità con GPT-Image-1.5.",
                eyebrow: "OpenAI · Immagine GPT-1.5",
                sectionKicker: "Immagine GPT",
                ctaTag: "Immagine GPT · Miral",
                badges: ["Testo in immagine", "Qualità selezionabile", "Paesaggio/Ritratto/Quadrato", "Comprensione precisa e tempestiva"],
                previewLabel: "GPT-Immagine-1.5",
                previewMeta: ["1024×1024", "1536×1024", "1024×1536"],
                previewTitle: "Da un'idea scritta a un'immagine AI raffinata e pratica",
                previewDesc: "Utilizza istruzioni chiare e qualità selezionabile per creare immagini di prodotti, poster, ritratti e contenuti del marchio.",
                keyFeaturesTitle: "Crea immagini di alta qualità con il generatore di immagini AI di immagini GPT",
                keyFeaturesIntro: "Esplora le funzionalità di GPT-Image-1.5 per una rapida comprensione, controllo della qualità, dimensioni pratiche delle immagini e creazione visiva professionale.",
                features: [
                    { name: "Suggerimenti in linguaggio naturale e multisoggetto", short: "Descrivere soggetti, composizione, illuminazione, stile e relazioni visive nel linguaggio naturale.", desc: "Il generatore di immagini GPT Image AI supporta istruzioni in linguaggio naturale con più soggetti, attributi e requisiti di composizione. Inizia con un semplice suggerimento o specifica la posizione, il colore e la relazione di ciascun soggetto per creare immagini multisoggetto più coerenti.", demo: { type: 'table', rows: [
                        { prompt: "Fotografia editoriale di un prodotto di una bottiglia di profumo trasparente su un piedistallo di pietra chiara, morbida luce mattutina da sinistra, sfondo pulito, profondità di campo ridotta, estetica del marchio premium.", image: require('@/assets/images/gptImage/perfume-editorial.webp') },
                        { prompt: "Una strada cittadina piovosa di notte, tre pedoni in primo piano con ombrelli di diversi colori, un tram che passa in lontananza, neon riflessi sul pavimento bagnato, ampia composizione cinematografica.", image: require('@/assets/images/gptImage/rainy-city-tram.webp') }
                    ] } },
                    { name: "Controllo qualità GPT-Image-1.5", short: "Scegli Auto, Basso, Medio o Alto in base alle esigenze di velocità e dettaglio.", desc: "GPT-Image-1.5 offre impostazioni di qualità automatica, bassa, media e alta. Utilizza una qualità inferiore per un'esplorazione rapida e una qualità superiore per le immagini del prodotto finale, i poster o le risorse di marketing.", prompt: "Pubblicità alimentare di alta qualità di una torta di fragole su sfondo nero, consistenza cremosa, luce morbida, fotografia dettagliata del cibo, composizione commerciale.", image: require('@/assets/images/gptImage/strawberry-cake.webp') },
                    { name: "Tre dimensioni pratiche delle immagini", short: "Crea output quadrati, orizzontali e verticali.", desc: "Scegli 1024×1024, 1536×1024 o 1024×1536 per post social, banner e immagini di presentazione oppure poster con ritratti e contenuti mobili.", prompt: "Un poster di viaggio con ritratto 1024×1536 con una scogliera sul mare e un faro nella nebbia mattutina, spazio per un titolo in alto, layout editoriale moderno.", image: require('@/assets/images/gptImage/lighthouse-travel-poster.webp') },
                    { name: "Cancella testo e creazione di layout", short: "Crea poster, etichette e concetti di marchio che includano testo.", desc: "Dichiarando chiaramente il testo richiesto, il posizionamento, l'atmosfera tipografica e le relazioni di layout, GPT Image può aiutare a esplorare poster, packaging, grafica di eventi e immagini di marketing con titoli.", demo: { type: 'table', rows: [
                        { prompt: "Poster di eventi tecnologici minimalisti con il titolo \"CREATE THE FUTURE\", grassetto sans-serif, sfondo blu intenso, griglia geometrica verde, titolo chiaro centrato.", image: require('@/assets/images/gptImage/create-the-future.webp') },
                        { prompt: "Confezione di caffè premium con il testo \"MIRAL ROAST\" sul davanti, calda trama di carta marrone, etichetta pulita, fotografia del prodotto in studio.", image: require('@/assets/images/gptImage/miral-roast-package.webp') }
                    ] } },
                    { name: "Dettaglio e realismo", short: "Rendi credibili materiali, illuminazione, persone e dettagli del prodotto.", desc: "GPT Image funziona bene per la fotografia di prodotti, i ritratti, gli interni e gli elementi visivi editoriali quando la richiesta descrive chiaramente i materiali, le scelte della fotocamera, l'illuminazione e la profondità di campo.", prompt: "Ritratto editoriale ravvicinato di un artista della ceramica alla luce naturale della finestra, consistenza realistica della pelle, polvere di argilla sulle mani, sfondo del laboratorio, profondità di campo, calda fotografia editoriale.", image: require('@/assets/images/gptImage/ceramic-artist.webp') }
                ],
                showcaseKicker: "Esempi suggeriti",
                showcaseTitle: "Esempi di prompt di immagini GPT per immagini AI migliori",
                showcaseIntro: "Utilizza questi suggerimenti relativi all'immagine GPT come punto di partenza. Descrivi chiaramente il soggetto, la composizione, l'illuminazione, lo stile, i materiali e l'eventuale testo richiesto.",
                variantsKicker: "Guida alla versione",
                variantsTitle: "Immagine GPT-1.5 rispetto a Immagine GPT-1",
                variantsIntro: "Scegli una versione dell'immagine GPT in base alla necessità o meno del controllo di qualità. Entrambi supportano le pratiche dimensioni quadrata, orizzontale e verticale.",
                variants: [
                    { name: "GPT-Immagine-1.5", tag: "Consigliato", desc: "Supporta 1024×1024, 1536×1024 e 1024×1536 con opzioni di qualità automatica, bassa, media e alta.", bestFor: "Ideale per il lavoro quotidiano e professionale che richiede controllo di qualità" },
                    { name: "GPT-Immagine-1", tag: "Classico", desc: "Supporta le stesse tre pratiche dimensioni di immagine con un set di controlli più semplice.", bestFor: "Ideale per la creazione semplice e generica di testo in immagine" }
                ],
                useCasesKicker: "Realizzato per il vero lavoro",
                useCasesTitle: "Casi d'uso popolari delle immagini GPT",
                useCases: [
                    { name: "Immagine GPT per fotografie e modelli di prodotti", desc: "Crea immagini di prodotti, scene di lifestyle, modelli di prodotti e concetti visivi di e-commerce." },
                    { name: "Immagine GPT per immagini di elenchi di e-commerce", desc: "Esplora le immagini delle schede dei prodotti, la grafica delle caratteristiche, gli espositori delle confezioni e i concetti pubblicitari." },
                    { name: "Immagine GPT per annunci di marketing e social media", desc: "Crea annunci sui social media, banner di campagna, banner e-mail e immagini di marketing del marchio." },
                    { name: "Immagine GPT per UI/UX e layout del sito web", desc: "Genera concetti visivi per interfacce di app, layout di siti Web, pagine di destinazione e pagine di presentazione dei prodotti." },
                    { name: "Immagine GPT per infografiche e report visivi", desc: "Esplora concetti di layout per infografiche, report visivi e grafica di presentazione; verificare tutto il testo e i dati prima dell'uso finale." },
                    { name: "Immagine GPT per poster e confezioni di prodotti", desc: "Esplora poster, etichette di prodotti e design di imballaggi con titoli e requisiti di layout." },
                    { name: "Immagine GPT per copertine di libri e immagini di blog", desc: "Crea copertine di libri, illustrazioni editoriali, intestazioni di blog e concetti visivi editoriali." },
                    { name: "Immagine GPT per i ritratti", desc: "Crea ritratti editoriali con illuminazione, sfondi e stile controllati." },
                    { name: "Immagine GPT per i concetti dei personaggi del gioco", desc: "Esplora rapidamente personaggi del gioco, costumi, oggetti di scena e diverse direzioni artistiche." },
                    { name: "Immagine GPT per ambienti di gioco", desc: "Genera ambienti di gioco, scene cinematografiche e concetti di costruzione del mondo per l'esplorazione creativa iniziale." },
                    { name: "Immagine GPT per contenuti social", desc: "Genera immagini quadrate, orizzontali e verticali per diverse piattaforme." }
                ],
                howToKicker: "Tre semplici passaggi",
                howToTitle: "Come utilizzare gratuitamente il generatore di immagini AI di immagini GPT online",
                howToIntro: "Iscriviti per ricevere crediti gratuiti e utilizza il generatore di immagini GPT Image AI online su Miral.",
                howToSteps: [
                    { title: "Inserisci una richiesta dettagliata", desc: "Descrivi il soggetto, l'ambientazione, la composizione, l'illuminazione, lo stile, i materiali e l'eventuale testo richiesto." },
                    { title: "Scegli Taglia e Qualità", desc: "Scegli una dimensione quadrata, orizzontale o verticale e imposta la qualità GPT-Image-1.5 in base alle tue esigenze." },
                    { title: "Genera e rivedi", desc: "Inizia la generazione, rivedi e scarica l'immagine oppure modifica la richiesta e crea un'altra versione." }
                ],
                howToCta: "Utilizza gratuitamente il generatore di immagini AI di immagini GPT",
                faqTitle: "Domande frequenti sull'immagine GPT",
                faqs: [
                    { q: "Cos'è il generatore di immagini AI di GPT Image?", a: "GPT Image è la famiglia di modelli da testo a immagine per uso generico di OpenAI. Su Miral, il generatore di immagini AI di GPT Image trasforma le istruzioni scritte in immagini di alta qualità per design, marketing, concetti di prodotto, poster e contenuti social." },
                    { q: "Posso utilizzare gratuitamente il generatore di immagini GPT Image AI?", a: "Sì. Iscriviti per ricevere crediti gratuiti e inizia subito a creare immagini di alta qualità con il generatore di immagini GPT Image AI. La generazione delle immagini utilizza i crediti corrispondenti." },
                    { q: "Come posso utilizzare il generatore di immagini AI di GPT Image online?", a: "Inserisci un messaggio dettagliato e scegli 1024×1024, 1536×1024 o 1024×1536. Con GPT-Image-1.5, puoi anche selezionare la qualità automatica, bassa, media o alta prima di fare clic su Genera." },
                    { q: "Qual è la differenza tra GPT-Image-1.5 e GPT-Image-1?", a: "Entrambe le versioni supportano le stesse tre pratiche dimensioni di immagine. GPT-Image-1.5 su Miral fornisce anche il controllo di qualità automatico, basso, medio e alto, mentre GPT-Image-1 ha un set di parametri più semplice." },
                    { q: "Quali dimensioni delle immagini supporta GPT Image?", a: "Su Miral, GPT-Image-1 e GPT-Image-1.5 supportano immagini quadrate 1024×1024, orizzontali 1536×1024 e verticali 1024×1536." },
                    { q: "Quale qualità di immagine GPT dovrei scegliere?", a: "Scegli basso o medio quando testi rapidamente le istruzioni, alto per le immagini del prodotto finale, i poster o le risorse di marketing e automatico quando non sei sicuro. Le opzioni di qualità si applicano a GPT-Image-1.5." },
                    { q: "Come correggere i risultati delle immagini GPT che non corrispondono alla mia richiesta?", a: "Descrivi il soggetto, l'ambientazione, la composizione, l'illuminazione, la fotocamera, i materiali, lo stile e qualsiasi testo richiesto in modo più esplicito. Utilizza gli esempi di immagini GPT in questa pagina come punto di partenza e adattali al tuo progetto." },
                    { q: "Ho bisogno di una rapida esperienza ingegneristica per utilizzare GPT Image?", a: "No. Inizia con un semplice suggerimento in linguaggio naturale, quindi aggiungi la posizione del soggetto, la composizione, l'illuminazione, i colori, i materiali e i requisiti di testo secondo necessità. Descrizioni più chiare generalmente aiutano il risultato a corrispondere più da vicino al tuo intento creativo." },
                    { q: "Quale strumento posso utilizzare per creare immagini di prodotti e-commerce, poster e concetti di interfaccia utente?", a: "GPT Image può creare immagini di elenchi di e-commerce, modelli di prodotti, poster, concetti di UI/UX, layout di siti Web, layout di infografiche, copertine di libri, immagini di blog, banner e-mail e concetti di giochi. Verifica testo, dati, elementi del marchio e dettagli strutturali prima dell'uso finale." },
                    { q: "Immagine GPT vs Midjourney: quale dovrei usare?", a: "GPT Image è particolarmente adatto per un controllo rapido e chiaro, dimensioni pratiche delle immagini e generazione diretta del browser. Midjourney può essere adatto agli utenti che preferiscono i suoi stili artistici, il flusso di lavoro delle immagini di riferimento e il processo creativo." }
                ],
                ctaTitle: "Usa l'immagine GPT gratuitamente su Miral!",
                ctaDesc: "Iscriviti per ricevere crediti gratuiti. Descrivi la tua idea, scegli una dimensione e una qualità e utilizza il generatore di immagini GPT Image AI per creare immagini di alta qualità."
            },
            qwenImage2Pro: {
                title: "Generatore di immagini AI Qwen Image 2.0 Pro online gratuito | Miral",
                description: "Crea immagini AI online con Qwen Image 2.0 Pro. Utilizza suggerimenti negativi, miglioramento dei suggerimenti, proporzioni flessibili e genera fino a quattro immagini per esecuzione.",
                heroHeadline: "Generatore di immagini AI Qwen Image 2.0 Pro",
                heroIntro: "Utilizza gratuitamente il generatore di immagini Qwen Image 2.0 Pro AI su Miral AI. Iscriviti per ricevere crediti gratuiti e creare rapidamente immagini di alta qualità con suggerimenti negativi, miglioramento immediato e proporzioni flessibili.",
                eyebrow: "Alibaba Tongyi Qwen · Qwen-Image-2.0-Pro",
                sectionKicker: "Qwen Immagine 2.0 Pro",
                ctaTag: "Qwen Immagine 2.0 Pro · Miral",
                badges: ["Testo in immagine", "Richiesta negativa", "Miglioramento immediato", "1-4 Immagini/Esegui", "Rapporti d'aspetto flessibili"],
                previewLabel: "Qwen Immagine 2.0 Pro",
                previewMeta: ["1:1", "2048×2048", "Fino a 1-4 immagini"],
                previewTitle: "Da un suggerimento preciso con esclusioni a immagini raffinate",
                previewDesc: "Combina suggerimenti positivi con suggerimenti negativi e migliora i suggerimenti per generare più immagini sul target in un'unica esecuzione.",
                keyFeaturesTitle: "Crea immagini precise con il generatore di testo in immagini Qwen Image 2.0 Pro",
                keyFeaturesIntro: "Esplora le principali funzionalità del generatore di immagini AI di Qwen Image 2.0 Pro per il controllo accurato, i suggerimenti negativi, il miglioramento dei prompt, l'output batch e le proporzioni flessibili.",
                mainFeaturesTitle: "Funzionalità chiave di Qwen Image 2.0 Pro",
                promptLabel: "Suggerimento positivo",
                negativePromptLabel: "Richiesta negativa",
                shortPromptLabel: "Breve suggerimento",
                negativePromptFallback: "scarsa chiarezza, dettagli distorti, composizione disordinata",
                features: [
                    { name: "Controllo prompt negativo", short: "Descrivi cosa escludere per risultati più puliti e in linea con gli obiettivi.", desc: "Il generatore di immagini AI Qwen Image 2.0 Pro supporta un prompt negativo dedicato, così puoi dire al modello cosa evitare, come scarsa chiarezza, mani deformate o composizione disordinata. Ciò ti offre un controllo più preciso sull'immagine finale e riduce la necessità di riavvolgere ripetutamente.", demo: { type: 'table', rows: [
                        { prompt: "Una foto di prodotto premium di una bottiglia di vetro per la cura della pelle su pietra bagnata, luce soffusa del mattino, sfondo pulito. (Negativo: sfondo disordinato, bassa risoluzione, riflessi deformati.)", image: require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp') },
                        { prompt: "Un ritratto di una giovane donna nella luce autunnale, struttura naturale della pelle, profondità di campo. (Negativo: pelle eccessivamente levigata, aspetto ceroso, colori troppo saturi.)", image: require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp') }
                    ] } },
                    { name: "Miglioramento immediato", short: "Facoltativamente, espandi un breve messaggio in dettagli più ricchi.", desc: "Attiva il miglioramento dei prompt e Qwen Image 2.0 Pro arricchirà automaticamente un breve prompt con dettagli aggiuntivi prima della generazione. Ciò aiuta i suggerimenti dei non esperti a produrre immagini più complete e vivide senza riscrittura manuale.", demo: { type: 'table', rows: [
                        { prompt: "Un accogliente angolo lettura vicino a una finestra piovosa.", image: require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp') },
                        { prompt: "Un leggio in legno accanto a una finestra coperta dalla pioggia di notte, una calda lampada da lavoro che illumina un libro aperto e un tè fumante, interni tranquilli e accoglienti.", image: require('@/assets/images/qwenImage2Pro/qwen-enhance-rainy-desk.webp') }
                    ] } },
                    { name: "Genera 1-4 immagini contemporaneamente", short: "Produci più varianti in un'unica esecuzione.", desc: "Qwen Image 2.0 Pro può generare fino a quattro immagini per richiesta, così puoi confrontare le variazioni di un concetto, angolo o stile fianco a fianco e scegliere quella migliore. Ciò accelera l'esplorazione creativa per il marketing e le immagini dei prodotti.", prompt: "Una lampada da tavolo minimalista in ceramica su un tavolino in noce, interni caldi da sera, parete color crema, ombre morbide, fotografia di prodotti scandinavi.", image: require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp') },
                    { name: "Rapporti d'aspetto flessibili", short: "Scegli formato orizzontale, verticale, quadrato o personalizzato.", desc: "Scegli tra proporzioni già pronte come 2688×1536 orizzontale, 1536×2688 verticale, 2048×2048 quadrato e 2368×1728/1728×2368, oppure inserisci una dimensione personalizzata da 512×512 a 2048×2048. Ciò rende il generatore di testo in immagini di Qwen Image 2.0 Pro adatto allo stesso modo per banner, poster, post social e miniature quadrate.", prompt: "Uno scatto cinematografico di un ampio paesaggio di una scogliera costiera nell'ora d'oro, nuvole drammatiche, dettagli rocciosi raffinati, 2688×1536.", image: require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp') },
                    { name: "Dettagli raffinati e realismo", short: "Renderizza texture, illuminazione e profondità realistiche.", desc: "Qwen Image 2.0 Pro produce texture fini, illuminazione realistica e profondità naturale, rendendolo una soluzione perfetta per la fotografia di prodotti, i ritratti e le immagini editoriali in cui la credibilità è importante.", prompt: "Ritratto editoriale ravvicinato di un anziano artista ceramista in un laboratorio illuminato dal sole, struttura naturale della pelle, polvere di argilla sulle mani, luce calda della finestra, profondità di campo ridotta.", image: require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp') }
                ],
                showcaseKicker: "Esempi suggeriti",
                showcaseTitle: "Qwen Image 2.0 Pro Esempi di suggerimenti per immagini AI migliori",
                showcaseIntro: "Utilizzare questi esempi di prompt di Qwen Image 2.0 Pro come punto di partenza. Accoppia ogni prompt positivo con un prompt negativo per rimuovere gli elementi indesiderati, quindi invialo direttamente al generatore.",
                useCasesKicker: "Realizzato per il vero lavoro",
                useCasesTitle: "Casi d'uso popolari di Qwen Image 2.0 Pro",
                useCases: [
                    { name: "Qwen Image 2.0 Pro per la fotografia di prodotti", desc: "Crea scatti di prodotti puliti con sfondi controllati utilizzando suggerimenti negativi per rimuovere il disordine." },
                    { name: "Qwen Immagine 2.0 Pro per il marketing", desc: "Genera concetti di campagna, annunci social e banner con più proporzioni." },
                    { name: "Qwen Image 2.0 Pro per poster e tipografia", desc: "Produci layout di poster e progetti ricchi di testo con titoli ed etichette chiari." },
                    { name: "Qwen Image 2.0 Pro per ritratti", desc: "Genera ritratti dettagliati con texture della pelle naturale utilizzando suggerimenti negativi per evitare artefatti." },
                    { name: "Qwen Image 2.0 Pro per l'arte concettuale", desc: "Esplora personaggi, ambienti e direzioni visive con 1-4 variazioni per corsa." },
                    { name: "Qwen Image 2.0 Pro per l'e-commerce", desc: "Produci più varianti di immagini per inserzioni e annunci in un'unica generazione." }
                ],
                howToKicker: "Tre semplici passaggi",
                howToTitle: "Come utilizzare il generatore di immagini AI Qwen Image 2.0 Pro online",
                howToIntro: "Utilizza il generatore di immagini AI Qwen Image 2.0 Pro online su Miral con suggerimenti positivi, suggerimenti negativi e controlli di output flessibili.",
                howToSteps: [
                    { title: "Inserisci il tuo prompt principale", desc: "Descrivi il soggetto, la scena, la composizione, l'illuminazione, lo stile e i dettagli visivi desiderati." },
                    { title: "Configura i controlli di generazione", desc: "Aggiungi un messaggio negativo se necessario, abilita il miglioramento del messaggio, scegli la dimensione e seleziona da una a quattro immagini." },
                    { title: "Genera e confronta", desc: "Inizia la generazione, confronta le varianti restituite e scarica l'immagine che meglio corrisponde al tuo intento." }
                ],
                howToCta: "Prova il generatore di immagini AI Qwen Image 2.0 Pro",
                faqTitle: "Domande frequenti su Qwen Image 2.0 Pro",
                faqs: [
                    { q: "Cos'è il generatore di immagini AI Qwen Image 2.0 Pro?", a: "Qwen Image 2.0 Pro è il modello testo-immagine Tongyi Qwen di Alibaba. Il generatore di immagini AI Qwen Image 2.0 Pro trasforma le istruzioni scritte in immagini dettagliate e di alta qualità ed è disponibile su Miral per arte, design, marketing e creazione visiva di prodotti direttamente nel tuo browser." },
                    { q: "Quale strumento posso utilizzare per creare più varianti dell'immagine del prodotto con suggerimenti negativi?", a: "Qwen Image 2.0 Pro fornisce un prompt negativo dedicato, un miglioramento opzionale del prompt, 1-4 immagini per esecuzione e proporzioni flessibili per variazioni visive di fotografia di prodotto, marketing e e-commerce." },
                    { q: "Posso utilizzare gratuitamente il generatore di immagini AI Qwen Image 2.0 Pro?", a: "Sì. Iscriviti per ricevere crediti gratuiti e inizia subito a creare immagini di alta qualità con il generatore di immagini AI Qwen Image 2.0 Pro. La generazione delle immagini utilizza i crediti corrispondenti." },
                    { q: "Come posso utilizzare il generatore di immagini AI Qwen Image 2.0 Pro online?", a: "Inserisci un messaggio di testo dettagliato, facoltativamente aggiungi un messaggio negativo che descriva cosa evitare, attiva il miglioramento del messaggio se necessario, scegli un formato o una dimensione personalizzata, imposta il numero di immagini da generare (1-4) e fai clic su Genera. Qwen Image 2.0 Pro funziona bene per materiali di marketing, fotografie di prodotti, ritratti e design di poster." },
                    { q: "Come correggere gli elementi indesiderati nei risultati di Qwen Image 2.0 Pro?", a: "Aggiungi un messaggio negativo che descriva gli elementi che non desideri, come scarsa chiarezza, mani deformate o uno sfondo disordinato. Qwen Image 2.0 Pro lo utilizza per allontanare la generazione da questi risultati." },
                    { q: "Quante immagini può generare Qwen Image 2.0 Pro contemporaneamente?", a: "Qwen Image 2.0 Pro può generare fino a 4 immagini in un'unica richiesta (n = da 1 a 4), in modo da poter confrontare le variazioni di un concetto, angolo o stile e scegliere quella migliore." },
                    { q: "Quali dimensioni e proporzioni supporta Qwen Image 2.0 Pro?", a: "Su Miral, Qwen Image 2.0 Pro offre rapporti già pronti come 2688×1536, 1536×2688, 2048×2048, 2368×1728 e 1728×2368, oltre a una dimensione personalizzata da 512×512 fino a 2048×2048. Copre output orizzontali, verticali e quadrati per banner, poster, post social e miniature." },
                    { q: "Quali sono i migliori esempi di prompt di Qwen Image 2.0 Pro?", a: "I suggerimenti efficaci di Qwen Image 2.0 Pro descrivono chiaramente il soggetto, l'ambientazione, la composizione, l'illuminazione e lo stile, quindi associano un messaggio positivo a un messaggio negativo per rimuovere i dettagli indesiderati. Utilizza gli esempi di prompt di Qwen Image 2.0 Pro in questa pagina come punto di partenza e personalizzali per il tuo progetto." },
                    { q: "Qwen Image 2.0 Pro vs Midjourney: quale dovrei usare?", a: "Scegli in base al flusso di lavoro piuttosto che a un vincitore universale. Qwen Image 2.0 Pro è la soluzione ideale quando sono necessari suggerimenti negativi espliciti, miglioramento dei suggerimenti, 1-4 immagini per esecuzione e proporzioni flessibili in un generatore basato su browser su Miral. Midjourney può essere adatto ai creatori che preferiscono il suo flusso di lavoro artistico distintivo e gli strumenti della community." }
                ],
                ctaTitle: "Prova Qwen Image 2.0 Pro gratuitamente su Miral!",
                ctaDesc: "Inserisci la tua idea qui sopra e utilizza il generatore di immagini AI Qwen Image 2.0 Pro con controlli opzionali per creare variazioni precise dell'immagine."
            },
            stableDiffusion: {
                title: "Generatore di immagini AI Stable Diffusion 3.5 online gratuito | Miral",
                description: "Genera immagini AI online con Stable Diffusion 3.5. Utilizza suggerimenti negativi, proporzioni preimpostate e dimensioni personalizzate da 512 a 2048 pixel su Miral.",
                heroHeadline: "Generatore di immagini AI a diffusione stabile 3.5",
                heroIntro: "Utilizza gratuitamente il generatore di immagini AI Stable Diffusion 3.5 su Miral AI. Iscriviti per ricevere crediti gratuiti e creare rapidamente immagini di alta qualità con istruzioni dettagliate, istruzioni negative e dimensioni flessibili.",
                eyebrow: "Stabilità AI · Diffusione stabile 3.5",
                sectionKicker: "Diffusione stabile 3.5",
                ctaTag: "Diffusione stabile 3.5 · Miral",
                badges: ["Testo in immagine", "Richiesta negativa", "Rapporti d'aspetto flessibili", "Dimensioni personalizzate"],
                previewLabel: "Diffusione stabile 3.5",
                previewMeta: ["1:1", "512-2048", "Multipli di 64"],
                previewTitle: "Da un suggerimento dettagliato a un'immagine controllata e raffinata",
                previewDesc: "Abbina suggerimenti positivi a suggerimenti negativi e scegli le proporzioni giuste per indirizzare Stable Diffusion 3.5 verso immagini pulite e mirate.",
                keyFeaturesTitle: "Crea immagini controllate con il generatore di testo in immagini Stable Diffusion 3.5",
                keyFeaturesIntro: "Esplora le principali funzionalità del generatore di immagini AI di Stable Diffusion 3.5 per suggerimenti negativi, proporzioni flessibili, dimensioni personalizzate e comprensione dettagliata dei suggerimenti.",
                exploreTitle: "Esplora altri modelli di immagini AI",
                mainFeaturesTitle: "Caratteristiche principali di Stable Diffusion 3.5",
                generatedImageLabel: "Immagine generata",
                versionLabel: "Controllo",
                featureLabel: "Cosa cambia",
                useCaseLabel: "Ideale per",
                variantsTitle: "Controlli di uscita a diffusione stabile 3.5",
                variantsIntro: "Combina il modello Stable Diffusion 3.5 con proporzioni preimpostate o dimensioni personalizzate esatte in base al layout finale di cui hai bisogno.",
                variants: [
                    { name: "Diffusione stabile 3.5", desc: "Generazione dettagliata di testo in immagine con controllo rapido positivo e negativo.", bestFor: "Immagini di prodotti, ritratti, concept art e immagini di marketing." },
                    { name: "Rapporti d'aspetto preimpostati", desc: "Dimensioni di output orizzontali, verticali e quadrate già pronte.", bestFor: "Post social, banner, poster e miniature." },
                    { name: "Dimensioni immagine personalizzate", desc: "Larghezza e altezza esatte da 512 a 2048 in multipli di 64.", bestFor: "Slot di layout e progetti che richiedono dimensioni in pixel precise." }
                ],
                controlsTitle: "Scegli i controlli di richiesta e le dimensioni dell'immagine corretti",
                controlsIntro: "Utilizza un messaggio negativo per ridurre i dettagli indesiderati, quindi seleziona un rapporto preimpostato o inserisci dimensioni personalizzate per il canale desiderato.",
                galleryTitle: "Esempi di immagini 3.5 con diffusione più stabile",
                discussionTitle: "Domande sulla diffusione stabile comune 3.5",
                communityTitle: "Modi più diffusi per creare con la diffusione stabile 3.5",
                tutorialPrompt: "Fotografia editoriale del prodotto di un altoparlante scultoreo in ceramica su pietra chiara, morbida luce mattutina della finestra, struttura realistica, composizione equilibrata, ombre sottili, sfondo pulito.",
                qualityBenefits: [
                    "Utilizza suggerimenti negativi per ridurre il disordine, i dettagli non corretti e gli stili visivi indesiderati.",
                    "Segui descrizioni stratificate del soggetto, della composizione, dell'illuminazione, dei materiali e dell'atmosfera.",
                    "Crea immagini orizzontali, verticali e quadrate con preimpostazioni o dimensioni personalizzate precise."
                ],
                features: [
                    { name: "Controllo prompt negativo", short: "Descrivi cosa escludere per risultati più puliti e in linea con gli obiettivi.", desc: "Il generatore di immagini AI di Stable Diffusion 3.5 supporta un prompt negativo dedicato, così puoi dire al modello cosa evitare, come scarsa chiarezza, mani deformate o uno sfondo disordinato. Ciò ti offre un controllo più preciso sull'immagine finale e riduce la necessità di riavvolgere ripetutamente.", demo: { type: 'table', rows: [
                        { prompt: "Una foto di prodotto premium di un vaso in ceramica nera opaca su un piedistallo in marmo, luce soffusa da studio, sfondo pulito. (Negativo: sfondo disordinato, bassa risoluzione, riflessi deformati.)", image: require('@/assets/images/stableDiffusion/1783501013638.webp') },
                        { prompt: "Un ritratto di un giovane nella luce morbida della finestra, nella struttura naturale della pelle, nella profondità di campo. (Negativo: pelle eccessivamente levigata, aspetto ceroso, colori troppo saturi.)", image: require('@/assets/images/stableDiffusion/1783501332038.webp') }
                    ] } },
                    { name: "Rapporti d'aspetto flessibili", short: "Scegli orizzontale, verticale, quadrato o una dimensione personalizzata.", desc: "Scegli tra proporzioni già pronte come 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536 e 1536×1536, oppure inserisci una dimensione personalizzata da 512×512 a 2048×2048. Ciò rende il generatore di testo in immagini Stable Diffusion 3.5 adatto allo stesso modo a banner, poster, post social e miniature quadrate.", prompt: "Uno scatto cinematografico di un ampio paesaggio di una scogliera costiera nell'ora d'oro, nuvole drammatiche, dettagli rocciosi raffinati, 1536×896.", image: require('@/assets/images/stableDiffusion/1783501396803.webp') },
                    { name: "Dimensioni immagine personalizzate", short: "Imposta le dimensioni esatte dei pixel per un output preciso.", desc: "Quando una preimpostazione non si adatta, passa a una dimensione personalizzata e inserisci qualsiasi larghezza e altezza da 512 a 2048 in multipli di 64. Ciò ti consente di abbinare un layout, uno slot banner o un aspetto di stampa specifici senza ritaglio manuale.", prompt: "Uno sfondo per poster minimalista con una composizione geometrica centrata, sfumatura blu intenso, grana sottile, 1280×1280.", image: require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp') },
                    { name: "Comprensione rapida e dettagliata", short: "Segue descrizioni stratificate di soggetto, luce e stile.", desc: "Stable Diffusion 3.5 legge le istruzioni di testo a più livelli e riproduce il soggetto, l'ambientazione, l'illuminazione e l'atmosfera che descrivi. Combina un chiaro suggerimento positivo con un suggerimento negativo per avvicinare il risultato al tuo intento in meno tentativi.", demo: { type: 'table', rows: [
                        { prompt: "Foto editoriale di prodotto di un orologio da polso accanto a biancheria piegata e una tazza di ceramica, composizione triangolare equilibrata, morbida luce mattutina.", image: require('@/assets/images/stableDiffusion/1783501741652.webp') },
                        { prompt: "Un accogliente angolo lettura accanto a una finestra piovosa, la luce calda di una lampada, libri impilati, una coperta strutturata, un'atmosfera cinematografica.", image: require('@/assets/images/stableDiffusion/1783501817217.webp') }
                    ] } },
                    { name: "Dettagli raffinati e realismo", short: "Rendi credibili illuminazione, materiali e profondità.", desc: "Stable Diffusion 3.5 produce texture fini, illuminazione realistica e profondità naturale, rendendo il generatore di immagini AI Stable Diffusion 3.5 una soluzione perfetta per fotografie di prodotti, ritratti, concept art e immagini editoriali in cui la credibilità è importante.", prompt: "Ritratto editoriale ravvicinato di un anziano artista ceramista in un laboratorio illuminato dal sole, struttura naturale della pelle, polvere di argilla sulle mani, luce calda della finestra, profondità di campo ridotta.", image: require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp') }
                ],
                showcaseKicker: "Esempi suggeriti",
                showcaseTitle: "Diffusione stabile 3.5 Esempi di suggerimenti per immagini AI migliori",
                showcaseIntro: "Utilizzare questi esempi di prompt di Stable Diffusion 3.5 come punto di partenza. Descrivi chiaramente il soggetto, la composizione, l'illuminazione e lo stile, abbina ogni suggerimento a un suggerimento negativo, quindi invialo direttamente al generatore.",
                useCasesKicker: "Realizzato per il vero lavoro",
                useCasesTitle: "Casi d'uso popolari di Stable Diffusion 3.5",
                useCases: [
                    { name: "Diffusione stabile 3.5 per la fotografia di prodotti", desc: "Crea scatti di prodotti puliti con sfondi controllati utilizzando suggerimenti negativi per rimuovere il disordine." },
                    { name: "Diffusione Stabile 3.5 per il Marketing", desc: "Genera concetti di campagna, annunci social e banner con più proporzioni." },
                    { name: "Diffusione stabile 3.5 per poster e layout", desc: "Produci sfondi per poster e immagini pronte per il layout in dimensioni pixel personalizzate." },
                    { name: "Diffusione stabile 3.5 per ritratti", desc: "Genera ritratti dettagliati con texture della pelle naturale, utilizzando suggerimenti negativi per evitare artefatti." },
                    { name: "Diffusione stabile 3.5 per Concept Art", desc: "Esplora personaggi, ambienti e indicazioni visive con istruzioni a più livelli." },
                    { name: "Diffusione stabile 3.5 per contenuti social", desc: "Crea immagini quadrate, verticali e orizzontali dimensionate per diverse piattaforme social." }
                ],
                howToKicker: "Tre semplici passaggi",
                howToTitle: "Come utilizzare il generatore di immagini AI Stable Diffusion 3.5 online",
                howToIntro: "Utilizza il generatore di immagini AI Stable Diffusion 3.5 online su Miral con un messaggio chiaro, un messaggio negativo e le proporzioni di cui ha bisogno il tuo progetto.",
                howToSteps: [
                    { title: "Inserisci il tuo prompt principale", desc: "Descrivi il soggetto, la scena, la composizione, l'illuminazione, lo stile e i dettagli visivi desiderati." },
                    { title: "Configura i controlli di generazione", desc: "Aggiungi un messaggio negativo se necessario, quindi scegli una proporzione già pronta o inserisci una dimensione personalizzata." },
                    { title: "Genera e rivedi", desc: "Inizia la generazione, esamina il risultato e scarica l'immagine o modifica la richiesta per un altro passaggio." }
                ],
                howToCta: "Prova il generatore di immagini AI Stable Diffusion 3.5",
                faqTitle: "Domande frequenti sulla diffusione stabile 3.5",
                faqs: [
                    { q: "Cos'è il generatore di immagini AI Stable Diffusion 3.5?", a: "Stable Diffusion 3.5 è un modello da testo a immagine di Stability AI. Il generatore di immagini AI Stable Diffusion 3.5 trasforma le istruzioni scritte in immagini dettagliate ed è disponibile su Miral per arte, design, marketing e creazione visiva di prodotti direttamente nel tuo browser." },
                    { q: "Quale strumento posso utilizzare per creare immagini di dimensioni personalizzate con suggerimenti negativi?", a: "Stable Diffusion 3.5 offre un prompt negativo dedicato, proporzioni già pronte e dimensioni personalizzate da 512 a 2048 per fotografie di prodotti, immagini di marketing, ritratti e concept art." },
                    { q: "Posso utilizzare gratuitamente il generatore di immagini AI Stable Diffusion 3.5?", a: "Sì. Iscriviti per ricevere crediti gratuiti e inizia subito a creare immagini di alta qualità con il generatore di immagini AI Stable Diffusion 3.5. La generazione delle immagini utilizza i crediti corrispondenti." },
                    { q: "Come posso utilizzare il generatore di immagini AI Stable Diffusion 3.5 online?", a: "Inserisci un messaggio di testo dettagliato, facoltativamente aggiungi un messaggio negativo che descriva cosa evitare, scegli una proporzione già pronta o inserisci una dimensione personalizzata e fai clic su Genera. Stable Diffusion 3.5 funziona bene per materiali di marketing, fotografie di prodotti, ritratti e layout di poster." },
                    { q: "Come correggere i dettagli indesiderati o deformati nelle immagini Stable Diffusion 3.5?", a: "Aggiungi un messaggio negativo che descriva gli elementi che non desideri, come scarsa chiarezza, mani deformate o uno sfondo disordinato. Stable Diffusion 3.5 lo utilizza per allontanare la generazione da questi risultati." },
                    { q: "Quali dimensioni e proporzioni supporta Stable Diffusion 3.5?", a: "Su Miral, Stable Diffusion 3.5 offre rapporti già pronti come 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536 e 1536×1536, oltre a una dimensione personalizzata da Da 512×512 fino a 2048×2048 in multipli di 64. Copre output orizzontali, verticali e quadrati per banner, poster, post social e miniature." },
                    { q: "Quali sono i migliori esempi di prompt di Stable Diffusion 3.5?", a: "I suggerimenti efficaci di Stable Diffusion 3.5 descrivono chiaramente il soggetto, l'ambientazione, la composizione, l'illuminazione e lo stile, quindi abbinano un messaggio positivo a un messaggio negativo per rimuovere i dettagli indesiderati. Utilizza gli esempi di prompt di Stable Diffusion 3.5 in questa pagina come punto di partenza e personalizzali per il tuo progetto." },
                    { q: "Stable Diffusion 3.5 vs Midjourney: quale dovrei usare?", a: "Scegli in base al flusso di lavoro piuttosto che a un vincitore universale. Stable Diffusion 3.5 è una soluzione perfetta quando hai bisogno di suggerimenti negativi espliciti, proporzioni già pronte e dimensioni di pixel personalizzate in un generatore basato su browser su Miral. Midjourney può essere adatto ai creatori che preferiscono il suo flusso di lavoro artistico distintivo e gli strumenti della community." }
                ],
                ctaTitle: "Prova gratuitamente Stable Diffusion 3.5 su Miral!",
                ctaDesc: "Inserisci la tua idea qui sopra e utilizza il generatore di immagini AI Stable Diffusion 3.5 con suggerimenti negativi e dimensioni flessibili per creare immagini controllate."
            },
            zImageTurbo: {
                title: "Z Image Turbo Generatore di immagini AI online gratuito | Miral",
                description: "Crea immagini AI di alta qualità online con Z Image Turbo. Estendi le istruzioni, scegli proporzioni flessibili, imposta dimensioni personalizzate e controlla i seed su Miral.",
                heroHeadline: "Generatore di immagini Z Image Turbo AI",
                heroIntro: "Utilizza gratuitamente il generatore di immagini Z Image Turbo AI su Miral AI. Iscriviti per ricevere crediti gratuiti e creare rapidamente immagini di alta qualità con estensione rapida, proporzioni flessibili e controllo seed.",
                eyebrow: "Z Immagine Turbo",
                sectionKicker: "Z Immagine Turbo",
                ctaTag: "Z Immagine Turbo · Miral",
                badges: ["Testo in immagine", "Proroga immediata", "Rapporti d'aspetto flessibili", "Dimensioni personalizzate", "Controllo dei semi"],
                previewLabel: "Z Immagine Turbo",
                previewMeta: ["1:1", "512-2048", "Controllo dei semi"],
                previewTitle: "Da un breve messaggio a un'immagine raffinata e ad alta risoluzione",
                previewDesc: "Lascia che un'estensione rapida arricchisca una breve idea, scegli le giuste proporzioni e riutilizza un seme per mantenere uno stile coerente tra le immagini.",
                keyFeaturesTitle: "Crea immagini raffinate con il generatore di testo in immagini Z Image Turbo",
                keyFeaturesIntro: "Esplora le funzionalità chiave del generatore di immagini AI Z Image Turbo per un'estensione rapida, proporzioni flessibili, dimensioni personalizzate e coerenza basata sui seed.",
                exploreTitle: "Esplora altri modelli di immagini AI",
                mainFeaturesTitle: "Caratteristiche principali di Z Image Turbo",
                generatedImageLabel: "Immagine generata",
                versionLabel: "Controllo",
                featureLabel: "Cosa cambia",
                useCaseLabel: "Ideale per",
                variantsTitle: "Controlli per la creazione di Z Image Turbo",
                variantsIntro: "Combina estensione rapida, dimensioni flessibili e controllo seed in base alla quantità di dettagli e coerenza visiva di cui il tuo progetto ha bisogno.",
                variants: [
                    { name: "Z Immagine Turbo", desc: "Generazione rapida di testo in immagine con output dettagliato ad alta risoluzione.", bestFor: "Immagini di prodotti, ritratti, concept art e immagini di marketing." },
                    { name: "Proroga immediata", desc: "Arricchisce automaticamente i brevi suggerimenti con ulteriori dettagli visivi.", bestFor: "Trasformare idee rapide in istruzioni di generazione più complete." },
                    { name: "Controllo dei semi", desc: "Riutilizza lo stesso seme iniziale mentre perfezioni altre impostazioni.", bestFor: "Mantenere uno stile coordinato tra varianti di immagini o campagne." }
                ],
                controlsTitle: "Scegli le giuste impostazioni di prompt, dimensione e seed",
                controlsIntro: "Abilita l'estensione tempestiva quando un'idea necessita di maggiori dettagli, scegli le dimensioni di output previste e riutilizza un seme quando la coerenza visiva è importante.",
                galleryTitle: "Altri esempi di immagini Z Image Turbo",
                discussionTitle: "Domande comuni su Z Image Turbo",
                communityTitle: "Modi popolari per creare con Z Image Turbo",
                tutorialPrompt: "Uno scooter elettrico compatto esposto in un luminoso studio architettonico, pavimento in cemento chiaro, lucernario morbido, fotografia del prodotto raffinata, composizione equilibrata, materiali realistici.",
                qualityBenefits: [
                    "Espandi le idee brevi in suggerimenti più ricchi senza riscrivere manualmente ogni dettaglio visivo.",
                    "Scegli orizzontale, verticale, quadrata o dimensioni personalizzate precise per il canale finale.",
                    "Riutilizza un seme per mantenere l'illuminazione, la tavolozza e la composizione più coerenti tra le iterazioni."
                ],
                features: [
                    { name: "Proroga immediata", short: "Facoltativamente, espandi un breve messaggio in dettagli più ricchi.", desc: "Attiva l'estensione del prompt e Z Image Turbo arricchirà automaticamente un breve prompt con dettagli aggiuntivi prima della generazione. Ciò aiuta i suggerimenti brevi o semplici a produrre immagini più complete e vivide senza riscrittura manuale.", demo: { type: 'table', rows: [
                        { prompt: "Una serra di vetro piena di piante tropicali sulla superficie di Marte.", image: require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp') },
                        { prompt: "Una piccola panetteria artigianale ricavata all'interno di un vagone ferroviario d'epoca.", image: require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp') }
                    ] } },
                    { name: "Rapporti d'aspetto flessibili", short: "Scegli orizzontale, verticale, quadrato o una dimensione personalizzata.", desc: "Scegli tra proporzioni già pronte come 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 e 1536×1536, oppure inserisci una dimensione personalizzata da 512×512 a 2048×2048. Ciò rende il generatore di testo in immagini Z Image Turbo adatto anche a banner, poster, post social e miniature quadrate.", prompt: "Una veduta aerea ultra-ampia di un mercato notturno di Tokyo sotto la pioggia, lanterne di carta luminose, bancarelle di cibo affollate, strade riflettenti, atmosfera cinematografica, 1536×864.", image: require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp') },
                    { name: "Dimensioni immagine personalizzate", short: "Imposta le dimensioni esatte dei pixel per un output preciso.", desc: "Quando una preimpostazione non si adatta, passa a una dimensione personalizzata e inserisci qualsiasi larghezza e altezza da 512 a 2048. Ciò ti consente di abbinare un layout, uno slot banner o un aspetto di stampa specifici senza ritaglio manuale.", prompt: "Un poster verticale per una mostra botanica, tipografia arancione di grandi dimensioni, rare foglie tropicali, calda trama della carta bianco sporco, griglia editoriale precisa, 1152×1728.", image: require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp') },
                    { name: "Controllo del seme per coerenza", short: "Riutilizza un seme per mantenere uno stile stabile tra le immagini.", desc: "Imposta un seed fisso (da 0 a 2147483647) e il generatore di immagini Z Image Turbo AI si appoggerà allo stesso punto di partenza durante le esecuzioni, rendendo più semplice mantenere un aspetto coerente mentre perfezioni il prompt. Lascia il seme a 0 per ottenere ogni volta un risultato nuovo e casuale.", prompt: "Una campagna coordinata per la cura della pelle con tre flaconi di vetro smerigliato su pietra verde pallido, luce soffusa e diffusa, accenti di eucalipto: riutilizza lo stesso seme per preservare l'illuminazione, la tavolozza e la composizione in tutta la serie di prodotti.", image: require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp') },
                    { name: "Dettagli raffinati e realismo", short: "Rendi credibili illuminazione, materiali e profondità.", desc: "Z Image Turbo produce trame fini, illuminazione realistica e profondità naturale, rendendolo una soluzione perfetta per la fotografia di prodotti, i ritratti, i concept art e le immagini editoriali in cui la credibilità è importante.", prompt: "Primo piano documentario di un liutaio che scolpisce un ponte in acero in un laboratorio tranquillo, trucioli di legno pregiato, utensili manuali usurati, struttura naturale della pelle, luce morbida dalla finestra a nord, profondità di campo ridotta.", image: require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp') }
                ],
                showcaseKicker: "Esempi suggeriti",
                showcaseTitle: "Esempi di prompt Z Image Turbo per immagini AI migliori",
                showcaseIntro: "Utilizza questi esempi di prompt di Z Image Turbo come punto di partenza. Descrivi chiaramente il soggetto, la composizione, l'illuminazione e lo stile, opzionalmente abilita l'estensione rapida, quindi invialo direttamente al generatore.",
                useCasesKicker: "Realizzato per il vero lavoro",
                useCasesTitle: "Casi d'uso popolari di Z Image Turbo",
                useCases: [
                    { name: "Z Image Turbo per la fotografia di prodotti", desc: "Crea scatti di prodotti puliti con sfondi controllati e un seme fisso per un aspetto coerente." },
                    { name: "Z Image Turbo per il marketing", desc: "Genera concetti di campagna, annunci social e banner con più proporzioni." },
                    { name: "Z Image Turbo per poster e layout", desc: "Produci sfondi per poster e immagini pronte per il layout in dimensioni pixel personalizzate." },
                    { name: "Z Image Turbo per ritratti", desc: "Genera ritratti dettagliati con texture naturale della pelle e illuminazione credibile." },
                    { name: "Z Image Turbo per concept art", desc: "Esplora personaggi, ambienti e indicazioni visive con istruzioni a più livelli." },
                    { name: "Z Image Turbo per contenuti social", desc: "Crea immagini quadrate, verticali e orizzontali dimensionate per diverse piattaforme social." }
                ],
                howToKicker: "Tre semplici passaggi",
                howToTitle: "Come utilizzare il generatore di immagini AI Z Image Turbo online",
                howToIntro: "Utilizza il generatore di immagini Z Image Turbo AI online su Miral con un prompt chiaro, un'estensione prompt opzionale e le proporzioni necessarie per il tuo progetto.",
                howToSteps: [
                    { title: "Inserisci il tuo prompt principale", desc: "Descrivi il soggetto, la scena, la composizione, l'illuminazione, lo stile e i dettagli visivi desiderati." },
                    { title: "Configura i controlli di generazione", desc: "Facoltativamente, abilita l'estensione della richiesta, scegli proporzioni già pronte o inserisci una dimensione personalizzata e imposta un seme se desideri coerenza." },
                    { title: "Genera e rivedi", desc: "Inizia la generazione, esamina il risultato e scarica l'immagine o modifica la richiesta per un altro passaggio." }
                ],
                howToCta: "Prova il generatore di immagini Z Image Turbo AI",
                faqTitle: "Domande frequenti su Z Image Turbo",
                faqs: [
                    { q: "Cos'è il generatore di immagini Z Image Turbo AI?", a: "Z Image Turbo è un modello da testo a immagine per la generazione di immagini ad alta risoluzione. Il generatore di immagini Z Image Turbo AI trasforma le istruzioni scritte in immagini dettagliate ed è disponibile su Miral per arte, design, marketing e creazione visiva di prodotti direttamente nel tuo browser." },
                    { q: "Quale strumento posso utilizzare per creare una serie coerente di immagini di prodotto?", a: "Z Image Turbo combina estensione rapida, dimensioni flessibili delle immagini e controllo seed per creare una serie coerente di fotografie di prodotti o immagini di marketing." },
                    { q: "Posso utilizzare gratuitamente il generatore di immagini Z Image Turbo AI?", a: "Sì. Iscriviti per ricevere crediti gratuiti e inizia subito a creare immagini di alta qualità con il generatore di immagini AI Z Image Turbo. La generazione delle immagini utilizza i crediti corrispondenti." },
                    { q: "Come posso utilizzare il generatore di immagini Z Image Turbo AI online?", a: "Inserisci un messaggio di testo dettagliato, facoltativamente attiva l'estensione del messaggio, scegli proporzioni già pronte o inserisci una dimensione personalizzata, imposta un seme se desideri un aspetto coerente e fai clic su Genera. Z Image Turbo funziona bene per materiali di marketing, fotografie di prodotti, ritratti e layout di poster." },
                    { q: "Cos'è l'estensione rapida in Z Image Turbo?", a: "L'estensione del prompt è un interruttore opzionale che consente a Z Image Turbo di arricchire automaticamente un prompt breve o semplice con dettagli aggiuntivi prima della generazione. Ciò aiuta i suggerimenti dei non esperti a produrre immagini più complete e vivide senza riscrittura manuale." },
                    { q: "Come correggere i risultati incoerenti in Z Image Turbo?", a: "Riutilizza lo stesso seme perfezionando altri parametri per mantenere uno stile coerente tra le immagini. Lascia il seme su 0 solo quando desideri ogni volta un risultato fresco e casuale." },
                    { q: "Quali dimensioni e proporzioni supporta Z Image Turbo?", a: "Su Miral, Z Image Turbo offre rapporti già pronti come 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 e 1536×1536, oltre a una dimensione personalizzata da 512×512 fino a 2048×2048. Copre output orizzontali, verticali e quadrati per banner, poster, post social e miniature." },
                    { q: "Quali sono i migliori esempi di prompt di Z Image Turbo?", a: "I suggerimenti efficaci di Z Image Turbo descrivono chiaramente il soggetto, l'ambientazione, la composizione, l'illuminazione e lo stile. Per idee brevi, abilitare l'estensione del prompt in modo che il modello possa arricchire automaticamente il prompt. Utilizza gli esempi di prompt Z Image Turbo in questa pagina come punto di partenza e personalizzali per il tuo progetto." }
                ],
                ctaTitle: "Prova Z Image Turbo gratuitamente su Miral!",
                ctaDesc: "Inserisci la tua idea qui sopra e utilizza il generatore di immagini Z Image Turbo AI con estensione rapida, dimensioni flessibili e controllo seed per creare immagini raffinate."
            },
            midjourney: {
                title: "Generatore di immagini AI di metà viaggio online gratuito | Miral",
                description: "Crea arte AI online con Midjourney su Miral AI. Scegli stili realistici o anime, guida i risultati con immagini di riferimento e trasforma i suggerimenti di testo in immagini vivide.",
                heroHeadline: "Generatore di immagini AI di metà viaggio",
                heroIntro: "Utilizza gratuitamente il generatore di immagini Midjourney AI su Miral AI. Iscriviti per ricevere crediti gratuiti e creare istantaneamente immagini di alta qualità con stili Realistico o Anime e guida opzionale alle immagini di riferimento.",
                eyebrow: "A metà viaggio",
                sectionKicker: "A metà viaggio",
                ctaTag: "Metà viaggio · Miral",
                badges: ["Testo in immagine", "Stili realistici e anime", "Guida all'immagine di riferimento", "Direzione Artistica"],
                previewLabel: "A metà viaggio",
                previewMeta: ["Realistico", "Anime", "Fino a 5 referenze"],
                previewTitle: "Da un suggerimento vivido a un'immagine cinematografica, diretta dall'arte",
                previewDesc: "Scegli uno stile, descrivi l'atmosfera e l'illuminazione e lascia che Midjourney modelli l'aspetto artistico del tuo concept, poster o personaggio.",
                keyFeaturesTitle: "Crea immagini dirette dall'arte con il generatore di immagini da testo a metà viaggio",
                keyFeaturesIntro: "Esplora le funzionalità chiave del generatore di immagini AI di Midjourney per il cambio di stile, la guida delle immagini di riferimento e una ricca direzione artistica.",
                features: [
                    { name: "Stili realistici e anime", short: "Cambia lo stile visivo con un solo tocco.", desc: "Il generatore di immagini AI di Midjourney su Miral espone due stili già pronti: Realistico e Anime. Scegli Realistico per dettagli fotografici, luce naturale e texture realistiche oppure Anime per linee stilizzate, colori vivaci e un tocco di disegnato a mano. Lo stile viene scelto sul pannello, in modo che il tuo suggerimento possa concentrarsi sulla scena stessa.", demo: { type: 'table', rows: [
                        { prompt: "Un viaggiatore solitario in piedi sul bordo di una cresta montuosa nebbiosa all'alba, luce volumetrica, campo lungo cinematografico, tessuto pregiato e dettagli rocciosi.", image: require('@/assets/images/midjourney/1783505533006329.webp') },
                        { prompt: "Una giovane spadaccina determinata su un tetto al crepuscolo, capelli fluenti, lanterne luminose, linee anime espressive, cel shading vibrante.", image: require('@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp') }
                    ] } },
                    { name: "Guida all'immagine di riferimento", short: "Carica fino a cinque immagini per orientare il look.", desc: "Guida il generatore di immagini AI di Midjourney con un massimo di cinque immagini di riferimento (PNG, JPG, JPEG o WebP). Usali per trasferire una tavolozza di colori, l'aspetto del personaggio, la forma del prodotto o l'estetica generale in modo che il risultato sia più vicino a una direzione di riferimento piuttosto che al solo testo.", prompt: "Una foto di prodotto premium di un vaso in ceramica nera opaca su un piedistallo di marmo, luce soffusa da studio, sfondo pulito, in linea con l'atmosfera e la tavolozza dei riferimenti caricati.", image: require('@/assets/images/midjourney/1783506116812275.webp') },
                    { name: "Illuminazione e atmosfera cinematografica", short: "Rendi la luce, l'atmosfera e la profondità drammatiche.", desc: "Midjourney è noto per l'illuminazione e l'atmosfera artistica. Descrivi l'ora d'oro, il bagliore del neon, la nebbia, la luce di contorno o il lume di candela e il modello si appoggia a un look cinematografico che si adatta a poster, illustrazioni chiave e immagini concettuali.", demo: { type: 'table', rows: [
                        { prompt: "Un vicolo al neon bagnato di pioggia di notte, pozzanghere riflettenti, bokeh morbido da segnali distanti, atmosfera cinematografica lunatica, un'unica figura con un ombrello.", image: require('@/assets/images/midjourney/1783506281563151.webp') },
                        { prompt: "Un ritratto dell'ora d'oro di un musicista su un tetto, retroilluminazione calda, riflesso dell'obiettivo, profondità di campo ridotta, grana della pellicola.", image: require('@/assets/images/midjourney/1783506420066100.webp') }
                    ] } },
                    { name: "Personaggio e arte concettuale", short: "Costruisci personaggi e mondi espressivi.", desc: "Il generatore di testo e immagine di Midjourney è particolarmente adatto per il design dei personaggi, le scene fantasy e i concept art. Descrivi la posa, l'abito, l'espressione e l'ambientazione di un personaggio, scegli uno stile e ripeti fino a quando il look non ottiene.", prompt: "Un alchimista errante con un mantello da viaggio a strati, che trasporta una lanterna di ottone e fiale luminose, un antico sentiero nel bosco, luce screziata, intricati dettagli del costume.", image: require('@/assets/images/midjourney/1783506547640511.webp') },
                    { name: "Manifesti e arte editoriale", short: "Produci layout sorprendenti e immagini chiave.", desc: "Dalle illustrazioni chiave della campagna alle illustrazioni editoriali, Midjourney dà vita a composizioni audaci e a un'estetica raffinata. Abbina un soggetto focale chiaro a uno stato d'animo descritto e lascia che il modello fornisca immagini dirette dall'arte per il marketing e l'uso editoriale.", prompt: "Un'audace key visual della campagna di un colibrì che volteggia sopra un luminoso fiore tropicale, tonalità gioiello saturate, spazio negativo pulito, illuminazione da studio ad alto contrasto.", image: require('@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp') }
                ],
                showcaseKicker: "Esempi suggeriti",
                showcaseTitle: "Esempi di suggerimenti di metà viaggio per immagini AI migliori",
                showcaseIntro: "Utilizzare questi esempi di prompt di metà viaggio come punto di partenza. Descrivi il soggetto, l'atmosfera, l'illuminazione e lo stile della scena, quindi scegli Realistico o Anime sul pannello e invialo al generatore.",
                useCasesKicker: "Realizzato per il vero lavoro",
                useCasesTitle: "Casi d'uso popolari di metà viaggio",
                useCases: [
                    { name: "Metà viaggio per Concept Art", desc: "Costruisci personaggi, mondi fantastici e direzioni visive con luci e atmosfere dirette dall'arte." },
                    { name: "A metà viaggio per illustrazioni chiave e poster", desc: "Crea immagini chiave, poster e illustrazioni editoriali per campagne audaci con un aspetto raffinato." },
                    { name: "Metà del viaggio per le immagini del prodotto e del marchio", desc: "Dai forma a concetti di prodotto premium e immagini di marchio, guidati da immagini di riferimento per coerenza." },
                    { name: "Metà viaggio per ritratti", desc: "Genera ritratti cinematografici con luce naturale, grana della pellicola o ombreggiature anime stilizzate." },
                    { name: "Midjourney per anime e illustrazione", desc: "Passa allo stile Anime per linee espressive, colori vivaci e personaggi disegnati a mano." },
                    { name: "Viaggio di metà per i contenuti social", desc: "Produci immagini straordinarie e condivisibili per feed, miniature e post social creativi." }
                ],
                howToKicker: "Tre semplici passaggi",
                howToTitle: "Come utilizzare il generatore di immagini AI di Midjourney online",
                howToIntro: "Utilizza il generatore di immagini AI di Midjourney online su Miral con un suggerimento vivido, uno stile scelto e immagini di riferimento opzionali.",
                howToSteps: [
                    { title: "Descrivi la tua scena", desc: "Scrivi un messaggio vivido che copra l'argomento, l'ambientazione, l'atmosfera, l'illuminazione e l'aspetto artistico che desideri." },
                    { title: "Scegli Stile e Riferimenti", desc: "Scegli Realistico o Anime nel pannello e, facoltativamente, carica fino a cinque immagini di riferimento per guidare il look." },
                    { title: "Generare e perfezionare", desc: "Inizia la generazione, esamina il risultato e scarica l'immagine o modifica la richiesta e i riferimenti per un altro passaggio." }
                ],
                howToCta: "Prova il generatore di immagini AI di metà viaggio",
                faqTitle: "Domande frequenti su Midjourney",
                faqs: [
                    { q: "Cos'è il generatore di immagini AI di Midjourney?", a: "Midjourney è un modello testo-immagine ampiamente utilizzato, noto per le sue immagini cinematografiche dirette dall'arte. Su Miral, il generatore di immagini AI Midjourney trasforma i suggerimenti scritti in immagini sorprendenti per concept art, key visual, poster e lavori editoriali direttamente nel tuo browser." },
                    { q: "Quale strumento posso utilizzare per creare concept art cinematografici con immagini di riferimento?", a: "Midjourney combina una ricca direzione artistica, illuminazione drammatica, stili realistici e anime e una guida alle immagini di riferimento per concept art cinematografici, immagini chiave e immagini del marchio." },
                    { q: "Posso utilizzare gratuitamente il generatore di immagini AI di Midjourney?", a: "Sì. Iscriviti per ricevere crediti gratuiti e inizia subito a creare immagini di alta qualità con il generatore di immagini AI di Midjourney. La generazione delle immagini utilizza i crediti corrispondenti." },
                    { q: "Come posso utilizzare il generatore di immagini AI di Midjourney online?", a: "Inserisci un messaggio di testo vivido che descriva il soggetto, l'atmosfera, l'illuminazione e lo stile, scegli Realistico o Anime sul pannello, facoltativamente carica fino a cinque immagini di riferimento e fai clic su Genera. Midjourney funziona bene per concept art, key visual, poster, ritratti e illustrazioni editoriali." },
                    { q: "Qual è la differenza tra lo stile Realistico e quello Anime?", a: "Il realistico si appoggia ai dettagli fotografici, alla luce naturale e alle trame realistiche, mentre l'anime preferisce linee stilizzate, colori vivaci e un aspetto disegnato a mano. Scegli lo stile sul pannello, in modo che il tuo suggerimento possa concentrarsi sulla scena stessa." },
                    { q: "Come correggere le immagini di Midjourney che non corrispondono al mio riferimento?", a: "Carica fino a cinque immagini di riferimento chiare (PNG, JPG, JPEG o WebP) e descrivi quale tavolozza di colori, aspetto del personaggio, forma del prodotto o estetica generale dovrebbe seguire il risultato." },
                    { q: "Quali sono i migliori esempi di suggerimenti di metà viaggio?", a: "I suggerimenti efficaci di metà viaggio descrivono in dettaglio il soggetto, l'ambientazione, l'atmosfera, l'illuminazione e l'aspetto artistico, quindi abbinano il suggerimento allo stile giusto sul pannello. Utilizza gli esempi di prompt di metà viaggio in questa pagina come punto di partenza e adattali al tuo progetto." },
                    { q: "Midjourney vs Stable Diffusion 3.5: quale dovrei usare?", a: "Scegli in base al flusso di lavoro piuttosto che a un vincitore universale. Midjourney è particolarmente adatto per concetti artistici, illuminazione cinematografica e immagini guidate da riferimenti con stili realistici e anime già pronti su Miral. Stable Diffusion 3.5 può essere adatto ai creatori che necessitano di suggerimenti negativi espliciti e proporzioni flessibili con dimensioni personalizzate." }
                ],
                ctaTitle: "Prova Midjourney gratuitamente su Miral!",
                ctaDesc: "Inserisci la tua idea qui sopra e utilizza il generatore di immagini AI di Midjourney con stili Realistici o Anime e una guida alle immagini di riferimento per creare immagini dirette dall'arte."
            }
        }
  }
}
